webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

// AFTER SSL const basePath = 'http://62.72.58.202:1337'
var basePath = 'https://api.dutasaranakonstruksi.com';

module.exports.currencyFormat = function (value) {
  if (value === undefined || value === null) {
    return 'Rp 0';
  }
  return 'Rp ' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};

module.exports.getImage = function (imageName, section) {
  if (imageName === undefined || imageName === '' || imageName === null || section === undefined || section === '' || section === null) {
    return __webpack_require__(59);
  }
  var defImage = __webpack_require__(60);
  var image;
  if (section === 'projects') {
    try {
      image = __webpack_require__(219)("./" + imageName);
    } catch (err) {
      image = defImage;
    }
  } else if (section === 'clients') {
    try {
      image = __webpack_require__(220)("./" + imageName);
    } catch (err) {
      image = defImage;
    }
  } else if (section === 'products') {
    try {
      image = __webpack_require__(221)("./" + imageName);
    } catch (err) {
      image = defImage;
    }
  } else if (section === 'banner') {
    try {
      image = __webpack_require__(222)("./" + imageName);
    } catch (err) {
      image = defImage;
    }
  } else if (section === 'url') {
    image = basePath + imageName;
  }
  return image;
};

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// require('material-design-lite')


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      isLoading: false,
      subscribeEmail: '',
      showNavigation: false,
      windowWidth: 0,
      windowHeight: 0,
      email: '',
      type: 'full'
    };
  },

  methods: {
    findAllContents: function findAllContents() {
      var _this = this;

      this.isLoading = true;
      this.$store.dispatch('findAllContents', {
        success: function success(res) {},
        fail: function fail() {
          _this.toast('Could not get contents. Try again later.', 'error', 'error_outline');
        }
      }).then(function () {
        _this.isLoading = false;
      }).catch(function (err) {
        console.error('error: ' + err);
      });
    },
    getWindowWidth: function getWindowWidth(event) {
      this.windowWidth = document.documentElement.clientWidth;
    },
    getWindowHeight: function getWindowHeight(event) {
      this.windowHeight = document.documentElement.clientHeight;
    },
    goToHomepage: function goToHomepage() {
      this.$router.push('/homepage');
      this.$data.showNavigation = false;
    },
    goToAbout: function goToAbout() {
      this.$router.push('/about');
      this.$data.showNavigation = false;
    },
    goToService: function goToService() {
      this.$router.push('/service');
      this.$data.showNavigation = false;
    },
    goToProjects: function goToProjects() {
      this.$router.push('/projects');
      this.$data.showNavigation = false;
    },
    goToProducts: function goToProducts() {
      this.$router.push('/products');
      this.$data.showNavigation = false;
    },
    goToContact: function goToContact() {
      this.$router.push('/contact');
      this.$data.showNavigation = false;
    },
    goToDashboard: function goToDashboard() {
      this.$router.push('/dashboard');
      this.$data.showNavigation = false;
    },
    goToDClients: function goToDClients() {
      this.$router.push('/dclients');
      this.$data.showNavigation = false;
    },
    goToDProjects: function goToDProjects() {
      this.$router.push('/dprojects');
      this.$data.showNavigation = false;
    },
    goToDProducts: function goToDProducts() {
      this.$router.push('/dproducts');
      this.$data.showNavigation = false;
    },
    goToAllContactForms: function goToAllContactForms() {
      this.$router.push('/inquiries');
      this.$data.showNavigation = false;
    },
    goToAllSubscribers: function goToAllSubscribers() {
      this.$router.push('/subscribers');
      this.$data.showNavigation = false;
    },
    goToComposeEmail: function goToComposeEmail() {
      this.$router.push('/composeemail');
      this.$data.showNavigation = false;
    },
    goToSettings: function goToSettings() {
      this.$router.push('/settings');
      this.$data.showNavigation = false;
    },
    goToLogin: function goToLogin() {
      this.$router.push('/login');
      this.$data.showNavigation = false;
    },
    goToLogout: function goToLogout() {
      this.$cookies.remove('uses');
      this.$cookies.remove('a');
      this.toast('Logged out succesfully.', 'success', 'check');
      this.$data.showNavigation = false;
      this.$router.push('/homepage');
    },
    resetEmailForm: function resetEmailForm() {
      this.$data.subscribeEmail = '';
    },
    validateEmailForm: function validateEmailForm() {
      if (this.$data.subscribeEmail !== '' && this.$data.subscribeEmail !== undefined && this.$data.subscribeEmail.trim() !== '') {
        return true;
      } else {
        return false;
      }
    },
    subscribe: function subscribe() {
      var _this2 = this;

      if (this.validateEmailForm()) {
        this.$store.dispatch('subscribe', {
          data: {
            email: this.$data.subscribeEmail
            // success: (res) => {
            //   console.log('success')
            //   this.toast(this.$data.email + ' subscribed!', 'success', 'check')
            //   this.resetEmailForm()
            // },
            // fail: (res) => {
            //   this.toast('Something went wrong. Try again later.', 'error', 'error_outline')
            // }
          } }).then(function () {
          _this2.isLoading = false;
          _this2.toast(_this2.$data.subscribeEmail + ' subscribed!', 'success', 'check');
          _this2.resetEmailForm();
        }).catch(function (err) {
          console.error('error: ' + err);
        });
      } else {
        this.toast('Invalid email address.', 'error', 'error_outline');
      }
    },
    findContentById: function findContentById(id) {
      var _this3 = this;

      this.$data.isLoading = true;
      this.$store.dispatch('findContentById', {
        data: {
          id: id
        },
        success: function success() {},
        fail: function fail() {
          _this3.toast('Something went wrong. Try again later.', 'error', 'error_outline');
        }
      }).then(function () {
        _this3.$data.isLoading = false;
      }).catch(function (err) {
        console.error('error: ' + err);
      });
    },
    toast: function toast(msg, type, icon) {
      this.$toasted.show(msg, {
        theme: 'bubble',
        position: 'top-center',
        fullWidth: true,
        type: type,
        icon: icon,
        duration: 2000
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['aboutUsFooter', 'subscribeFooter', 'socialMediaFooter']), {
    title: function title() {
      switch (this.$route.path) {
        case '/homepage':
          return 'Homepage';
        case '/about':
          return 'About';
        case '/service':
          return 'Service';
        case '/projects':
          return 'Projects';
        case '/products':
          return 'Products';
        case '/contact':
          return 'Contact';
        case '/dashboard':
          return 'Dashboard';
        case '/dclients':
          return 'Clients';
        case '/dprojects':
          return 'Projects';
        case '/dproducts':
          return 'Products';
        case '/settings':
          return 'Settings';
        case '/login':
          return 'Login';
        case '/logout':
          return 'Logout';
        default:
          return 'Homepage';
      }
    },
    showHamburgerMenu: function showHamburgerMenu() {
      if (this.$data.windowWidth > 900) {
        return false;
      } else {
        return true;
      }
    },
    isOffice: function isOffice() {
      if (this.$route.path === '/dashboard' || this.$route.path === '/dclients' || this.$route.path === '/addclient' || this.$route.path === '/dprojects' || this.$route.path === '/addproject' || this.$route.path === '/dproducts' || this.$route.path === '/addproduct' || this.$route.path.includes('/editproduct') || this.$route.path === '/inquiries' || this.$route.path === '/contactforms' || this.$route.path === '/subscribers' || this.$route.path === '/composeemail' || this.$route.path === '/settings') {
        return true;
      } else {
        return false;
      }
    }
  }),
  mounted: function mounted() {
    this.$nextTick(function () {
      window.addEventListener('resize', this.getWindowWidth);
      window.addEventListener('resize', this.getWindowHeight);

      this.getWindowWidth();
      this.getWindowHeight();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.getWindowWidth);
    window.removeEventListener('resize', this.getWindowHeight);
  },
  created: function created() {
    this.findAllContents();
    // this.findContentById('aboutUsFooter')
    // this.findContentById('subscribeFooter')
    // this.findContentById('socialMediaFooter')
  }
});

/***/ }),
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 55 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAh1BMVEVHcEz///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////9NFUgUAAAALHRSTlMAzO8atBCqhFsr9jPpx/jxBg3ZQwHPwtL6ezZWaS/mlWEJIY51nRSjJ6K7sixs9EIAAADcSURBVDjL7ZDJDoIwGIT7F1ukBQWs4r7vzvs/nxQ4CBQTEo/OoUw6X0hnGKvL82kEqxtzaq2AMCMihasrX0D5x8JF8Bz5BHxZWTcww4p9AYyH1FiTBFpnrj8McbKfvQIAdWgDZ6zz86BGLykfE8cTfAzz84gn61AJBBi4wnij9aUCZlrrwLQaWtmW98JhV88TcCnlLrFt/dzJ+bYOCEzrFyr8PZAJIeKyUO5EE4jnxbwby4ZFi7RRcx8RbasdxkQUNac2zSVN36n/QA9gAcU5H0N25MaLuFW6/Lx9A51pF5WhNlJjAAAAAElFTkSuQmCC"

/***/ }),
/* 56 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAA5FBMVEVHcEz////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////GHNL/AAAAS3RSTlMAlBR25uIHCjMC69XgHt37N9FI2ihcEb+viOPLfKghmW5gDmhNq+4rO4rG84WgJvjvPrqaJI9VcGP1RRd4t0QEflBUgS4aGaRKV7XIgZNEAAABP0lEQVQYGa3A1ULCAABA0bvOoLu7026x5f//RxgwQPbI4exS7w4+sQZ0ODJN9y05LtWM74xXgZJX4EAhl1RBL5q5/HwiQuExLhjs3Fif+Eojx/0dQCaZSs9KbKTMNluGO1YsmL2iZlvXGmv1JoGnhLKAuQSMHluXCeDrhkBDfgFe86wlsrI9rOZjBLoDAMOq4zP0SlF5IiBUgKmkT6aEaSaBxVJWxklCRCPAs1L9qUgjTmi3GkBDEQlz18OXjYqEKD/gU7O5GCfEicNatT+fLXsO/wya+MS+UC6X7zkmttpsPPRqnMgI7HTtusOx67hGQB/aniwZBGJmggORotxg78rssNWpF4q2K2kE1K6is5PzhtU2e8ZVPHNPQBT66Ze70jNrauTNzcc4ojWEtOyZbjRqj63LCGG0jwtdv1A5qz82xRxdf5iKYwAAAABJRU5ErkJggg=="

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hello',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js PWA'
    };
  },

  methods: {
    goToHomepage: function goToHomepage() {
      this.$router.push('/homepage');
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Homepage',
  data: function data() {
    return {
      bannerImg: 'dsk-home-bg.jpg',
      quoteFormBg: 'formBg.jpg',
      windowWidth: 0,
      windowHeight: 0,
      inquiry: {
        email: '',
        name: '',
        phoneNumber: '',
        question: '-'
      },
      errorMessages: [],
      from: 0,
      until: 2000,
      isVisible: false,
      projectSection: 'projects',
      projectList: [],
      p1Active: false,
      p2Active: false,
      p3Active: false,
      p4Active: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    isMobile: function isMobile() {
      if (this.$data.windowWidth > 900) {
        return false;
      } else {
        return true;
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['homeTitleTop', 'homeTitleMid', 'homeTitleBot', 'homeDynamicText1', 'homeDynamicText2', 'homeDynamicText3'])),
  methods: {
    getWindowWidth: function getWindowWidth(event) {
      this.windowWidth = document.documentElement.clientWidth;
    },
    getWindowHeight: function getWindowHeight(event) {
      this.windowHeight = document.documentElement.clientHeight;
    },
    resetForm: function resetForm() {
      this.$data.inquiry.name = '';
      this.$data.inquiry.email = '';
      this.$data.inquiry.phoneNumber = '';
    },
    createInquiry: function createInquiry() {
      var _this = this;

      if (this.validateQuoteForm()) {
        this.$store.dispatch('sendMessage', {
          data: {
            message: this.$data.inquiry
          },
          success: function success() {
            _this.toast('Terima kasih, Anda akan segera kami hubungi.', 'success', 'check');
            _this.resetForm();
          },
          fail: function fail() {
            _this.toast('Maaf, ada gangguan sistem saat ini. Silahkan dicoba sesaat lagi.', 'error', 'error_outline');
          }
        });
      } else {
        this.toast(this.$data.errorMessages[0], 'error', 'error_outline');
      }
    },
    validateQuoteForm: function validateQuoteForm() {
      this.$data.errorMessages = [];
      if (this.$data.inquiry.name === null || this.$data.inquiry.name === undefined || this.$data.inquiry.name.trim() === '') {
        this.$data.errorMessages.push('Wajib isi nama');
      }
      if (this.$data.inquiry.phoneNumber === null || this.$data.inquiry.phoneNumber === undefined || this.$data.inquiry.phoneNumber.trim() === '') {
        this.$data.errorMessages.push('Wajib isi nomor telepon');
      }
      if (this.$data.inquiry.email === null || this.$data.inquiry.email === undefined || this.$data.inquiry.email.trim() === '') {
        this.$data.errorMessages.push('Wajib isi email');
      }
      if (this.$data.errorMessages.length > 0) {
        return false;
      } else {
        return true;
      }
    },
    findContentById: function findContentById(id) {
      var _this2 = this;

      this.$data.isLoading = true;
      this.$store.dispatch('findContentById', {
        data: {
          id: id
        },
        success: function success() {},
        fail: function fail() {
          _this2.toast('Something went wrong. Try again later.', 'error', 'error_outline');
        }
      }).then(function () {
        _this2.$data.isLoading = false;
      }).catch(function (err) {
        console.error('error: ' + err);
      });
    },
    toast: function toast(msg, type, icon) {
      this.$toasted.show(msg, {
        theme: 'bubble',
        position: 'top-center',
        fullWidth: true,
        type: type,
        icon: icon,
        duration: 2000
      });
    },

    formatter: function formatter(num) {
      return num.toFixed(2);
    },
    afterParty: function afterParty() {},
    getImage: function getImage(imageName, section) {
      return __WEBPACK_IMPORTED_MODULE_1__util___default.a.getImage(imageName, section);
    },
    goToProject: function goToProject() {
      this.$router.push('/projects');
    },
    visibilityChanged1: function visibilityChanged1(isVisible, entry) {
      this.$data.isVisible = isVisible;
      this.$refs.num1.start();
    },
    visibilityChanged2: function visibilityChanged2(isVisible, entry) {
      this.$data.isVisible = isVisible;
      this.$refs.num2.start();
    },
    visibilityChanged3: function visibilityChanged3(isVisible, entry) {
      this.$data.isVisible = isVisible;
      this.$refs.num3.start();
    },
    visibilityChanged4: function visibilityChanged4(isVisible, entry) {
      this.$data.isVisible = isVisible;
      this.$refs.num4.start();
    },
    goToProducts: function goToProducts() {
      this.$router.push('/products');
    },
    getProjectList: function getProjectList() {
      var _this3 = this;

      this.$data.isLoading = true;
      this.$store.dispatch('getProjectList', {
        // data: {
        //   page: 0,
        //   size: 4
        // },
        success: function success(res) {
          _this3.$data.projectList = res.data;
          _this3.$data.isLoading = false;
        },
        fail: function fail() {
          _this3.$data.isLoading = false;
          _this3.$data.isError = true;
          console.log('failed get project list');
        }
      }).then(function () {}).catch(function (err) {
        console.log('catch in getProjectList ' + err);
      });
    },
    findAllContents: function findAllContents() {
      var _this4 = this;

      this.isLoading = true;
      this.$store.dispatch('findAllContents', {
        success: function success(res) {},
        fail: function fail() {
          _this4.toast('Could not get contents. Try again later.', 'error', 'error_outline');
        }
      }).then(function () {
        _this4.isLoading = false;
      }).catch(function (err) {
        console.error('error: ' + err);
      });
    }
  },
  created: function created() {
    this.getProjectList();
    this.findAllContents();
    // this.findContentById('homeTitleTop')
    // this.findContentById('homeTitleMid')
    // this.findContentById('homeTitleBot')
    // this.findContentById('homeDynamicText1')
    // this.findContentById('homeDynamicText2')
    // this.findContentById('homeDynamicText3')
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      window.addEventListener('resize', this.getWindowWidth);
      window.addEventListener('resize', this.getWindowHeight);

      this.getWindowWidth();
      this.getWindowHeight();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.getWindowWidth);
    window.removeEventListener('resize', this.getWindowHeight);
  }
});

/***/ }),
/* 59 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/p1.4603e0a.jpg";

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/p10.6c2df90.jpg";

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/p2.e1a0851.jpg";

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/p3.bf55a70.png";

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/p4.562079a.png";

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/p5.5250429.jpg";

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/p6.925164f.jpg";

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/p7.9a140cc.jpg";

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/p8.11c9b86.jpg";

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/p9.d0e9809.jpg";

/***/ }),
/* 71 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/client-egs.2c3c759.png";

/***/ }),
/* 73 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAZ4AAAB6CAMAAAC4AMUdAAAAw1BMVEX///8AZ04AY0kAAAAAYUZPiHeDpZkAVjcAXkL4+/pZi3oAWDqvxLwAZUtJhHIAXUFumIqiu7I7e2ebtqxnlIV2nZAhcFmNjIza2tqysbHk4+PCwsLr8e+npqb09PSGhYU5NjdPTU5GREWamZnPz8+sq6vg4ODJ19JkYmIiHh8odF5zcnIWbFTT39rl7OmLiooUDhB+fX1aWFg0MTKOraK8vLxoZ2e2y8UqJycbFxhKSEjJycnN2tUNAAYeGhs/PD0ARh07TOGSAAAQ7klEQVR4nO2deWOiOhfG0VAFEalad2XaarV1G+tS7Xa93/9T3SRkI6yinet93zx/dBRiCOdHknOSo6NpSkpKSkpKSkpKSkpKSkpKSkpKSlehZaOA1TDJgYKkMjnuNuQzSlGqXwzP3NCRirTGraWLMnSKreLoSulk1C5F51bPIek35P2imPOpuCAn6k5OKaXsyoXo7C2vPtZHcrbvQs6WHF8Ww9qhFKpL4emTLlGckAN3uu86edZL53ZIM5TCdSk8tTyuziiQ96QzMTl9cuJWD2mFUoQuhGfrdR57St73JTrWPgKbUqwug4e6ARbtI1P/CKbfkuOucgtO0mXwEDfAopFNwfBfZE4LkjFQKaUugoe4AXqJvP+K8qm3qvOcpkvgoT61TXxqMy/51DRQlUMhpSRdAA91A1gfKUk+NbtETvnUJ+oCeGqe0VncWZacM4MGqnfKpz5V5+Mh8wmLO5eyT00DVeVTn66z8Xwl+NRGgxyXQyGlFDoXD3UDWNwp+9RNWrL2H5l47DTtTFXoAjoXD3ED9DvyfiI5Z9aSnJB8aitUjiHERfkYxZ+NLxRl2rzhWJaem89zBmyJHh6h2TosZKBC6IWj87rs+KZI1xKa84N4iBtg58h7U5r9rSo5IYVCVt90JZn95WJSL1kOaW+zFKNmPu4sLRReRWVqQLvKdnCsUn2ypKHBclK/YS0RrGrlCntaSHMX+8LUIjXZtbimyDUJp6ZxfM7Ds5R96or/OWGbP6b0yBaj69xPcT/Ll6KLwE4bUwHT3V3Umf6koIuDsG1V9sFS+5rla7Vt3S0ChZZbC9+zEVIBl3/edarCqX5cMHgeHkKexZ1VaVWAbf5IoVAcHliLlQKPGXeaFIrEg1TmncOpBc2O9TUVbkhvhpdyK4i0UQ49SeTDY9u+c42YeOMsPMQNYHGnvNNW/CIn5FAoHo+2cP4AHs2dkq5ejNnQ37Jb0qMbhAK6E/A4/qJxLu05eKgb4LjkgLTTxjZ/5FAoCY/2Zf0BPHTEtb7iCk1I2/NxhmraJ+DhzixRIbr7nIGHugHMp5Z22tjmjxwKJeOBLf4DeLQ9GrqsiIGNijyETtwFJ84JeFicTmVGd58z8BA3gMWd8qoAC1SlUEjCsyTy3b5p/ahrQAVdTstvVnPx9eVvijeh6luhzH7baBTqopVzdmo8djD5Zhs00Nl4iBvA9nLknTZ233IoJOGxScxTnIo3eGdwPF9lWfua4XvLii58hTiebQ3rpnRbF4eyhp6/Ed5q9SmMZWA8MxVdKxxQs2cNFrK8RDBrzo9BR5C3PtDcclmwP++trCVm5D5LZjx0PmFxp7TTxmZSORSS8TTpyGdbDX60bHE8BcuQBcd6LoeNolq9KBzXOZ6CYWPl87olPL1VgzUfaoLq9Zpi6AJFeKt8Q1Hbs6ctz69bNgQ8thNoL79z/jzs+RxUj+o+mfEQN4C58FL2GgtUtZuw8DsMDzzKbbUoCngSVrqF4aIq3mf+LrQKp8CLCw+BYHdUZ1EYu27ywlAr+MGc7cIR8MTmIvF7nBb5rBd1h1nxNIhPnZh0KIdC5DSvScBj8DGl/3N4hOJ1AUIge8Vlp/aOzju2QNGu3RBV7JR4eJsmljCwhlspMx7qBmRNOgzHo/MAxP0jeEoWb4ec4SUQ0SyWy4KvwZbabKZcSjxFNl9Bd1YYLSIWArPhcc9NOgzH4/A5finiceJXGE/Ew8IxXxc1A8+RgK6i+9ytSaFmWYbuuzURjx7ZXs4cxVNCA8vh3ScbnqSkQ+bnNCLmvFA8tsOPLoRZoXx3K2l6Mh6DPuZ5Z8785pLD3eV9wD4OH/gKuiWHPYtyoymuWAt4GnJzbxkfXg3eX+F9KeI5zoSnfnbSoYBnTpPxrbngRZWduLin5Os/KfBs51OsZu2Wm7HgCOuY28AIKgy10DHzudpE5le9YhFvLzbuoWYw2OPwhQ+JU1po98mChyUdMp9aSjqkZnEjwy0BT6GBVaj6ovebmCWuDHhCZN45Yge5CziYgu3QqkDEqkG/mjOS8LBlAb70UCG7mNz/CN1YyIJHTjqUdtrSJB0mBf39Yuyqwfl4+nUDdheHPxI3wc0dITB24FARuapTRfsOafAYrD8uqGvFR9dJ2EiTAY+cdJjlizxJeEr5H8Wz2M6LqKQQlIbg4X7vF1pCz0Uuzi31+CVRiifPjrB9MWG6DdvtPx1PIOlQ8glTJR0m4IH98Yd7j2ZW4aQh9p7ghjP/+AQ9aKG7cZ6WVho8fCNhwXoK71BkOjoTD0s6pKsemZIO4/EUrIT9nkvMPZoLXUU+9wS/2KLz1QUyb+etaT2c0FZPdg2EhSGh/TovVQka7GQ8l0k6jMMzaSIbC3gmdUlV/ziQEQ98XAWbBpe9BGeNVYsyQSqF8lKuyhWrqsrtrWNTMH9WW/zNs1+EvcBFsPuciod+kScy6TDdF3mi8JiTbc7bZM6HLonqdEX0RDzl2zD/sMkj1BDbCBtBvv1mG8YAVq2w7ws1aTVhCzQnL4jiT/PtL83ti+KVBAfYE/HQhBvnzKTDoGPdaNyVajoP9PKXXdRxWHRV4x7YVvzicyB3h49FMHTmuV6MUVHMUGhYSYs68ZuyWMEVsNPwUDcgMukw7Rd5QsJS3Z/ydWE8vApDDGeEuENelRS6Q9/STfKou3t+BXFVe5uEJ5WhA8HXaXiyJh0GFL7mJurH8OQMdtQUZwxt6rNN3r8txF6Lo7l4gSQ8xYQ9c69yufuchCcp6ZBt/iR+keffxCMEO760DDcnMmwKUejcFjZLxdQqvo59m4Anfm+eVyPd6il4AkmH0lSWj0o6DOokPI1iMNvXdw8nbsfxIamUd8TswduigQZYO28Uhd0EtJrs8ImjWqQN1oUNgaYwFurB9hb/Djh7oZJzEk/BM5V86tRJh2fiMYOaiJc+dXDjDvNW96cE9uulpq43S1XRK0NjhJgJUp5bDpTl3HGTL8VhMqS9Ju+L1UZA3H+UcxJPwEOTDqN8ajZRBpIOz8QTonPwCKYuG3HZhURojOB780j9xddk4esOhfiwVJBbDP5yjjAvuX7bpcdzRtLhdeERDqN0VCH1IFTelpUTa/2ERR1RYROpmC7kP58aTyDpUNppi0s6vC48QnG8GOY0tBjdkStZMZOHmUvKEvVfMWiOZUSB1HiIG8CclcAGKb1CSNLhdeERV4nxo2TUIk2/nNIP2vnoQrmEDQVB4V6ouPzky0lMi0dOOpQz52KTDq8Mj9ARvON2seFboaHqN4q8cXZEprxZwIXS4YnK1xW6j5YBD42XWDXyF3likw5DmsOrjsBjl8I9IM8NkvHQ41Xx8hAPPe7DAy0p16Nbpb203dYv31j+mzH0rRxbmpNbUohXGqOQLXNy/Vv2aa0uDsTp8DQTkg6ZexqadBiUUaUqzyOK5Isxki7PjhsRVUh2Dqkn7xSbt/X9ZAE12ddv55YRvBXd0kvb8uSLFGpMLScfrDRGkQ+vzsuc3nto0iEtfGLSYVhzQvJb/23BcNRwsAwj8iufeZ2UgYX0FE7QmU1Kg+fcpEOlrEqDxyRPeHLSYcQ8opRVafBUEpIOnaSkQ6WsSoEnkHQo+9Q0UA1NBVI6R8l4gkmHkk9No4voLxEpZVUyHpp0SH1qOemQLRZW0vnUSicoEc8lkg6VsioJD006zFOfOkvSoVJWJeBhvx4elXSofj38R5WAR/4ij7zTxjZ/1C8d/oji8chJh+rXw/+wYvGk/vVwORRSupBi8Vwq6VApq+LwyEmHgV8PT5t0qJRVMXjKRfytYp0lHRr+rxsLv3SY+LuR3s8ypiuWrvyplWW75g9dJbX0SDwu+U2FCo07C5Ubn1iK5I3ST6kSm6aipKSkpKSkpKSkpKSkpKSkpKSk9L8oN7kI0ziusBt4oRQlt8tfjuMKdsFT2jp7AACv2m43eHYMOprW6WnaLxBxJay0Fwt8utfL/NmrkwnAirwcAfArpmQXWTWdwEd35PWMl03wLMLjAoimFY6nBbB2aa/m0+6APrtK3dQrlwuO1BDr4+oyeLpgQF/ePwZPe73nMwbPqA2VaeRrgcdP1x3NIvrlf04uGN5/4Fdw8LpQ7+nyJz8SD1Iknsxz0gg8kyZkreHK5ILWwJsnoFUwnu4agHv4bGsPw/YBHEbaAIC1i43+BM+0UdnhtzcQfgJ3TS2i9Y4AbCCY18P7YUNAIzxj0B0C8IBsbs4AeBshPI8zgmcGr95+hgNSizaJ4Xl60d4AeMXNhB98R1Rf37orSB+93zweOgQ1Bf0gkKVtaz/Ajw7hgQ4+OQAmbJE7pLdy3XLBb9ezDLQ3MnkXfIzab2AETfsBhp2X79lqNwRrdOLw3tm9o3ucgcG4g471wONxQEh0wHOvt4b+w64FZgPSfxCeNjgeYBX38C2sERZBJv3r2TPqK3oDZp+jVzYitgDJVB58H557M/Abvnx56bV/oxKzI5i1etrx/bO9BsO2tjritj+Tm3njd9YDH/ewbSNw7H3OEGTvMRzCG2iDx786nffsvfSPCfWYZ/Ts7UDXRHjesKdwgLY/IkY9sDERD4QHWaINWY6xD9cBbXSW1QQe0N8jCAxubXymBY0zAugpxkRePDxD/PRjM72syWdaYLPZHH4jeyLyx5VnU017XqGWIFpjdAUXfXaIbP4JeviTY1z/02Aw6KCWH3ALXtBf1Ed9eDSNtOa6hfD00M0+fuDXGnzOTBPzOCKreu40ujMy96zW6J1p4imkhwh6GnlMBhCaMEt5eJDxdrAotqV32sMzEOaz9ZG8aIEhVA/VhaAg9/vhiBqF3nuTfhtfF5m3i/5QT6CNDb4CK+QX9sAnvj/M4BNeSMSDcbJh+XrlIXnAzyN67QIigsfFY46A57jRWiuvCMLDxu+O9xIZJRQPKuoFOmOO5+hNe+4rrHHF8ZBBh+M5kCtCPF4Y8L42YTl0xccX/EhhdemLN4wHIWx7bUHOpIgHP0qbEL/lyoTxQIMgI3h4fuH/CNiMwgPvCY5T+D8I1vx4cEdCnSQGD7K3gMfFA5D5feh1+w9xeB40ckWCZ4N4Dbzrtj9ZH16RGE7Eg4Np9E+g9/xFh9Prleu5A7/QkI5fr1ibA3gG+P2MdhTNh6ftWQsRiMQzwMVHwtwzQpP5Dg9D6xg8z9+0Qg9PB2jdMb2B4es7PTsk0wnHg9oL9QSv3AFj0kCPmUv72hXLc6Y/vtGTRXoS6vhuOwQPOvMKTel6XsCnD4/28t1Fpp9p0Xi6yNtrAwEPNOgAnuqg2SEGzw6b3RxRPD3oGz51vD7zdljxKX4DfsHPuA8Mj7ZG7Lure9S2V3Q9jAc1acYnzquVh6cDPjT6OD2AzfM98rUPaGj2+swQ42mBwwt+GHswEoL+senDMwbguAGPphB3wjruNTLSo1EPWv77CKNf+OwiUHgqeoDH78HzB1hTJ5As6jwRf+0V4D8vz4/oM2+eF/C4eji+40ZDroAHoSaMoL5hUPZM+6TmHsDmCF7QlzvWMDRYeYPbK9i8xwbh16IBfoQGY/76c/h7gKy+Qw+9ic+MB6bmDszusIVvWXOffg93KFQdCKGD2WkNPYsMmL12O/rWKzpqDaGH2/UWddp4tEQX7fwamG3qjXc7O6hO1zuvjfDf9vDXELVuhMl74DreDP/tm+G7T61WB12wT9u2a7VI1Z3fT7AduD+7w9b1953/qjw3YoRHzVH6lXSqdsb1VqV0aoHX3ufAi4lnpwf/Cs8Pa/ABwL3nEXiu2Ukak1UGJSUlJSUlJSUlJSUlJSUlJaX/L/0DStm8Ym4Dw/QAAAAASUVORK5CYII="

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/client1.b6c41c0.jpg";

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/client2.d9578f2.jpg";

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/client3.0f6470c.jpg";

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bahu shoulder 15 cm & 35 cm DSK.36d946f.jpg";

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Cat walk 120 dsk.12ee263.jpg";

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Horizontal Frame 1,2m.e8dadbd.jpg";

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Horizontal shore 0,9 meter.11b6ad6.jpg";

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Horizontal shore 1,2 meter & 0,9 meter - Salin.250eff9.jpg";

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Horizontal shore 1,2 meter.e516def.jpg";

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Jack base 60cm solid.e6dd253.jpg";

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Kuncian siku tembereng (tie rod 50cm).aadb247.jpg";

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Main beam (hollow 50x50) 2,4m,,3.0m,,4.0m.fc027be.jpg";

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Main beam 2,4m (Hollow 50x50 x2,4m).9f1be6b.jpg";

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Main beam 3.0m (hollow 50x50 x3.0m).5d929f8.jpg";

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Main beam 4.0m (hollow 50x50x4.0m).3a7d1ca.jpg";

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Metal Plank 250mm X 2,5m.857566a.jpg";

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Pipa 40 cm joint sock 20cm.fb0f62c.jpg";

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Pipa 40cm polos & pipa 40cm joint sock 20cm.91a4851.jpg";

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Pipa 40cm polos.464059d.jpg";

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Post shore 1,2,3 meter.f46c70e.jpg";

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Post shore 1.0 meter.7ede64e.jpg";

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Post shore 2.0 meter.aff7cce.jpg";

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Post shore 3.0 meter.e54b87a.jpg";

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Push pull 3.0m tampak samping.c39bcf5.jpg";

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Push pull 3.0m.6c180a4.jpg";

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Siku tembereng 30-50.b2fb092.jpg";

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Sub beam 2,4m (hollow 40x40x2,4m).6da2a05.jpg";

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Sub beam 3.0m (hollow 40x40x3.0m).51e8106.jpg";

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Sub beam 4,8m (hollow 40x40x4,8m).9da36c4.jpg";

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Sub beam 4,8m,,3.0m,,2,4m (hollow 40x40).192d200.jpg";

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Suri-suri 170cm tampak samping.ad46db8.jpg";

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Suri-suri 170cm.8ce343e.jpg";

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Swipel Clamp (Hidup).51eb19b.jpg";

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Tangga DSK Versi 2.8c51df6.jpg";

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Tangga DSK tampak samping.8b279cd.jpg";

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Tangga dsk.9c8d4b9.jpg";

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/U- head 60cm hollow DSK.18b4de3.jpg";

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/U-head 60cm solid.1f5898a.jpg";

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Whell 8 inch (Roda Scaffolding 8 x 2).d52174b.jpg";

/***/ }),
/* 113 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 115 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/why-us.9f9d12a.png";

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'About',
  data: function data() {
    return {
      bannerImg: 'dsk-about-bg.jpg'
    };
  },

  methods: {
    getImage: function getImage(imageName, section) {
      return __WEBPACK_IMPORTED_MODULE_1__util___default.a.getImage(imageName, section);
    },
    findAllClients: function findAllClients() {
      var _this = this;

      this.isLoading = true;
      this.$store.dispatch('findAllClients', {
        success: function success(res) {},
        fail: function fail() {
          _this.toast('Could not get clients. Try again later.', 'error', 'error_outline');
        }
      }).then(function () {
        _this.isLoading = false;
      }).catch(function (err) {
        console.error('error: ' + err);
      });
    },
    findAllContents: function findAllContents() {
      var _this2 = this;

      this.isLoading = true;
      this.$store.dispatch('findAllContents', {
        success: function success(res) {},
        fail: function fail() {
          _this2.toast('Could not get contents. Try again later.', 'error', 'error_outline');
        }
      }).then(function () {
        _this2.isLoading = false;
      }).catch(function (err) {
        console.error('error: ' + err);
      });
    },
    findContentById: function findContentById(id) {
      var _this3 = this;

      this.$data.isLoading = true;
      this.$store.dispatch('findContentById', {
        data: {
          id: id
        },
        success: function success() {},
        fail: function fail() {
          _this3.toast('Something went wrong. Try again later.', 'error', 'error_outline');
        }
      }).then(function () {
        _this3.$data.isLoading = false;
      }).catch(function (err) {
        console.error('error: ' + err);
      });
    }
  },
  created: function created() {
    /*
    this.findContentById('aboutTitleTop')
    this.findContentById('aboutTitleMid')
    this.findContentById('aboutTitleBot')
    this.findContentById('aboutDynamicText1')
    this.findContentById('aboutDynamicText2')
    this.findContentById('aboutWhyUsTitle1')
    this.findContentById('aboutWhyUsDescription1')
    this.findContentById('aboutWhyUsTitle2')
    this.findContentById('aboutWhyUsDescription2')
    this.findContentById('aboutWhyUsTitle3')
    this.findContentById('aboutWhyUsDescription3')
    this.findContentById('aboutWhyUsTitle4')
    this.findContentById('aboutWhyUsDescription4')
    this.findContentById('visionMissionTitle1')
    this.findContentById('visionMissionDescription1')
    this.findContentById('visionMissionTitle2')
    this.findContentById('visionMissionDescription2')
    this.findContentById('visionMissionTitle3')
    this.findContentById('visionMissionDescription3')
    this.findContentById('visionMissionTitle4')
    this.findContentById('visionMissionDescription4')
    this.findContentById('visionMissionTitle5')
    this.findContentById('visionMissionDescription5')
    this.findContentById('visionMissionTitle6')
    this.findContentById('visionMissionDescription6')
    this.findContentById('visionMissionTitle7')
    this.findContentById('visionMissionDescription7')
    this.findContentById('visionMissionTitle8')
    this.findContentById('visionMissionDescription8')
    */
    this.findAllContents();
    this.findAllClients();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['aboutTitleTop', 'aboutTitleMid', 'aboutTitleBot', 'aboutDynamicText1', 'aboutDynamicText2', 'aboutWhyUsTitle1', 'aboutWhyUsDescription1', 'aboutWhyUsTitle2', 'aboutWhyUsDescription2', 'aboutWhyUsTitle3', 'aboutWhyUsDescription3', 'aboutWhyUsTitle4', 'aboutWhyUsDescription4', 'visionMissionTitle1', 'visionMissionDescription1', 'visionMissionTitle2', 'visionMissionDescription2', 'visionMissionTitle3', 'visionMissionDescription3', 'visionMissionTitle4', 'visionMissionDescription4', 'visionMissionTitle5', 'visionMissionDescription5', 'visionMissionTitle6', 'visionMissionDescription6', 'visionMissionTitle7', 'visionMissionDescription7', 'visionMissionTitle8', 'visionMissionDescription8', 'clients']))
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Service',
  data: function data() {
    return {
      bannerImg: 'dsk-service-bg.jpg',
      serviceSection: 'service'
    };
  },

  methods: {
    getImage: function getImage(imageName, section) {
      return __WEBPACK_IMPORTED_MODULE_1__util___default.a.getImage(imageName, section);
    },
    findContentById: function findContentById(id) {
      var _this = this;

      this.$data.isLoading = true;
      this.$store.dispatch('findContentById', {
        data: {
          id: id
        },
        success: function success() {},
        fail: function fail() {
          _this.toast('Something went wrong. Try again later.', 'error', 'error_outline');
        }
      }).then(function () {
        _this.$data.isLoading = false;
      }).catch(function (err) {
        console.error('error: ' + err);
      });
    },
    findAllContents: function findAllContents() {
      var _this2 = this;

      this.isLoading = true;
      this.$store.dispatch('findAllContents', {
        success: function success(res) {},
        fail: function fail() {
          _this2.toast('Could not get contents. Try again later.', 'error', 'error_outline');
        }
      }).then(function () {
        _this2.isLoading = false;
      }).catch(function (err) {
        console.error('error: ' + err);
      });
    }
  },
  created: function created() {
    this.findAllContents();
    // this.findContentById('serviceTitleTop')
    // this.findContentById('serviceTitleMid')
    // this.findContentById('serviceTitleBot')
    // this.findContentById('serviceDynamicText1')
    // this.findContentById('serviceDynamicText2')
    // this.findContentById('serviceDynamicText3')
    // this.findContentById('serviceDynamicText4')
    // this.findContentById('serviceDynamicText5')
    // this.findContentById('serviceDynamicText6')
    // this.findContentById('serviceDynamicText7')
    // this.findContentById('serviceDynamicText8')
    // this.findContentById('serviceDynamicText9')
    // this.findContentById('serviceDynamicText10')
    // this.findContentById('serviceDynamicText11')
    // this.findContentById('serviceDynamicText12')
    // this.findContentById('serviceDynamicText13')
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['serviceTitleTop', 'serviceTitleMid', 'serviceTitleBot', 'serviceDynamicText1', 'serviceDynamicText2', 'serviceDynamicText3', 'serviceDynamicText4', 'serviceDynamicText5', 'serviceDynamicText6', 'serviceDynamicText7', 'serviceDynamicText8', 'serviceDynamicText9', 'serviceDynamicText10', 'serviceDynamicText11', 'serviceDynamicText12', 'serviceDynamicText13']))
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Projects',
  data: function data() {
    return {
      projectList: [],
      bannerImg: 'dsk-projects-bg.jpg',
      projectSection: 'projects'
    };
  },

  methods: {
    getImage: function getImage(imageName, section) {
      return __WEBPACK_IMPORTED_MODULE_1__util___default.a.getImage(imageName, section);
    },
    getProjectList: function getProjectList() {
      var _this = this;

      this.$data.isLoading = true;
      this.$store.dispatch('getProjectList', {
        data: {},
        success: function success(res) {
          _this.$data.projectList = res.data;
          _this.$data.isLoading = false;
        },
        fail: function fail() {
          _this.$data.isLoading = false;
          _this.$data.isError = true;
          console.log('failed get project list');
        }
      }).then(function () {}).catch(function (err) {
        console.log('catch in getProjectList ' + err);
      });
    },
    findContentById: function findContentById(id) {
      var _this2 = this;

      this.$data.isLoading = true;
      this.$store.dispatch('findContentById', {
        data: {
          id: id
        },
        success: function success() {},
        fail: function fail() {
          _this2.toast('Something went wrong. Try again later.', 'error', 'error_outline');
        }
      }).then(function () {
        _this2.$data.isLoading = false;
      }).catch(function (err) {
        console.error('error: ' + err);
      });
    },
    findAllContents: function findAllContents() {
      var _this3 = this;

      this.isLoading = true;
      this.$store.dispatch('findAllContents', {
        success: function success(res) {},
        fail: function fail() {
          _this3.toast('Could not get contents. Try again later.', 'error', 'error_outline');
        }
      }).then(function () {
        _this3.isLoading = false;
      }).catch(function (err) {
        console.error('error: ' + err);
      });
    }
  },
  created: function created() {
    this.getProjectList();
    this.findAllContents();
    // this.findContentById('projectTitleTop')
    // this.findContentById('projectTitleMid')
    // this.findContentById('projectTitleBot')
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['projectTitleTop', 'projectTitleMid', 'projectTitleBot']))
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Products',
  data: function data() {
    return {
      isLoading: false,
      isError: false,
      bannerImg: 'dsk-products-bg.jpg',
      productSection: 'products',
      productList: []
    };
  },

  methods: {
    getImage: function getImage(imageName, section) {
      return __WEBPACK_IMPORTED_MODULE_1__util___default.a.getImage(imageName, section);
    },
    formatPrice: function formatPrice(value) {
      return __WEBPACK_IMPORTED_MODULE_1__util___default.a.currencyFormat(value);
    },
    findAllProducts: function findAllProducts(page) {
      var _this = this;

      this.isLoading = true;
      this.$store.dispatch('getProductList', {
        // data: {
        //   page: page,
        //   size: 100
        // },
        success: function success(res) {
          _this.$data.productList = res.body.data;
        },
        fail: function fail() {
          _this.toast('Could not get products. Try again later.', 'error', 'error_outline');
        }
      }).then(function () {
        _this.isLoading = false;
      }).catch(function (err) {
        console.error('error: ' + err);
      });
    },
    findContentById: function findContentById(id) {
      var _this2 = this;

      this.$data.isLoading = true;
      this.$store.dispatch('findContentById', {
        data: {
          id: id
        },
        success: function success() {},
        fail: function fail() {
          _this2.toast('Something went wrong. Try again later.', 'error', 'error_outline');
        }
      }).then(function () {
        _this2.$data.isLoading = false;
      }).catch(function (err) {
        console.error('error: ' + err);
      });
    },
    findAllContents: function findAllContents() {
      var _this3 = this;

      this.isLoading = true;
      this.$store.dispatch('findAllContents', {
        success: function success(res) {},
        fail: function fail() {
          _this3.toast('Could not get contents. Try again later.', 'error', 'error_outline');
        }
      }).then(function () {
        _this3.isLoading = false;
      }).catch(function (err) {
        console.error('error: ' + err);
      });
    }
  },
  created: function created() {
    this.findAllProducts(0);
    this.findAllContents();
    // this.findContentById('productTitleTop')
    // this.findContentById('productTitleMid')
    // this.findContentById('productTitleBot')
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['productTitleTop', 'productTitleMid', 'productTitleBot']))
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ContactUs',
  data: function data() {
    return {
      bannerImg: 'dsk-contact-bg.jpg',
      p: '021-555-8000',
      a: 'Jl. M.H. Thamrin No. 5A, Kebon Melati, Tanah Abang, Jakarta Pusat',
      cPhoneNumberId: 'cPhoneNumber',
      inquiry: {
        email: '',
        name: '',
        phoneNumber: ''
      },
      errors: [],
      position: { lat: -6.202237, lng: 106.714959 }
    };
  },

  methods: {
    getImage: function getImage(imageName, section) {
      return __WEBPACK_IMPORTED_MODULE_1__util___default.a.getImage(imageName, section);
    },
    formatPrice: function formatPrice(value) {
      return __WEBPACK_IMPORTED_MODULE_1__util___default.a.currencyFormat(value);
    },
    resetForm: function resetForm() {
      this.$data.inquiry.name = '';
      this.$data.inquiry.email = '';
      this.$data.inquiry.phoneNumber = '';
    },
    validateForm: function validateForm() {
      if (this.$data.inquiry.name === '' || this.$data.inquiry.email === '' || this.$data.inquiry.email === '' || this.$data.inquiry.name.trim() === '' || this.$data.inquiry.email.trim() === '' || this.$data.inquiry.email.trim() === '') {
        this.$data.errors.push('Semua kolom wajib diisi');
        return false;
      }
      return true;
    },
    sendEmail: function sendEmail() {
      var _this = this;

      if (this.validateForm()) {
        this.$store.dispatch('sendMessage', {
          data: {
            message: this.$data.inquiry
          },
          success: function success() {
            _this.toast('Terima kasih, Anda akan segera kami hubungi.', 'success', 'check');
            _this.resetForm();
          },
          fail: function fail() {
            _this.toast('Maaf, ada gangguan sistem saat ini. Silahkan dicoba sesaat lagi.', 'error', 'error_outline');
          }
        });
        // this.$store.dispatch('createInquiry', {
        //   data: {
        //     inquiry: this.$data.inquiry
        //   },
        //   success: () => {
        //     this.toast('Terima kasih, Anda akan segera kami hubungi.', 'success', 'check')
        //     this.resetForm()
        //   },
        //   fail: () => {
        //     this.toast('Maaf, ada gangguan sistem saat ini. Silahkan dicoba sesaat lagi.', 'error', 'error_outline')
        //   }
        // })
      } else {
        this.toast(this.$data.errors[0], 'error', 'error_outline');
        this.isLoading = false;
      }
    },
    findPhoneNumber: function findPhoneNumber() {
      var _this2 = this;

      this.$data.isLoading = true;
      this.$store.dispatch('findContentById', {
        data: {
          id: this.$data.cPhoneNumberId
        },
        success: function success() {},
        fail: function fail() {}
      }).then(function () {
        _this2.$data.isLoading = false;
      }).catch(function (err) {
        console.error('error: ' + err);
      });
    },
    toast: function toast(msg, type, icon) {
      this.$toasted.show(msg, {
        theme: 'bubble',
        position: 'top-center',
        fullWidth: true,
        type: type,
        icon: icon,
        duration: 2000
      });
    },
    findContentById: function findContentById(id) {
      var _this3 = this;

      this.$data.isLoading = true;
      this.$store.dispatch('findContentById', {
        data: {
          id: id
        },
        success: function success() {},
        fail: function fail() {
          _this3.toast('Something went wrong. Try again later.', 'error', 'error_outline');
        }
      }).then(function () {
        _this3.$data.isLoading = false;
      }).catch(function (err) {
        console.error('error: ' + err);
      });
    },
    findAllContents: function findAllContents() {
      var _this4 = this;

      this.isLoading = true;
      this.$store.dispatch('findAllContents', {
        success: function success(res) {},
        fail: function fail() {
          _this4.toast('Could not get contents. Try again later.', 'error', 'error_outline');
        }
      }).then(function () {
        _this4.isLoading = false;
      }).catch(function (err) {
        console.error('error: ' + err);
      });
    }
  },
  created: function created() {
    this.findAllContents();
    // this.findContentById('contactTitleMid')
    // this.findContentById('contactTitleBot')
    // this.findContentById('contactDynamicText1')
    // this.findContentById('contactDynamicText2')
    // this.findContentById('contactDynamicText3')
    // this.findContentById('contactDynamicText4')
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['phoneNumber', 'contactTitleMid', 'contactTitleBot', 'contactDynamicText1', 'contactDynamicText2', 'contactDynamicText3', 'contactDynamicText4']))
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__util__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',
  data: function data() {
    return {
      errors: [],
      username: '',
      password: '',
      bannerImg: 'dsk-home-bg.jpg'
    };
  },

  methods: {
    getImage: function getImage(imageName, section) {
      return __WEBPACK_IMPORTED_MODULE_0__util___default.a.getImage(imageName, section);
    },
    login: function login() {
      var _this = this;

      if (this.validateLogin()) {
        this.$store.dispatch('login', {
          data: {
            username: this.$data.username,
            password: this.$data.password
          },
          success: function success(res) {
            console.log('response body login ', res.body);
            _this.$cookies.set('uses', _this.$data.username, '1d');
            _this.$cookies.set('a', res.body, '1d');
            _this.toast('Hi there!', 'success', 'check');
            _this.$router.push('/dashboard');
          },
          fail: function fail() {
            console.log('failed to login');
            _this.toast('Invalid username or password', 'error', 'error_outline');
          }
        });
      } else {
        this.toast(this.$data.errors[0], 'error', 'error_outline');
      }
    },
    validateLogin: function validateLogin() {
      if (this.$data.username === '' || this.$data.username === undefined || this.$data.username.trim() === '' || this.$data.password === '' || this.$data.password === undefined || this.$data.password.trim() === '') {
        this.$data.errors.push('Invalid username or password.');
        return false;
      }
      return true;
    },
    toast: function toast(msg, type, icon) {
      this.$toasted.show(msg, {
        theme: 'bubble',
        position: 'top-center',
        fullWidth: true,
        type: type,
        icon: icon,
        duration: 2000
      });
    }
  }
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Dashboard',
  data: function data() {
    return {
      totalPortfolios: 0,
      totalProducts: 0,
      totalClients: 0
    };
  },

  methods: {
    getImage: function getImage(imageName, section) {
      return __WEBPACK_IMPORTED_MODULE_1__util___default.a.getImage(imageName, section);
    },
    toast: function toast(msg, type, icon) {
      this.$toasted.show(msg, {
        theme: 'bubble',
        position: 'top-center',
        fullWidth: true,
        type: type,
        icon: icon,
        duration: 2000
      });
    },
    getAllInquiries: function getAllInquiries(page) {
      var _this = this;

      this.isLoading = true;
      this.$store.dispatch('getAllInquiries', {
        data: {
          page: page,
          size: 5
        },
        success: function success(res) {},
        fail: function fail() {
          _this.toast('Could not get inquiries. Try again later.', 'error', 'error_outline');
        }
      }).then(function () {
        _this.isLoading = false;
      }).catch(function (err) {
        console.error('error: ' + err);
      });
    },
    findAllClients: function findAllClients() {
      var _this2 = this;

      this.isLoading = true;
      this.$store.dispatch('findAllClients', {
        success: function success(res) {
          _this2.$data.totalClients = res.body.meta.pagination.total;
          // this.$data.clientList = res.body.data
          // this.$data.totalPortfolios = res.body.data
        },
        fail: function fail() {
          _this2.toast('Could not get clients. Try again later.', 'error', 'error_outline');
        }
      }).then(function () {
        _this2.isLoading = false;
      }).catch(function (err) {
        console.error('error: ' + err);
      });
    },
    findAllProjects: function findAllProjects() {
      var _this3 = this;

      this.isLoading = true;
      this.$store.dispatch('getProjectList', {
        success: function success(res) {
          _this3.$data.totalPortfolios = res.body.meta.pagination.total;
        },
        fail: function fail() {
          _this3.toast('Could not get projects. Try again later.', 'error', 'error_outline');
        }
      }).then(function () {
        _this3.isLoading = false;
      }).catch(function (err) {
        console.error('error: ' + err);
      });
    },
    findAllProducts: function findAllProducts() {
      var _this4 = this;

      this.isLoading = true;
      this.$store.dispatch('getProductList', {
        success: function success(res) {
          console.log('res is ', res);
          _this4.$data.totalProducts = res.body.meta.pagination.total;
        },
        fail: function fail() {
          _this4.toast('Could not get products. Try again later.', 'error', 'error_outline');
        }
      }).then(function () {
        _this4.isLoading = false;
      }).catch(function (err) {
        console.error('error: ' + err);
      });
    }
    // findAllSubscribers (page) {
    //   this.$store.dispatch('findAllSubscribers', {
    //     data: {
    //       page: page,
    //       size: 3
    //     },
    //     success: (res) => {
    //       console.log('success')
    //     },
    //     fail: (res) => {
    //       this.toast('Something went wrong. Try again later.', 'error', 'error_outline')
    //     }
    //   }).then(() => {
    //     this.isLoading = false
    //   }).catch(err => {
    //     console.error('error: ' + err)
    //   })
    // }

  },
  created: function created() {
    // this.getAllInquiries(0)
    // this.findAllSubscribers(0)
    this.findAllClients();
    this.findAllProducts();
    this.findAllProjects();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['totalInquiries', 'inquiries', 'subscribers', 'totalSubscribers']))
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DProducts',
  data: function data() {
    return {
      isLoading: true,
      errors: [],
      productSection: 'products',
      productList: []
    };
  },

  methods: {
    deleteProduct: function deleteProduct(product) {
      var _this = this;

      this.isLoading = true;
      this.$store.dispatch('deleteProduct', {
        data: {
          id: product.id,
          token: this.$cookies.get('a').jwt
        },
        success: function success(res) {
          _this.deleteFile(product.attributes.image.data.id);
        },
        fail: function fail() {
          _this.toast('Could not remove product. Try again later.', 'error', 'error_outline');
        }
      }).then(function () {
        _this.isLoading = false;
      }).catch(function (err) {
        console.error('error: ' + err);
      });
    },
    deleteFile: function deleteFile(id) {
      var _this2 = this;

      this.$store.dispatch('deleteFile', {
        data: {
          id: id,
          token: this.$cookies.get('a').jwt
        },
        success: function success(res) {
          _this2.toast('Remove product is done.', 'success', 'check');
          _this2.findAllProducts();
        },
        fail: function fail() {
          _this2.toast('Image delete failed.', 'error', 'error_outline');
        }
      }).then(function () {}).catch(function (err) {
        console.error('error: ' + err);
      });
    },
    editProduct: function editProduct(id) {
      this.$router.push({ name: 'EditProduct', params: { id: id } });
    },
    findAllProducts: function findAllProducts() {
      var _this3 = this;

      this.isLoading = true;
      this.$store.dispatch('getProductList', {
        success: function success(res) {
          _this3.$data.productList = res.body.data;
        },
        fail: function fail() {
          _this3.toast('Could not get products. Try again later.', 'error', 'error_outline');
        }
      }).then(function () {
        _this3.isLoading = false;
      }).catch(function (err) {
        console.error('error: ' + err);
      });
    },
    goToAddProduct: function goToAddProduct() {
      this.$router.push('/addproduct');
    },
    getImage: function getImage(imageName, section) {
      return __WEBPACK_IMPORTED_MODULE_1__util___default.a.getImage(imageName, section);
    },
    currencyFormat: function currencyFormat(price) {
      return __WEBPACK_IMPORTED_MODULE_1__util___default.a.currencyFormat(price);
    },
    toast: function toast(msg, type, icon) {
      this.$toasted.show(msg, {
        theme: 'bubble',
        position: 'top-center',
        fullWidth: true,
        type: type,
        icon: icon,
        duration: 2000
      });
    }
  },
  created: function created() {
    this.findAllProducts();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['products']))
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DProjects',
  data: function data() {
    return {
      projectSection: 'projects',
      projectList: []
    };
  },

  methods: {
    goToAddProject: function goToAddProject() {
      this.$router.push('/addproject');
    },
    getImage: function getImage(imageName, section) {
      return __WEBPACK_IMPORTED_MODULE_1__util___default.a.getImage(imageName, section);
    },
    editProject: function editProject(id) {
      this.$router.push({ name: 'EditProject', params: { id: id } });
    },
    deleteProject: function deleteProject(project) {
      var _this = this;

      this.isLoading = true;
      this.$store.dispatch('deleteProject', {
        data: {
          id: project.id,
          token: this.$cookies.get('a').jwt
        },
        success: function success(res) {
          _this.deleteFile(project.attributes.images.data[0].id);
        },
        fail: function fail() {
          _this.toast('Could not remove project. Try again later.', 'error', 'error_outline');
        }
      }).then(function () {
        _this.isLoading = false;
      }).catch(function (err) {
        console.error('error: ' + err);
      });
    },
    deleteFile: function deleteFile(id) {
      var _this2 = this;

      this.$store.dispatch('deleteFile', {
        data: {
          id: id,
          token: this.$cookies.get('a').jwt
        },
        success: function success(res) {
          _this2.toast('Remove project is done.', 'success', 'check');
          _this2.findAllProjects(0);
        },
        fail: function fail() {
          _this2.toast('Image delete failed.', 'error', 'error_outline');
        }
      }).then(function () {}).catch(function (err) {
        console.error('error: ' + err);
      });
    },
    findAllProjects: function findAllProjects(page) {
      var _this3 = this;

      this.isLoading = true;
      this.$store.dispatch('getProjectList', {
        success: function success(res) {
          _this3.$data.projectList = res.body.data;
        },
        fail: function fail() {
          _this3.toast('Could not get projects. Try again later.', 'error', 'error_outline');
        }
      }).then(function () {
        _this3.isLoading = false;
      }).catch(function (err) {
        console.error('error: ' + err);
      });
    },
    toast: function toast(msg, type, icon) {
      this.$toasted.show(msg, {
        theme: 'bubble',
        position: 'top-center',
        fullWidth: true,
        type: type,
        icon: icon,
        duration: 2000
      });
    }
  },
  created: function created() {
    this.findAllProjects(0);
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['projects']))
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DClients',
  data: function data() {
    return {
      isLoading: true,
      errors: [],
      clientList: []
    };
  },

  methods: {
    deleteClient: function deleteClient(client) {
      var _this = this;

      this.isLoading = true;
      this.$store.dispatch('deleteClient', {
        data: {
          id: client.id,
          token: this.$cookies.get('a').jwt
        },
        success: function success(res) {
          _this.deleteFile(client.attributes.image.data.id);
        },
        fail: function fail() {
          _this.toast('Could not remove client. Try again later.', 'error', 'error_outline');
        }
      }).then(function () {
        _this.isLoading = false;
      }).catch(function (err) {
        console.error('error: ' + err);
      });
    },
    deleteFile: function deleteFile(id) {
      var _this2 = this;

      this.$store.dispatch('deleteFile', {
        data: {
          id: id,
          token: this.$cookies.get('a').jwt
        },
        success: function success(res) {
          _this2.toast('Remove client is done.', 'success', 'check');
          _this2.findAllClients();
        },
        fail: function fail() {
          _this2.toast('Image delete failed.', 'error', 'error_outline');
        }
      }).then(function () {}).catch(function (err) {
        console.error('error: ' + err);
      });
    },
    findAllClients: function findAllClients() {
      var _this3 = this;

      this.isLoading = true;
      this.$store.dispatch('findAllClients', {
        success: function success(res) {
          _this3.$data.clientList = res.body.data;
        },
        fail: function fail() {
          _this3.toast('Could not get clients. Try again later.', 'error', 'error_outline');
        }
      }).then(function () {
        _this3.isLoading = false;
      }).catch(function (err) {
        console.error('error: ' + err);
      });
    },
    goToAddClient: function goToAddClient() {
      this.$router.push('/addclient');
    },
    getImage: function getImage(imageName, section) {
      return __WEBPACK_IMPORTED_MODULE_1__util___default.a.getImage(imageName, section);
    },
    currencyFormat: function currencyFormat(price) {
      return __WEBPACK_IMPORTED_MODULE_1__util___default.a.currencyFormat(price);
    },
    toast: function toast(msg, type, icon) {
      this.$toasted.show(msg, {
        theme: 'bubble',
        position: 'top-center',
        fullWidth: true,
        type: type,
        icon: icon,
        duration: 2000
      });
    }
  },
  created: function created() {
    this.findAllClients(0);
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['clients']))
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Settings',
  data: function data() {
    return {
      errors: [],
      isLoading: false,
      editingPhoneNumber: false,
      editingContent: {
        homeTitleTop: false,
        homeTitleMid: false,
        homeTitleBot: false,
        homeDynamicText1: false,
        homeDynamicText2: false,
        homeDynamicText3: false,
        aboutTitleTop: false,
        aboutTitleMid: false,
        aboutTitleBot: false,
        aboutDynamicText1: false,
        aboutDynamicText2: false,
        aboutWhyUsTitle1: false,
        aboutWhyUsDescription1: false,
        aboutWhyUsTitle2: false,
        aboutWhyUsDescription2: false,
        aboutWhyUsTitle3: false,
        aboutWhyUsDescription3: false,
        aboutWhyUsTitle4: false,
        aboutWhyUsDescription4: false,
        visionMissionTitle1: false,
        visionMissionDescription1: false,
        visionMissionTitle2: false,
        visionMissionDescription2: false,
        visionMissionTitle3: false,
        visionMissionDescription3: false,
        visionMissionTitle4: false,
        visionMissionDescription4: false,
        visionMissionTitle5: false,
        visionMissionDescription5: false,
        visionMissionTitle6: false,
        visionMissionDescription6: false,
        visionMissionTitle7: false,
        visionMissionDescription7: false,
        visionMissionTitle8: false,
        visionMissionDescription8: false,
        serviceTitleTop: false,
        serviceTitleMid: false,
        serviceTitleBot: false,
        serviceDynamicText1: false,
        serviceDynamicText2: false,
        serviceDynamicText3: false,
        serviceDynamicText4: false,
        serviceDynamicText5: false,
        serviceDynamicText6: false,
        serviceDynamicText7: false,
        serviceDynamicText8: false,
        serviceDynamicText9: false,
        serviceDynamicText10: false,
        serviceDynamicText11: false,
        serviceDynamicText12: false,
        serviceDynamicText13: false,
        projectTitleTop: false,
        projectTitleMid: false,
        projectTitleBot: false,
        productTitleTop: false,
        productTitleMid: false,
        productTitleBot: false,
        contactTitleMid: false,
        contactTitleBot: false,
        contactDynamicText1: false,
        contactDynamicText2: false,
        contactDynamicText3: false,
        contactDynamicText4: false,
        aboutUsFooter: false,
        subscribeFooter: false,
        socialMediaFooter: false
      },
      mphoneNumber: null,
      mHomeTitleTop: null,
      mhomeTitleTop: null,
      mhomeTitleMid: null,
      mhomeTitleBot: null,
      mhomeDynamicText1: null,
      mhomeDynamicText2: null,
      mhomeDynamicText3: null,
      maboutTitleTop: null,
      maboutTitleMid: null,
      maboutTitleBot: null,
      maboutDynamicText1: null,
      maboutDynamicText2: null,
      maboutWhyUsTitle1: null,
      maboutWhyUsDescription1: null,
      maboutWhyUsTitle2: null,
      maboutWhyUsDescription2: null,
      maboutWhyUsTitle3: null,
      maboutWhyUsDescription3: null,
      maboutWhyUsTitle4: null,
      maboutWhyUsDescription4: null,
      mvisionMissionTitle1: null,
      mvisionMissionDescription1: null,
      mvisionMissionTitle2: null,
      mvisionMissionDescription2: null,
      mvisionMissionTitle3: null,
      mvisionMissionDescription3: null,
      mvisionMissionTitle4: null,
      mvisionMissionDescription4: null,
      mvisionMissionTitle5: null,
      mvisionMissionDescription5: null,
      mvisionMissionTitle6: null,
      mvisionMissionDescription6: null,
      mvisionMissionTitle7: null,
      mvisionMissionDescription7: null,
      mvisionMissionTitle8: null,
      mvisionMissionDescription8: null,
      mserviceTitleTop: null,
      mserviceTitleMid: null,
      mserviceTitleBot: null,
      mserviceDynamicText1: null,
      mserviceDynamicText2: null,
      mserviceDynamicText3: null,
      mserviceDynamicText4: null,
      mserviceDynamicText5: null,
      mserviceDynamicText6: null,
      mserviceDynamicText7: null,
      mserviceDynamicText8: null,
      mserviceDynamicText9: null,
      mserviceDynamicText10: null,
      mserviceDynamicText11: null,
      mserviceDynamicText12: null,
      mserviceDynamicText13: null,
      mprojectTitleTop: null,
      mprojectTitleMid: null,
      mprojectTitleBot: null,
      mproductTitleTop: null,
      mproductTitleMid: null,
      mproductTitleBot: null,
      mcontactTitleMid: null,
      mcontactTitleBot: null,
      mcontactDynamicText1: null,
      mcontactDynamicText2: null,
      mcontactDynamicText3: null,
      mcontactDynamicText4: null,
      maboutUsFooter: null,
      msubscribeFooter: null,
      msocialMediaFooter: null
    };
  },

  methods: {
    editingToFalse: function editingToFalse() {
      this.$data.editingPhoneNumber = false;
      this.$data.editingContent.homeTitleTop = false;
      this.$data.editingContent.homeTitleMid = false;
      this.$data.editingContent.homeTitleBot = false;
      this.$data.editingContent.homeDynamicText1 = false;
      this.$data.editingContent.homeDynamicText2 = false;
      this.$data.editingContent.homeDynamicText3 = false;
      this.$data.editingContent.aboutTitleTop = false;
      this.$data.editingContent.aboutTitleMid = false;
      this.$data.editingContent.aboutTitleBot = false;
      this.$data.editingContent.aboutDynamicText1 = false;
      this.$data.editingContent.aboutDynamicText2 = false;
      this.$data.editingContent.aboutWhyUsTitle1 = false;
      this.$data.editingContent.aboutWhyUsDescription1 = false;
      this.$data.editingContent.aboutWhyUsTitle2 = false;
      this.$data.editingContent.aboutWhyUsDescription2 = false;
      this.$data.editingContent.aboutWhyUsTitle3 = false;
      this.$data.editingContent.aboutWhyUsDescription3 = false;
      this.$data.editingContent.aboutWhyUsTitle4 = false;
      this.$data.editingContent.aboutWhyUsDescription4 = false;
      this.$data.editingContent.visionMissionTitle1 = false;
      this.$data.editingContent.visionMissionDescription1 = false;
      this.$data.editingContent.visionMissionTitle2 = false;
      this.$data.editingContent.visionMissionDescription2 = false;
      this.$data.editingContent.visionMissionTitle3 = false;
      this.$data.editingContent.visionMissionDescription3 = false;
      this.$data.editingContent.visionMissionTitle4 = false;
      this.$data.editingContent.visionMissionDescription4 = false;
      this.$data.editingContent.visionMissionTitle5 = false;
      this.$data.editingContent.visionMissionDescription5 = false;
      this.$data.editingContent.visionMissionTitle6 = false;
      this.$data.editingContent.visionMissionDescription6 = false;
      this.$data.editingContent.visionMissionTitle7 = false;
      this.$data.editingContent.visionMissionDescription7 = false;
      this.$data.editingContent.visionMissionTitle8 = false;
      this.$data.editingContent.visionMissionDescription8 = false;
      this.$data.editingContent.serviceTitleTop = false;
      this.$data.editingContent.serviceTitleMid = false;
      this.$data.editingContent.serviceTitleBot = false;
      this.$data.editingContent.serviceDynamicText1 = false;
      this.$data.editingContent.serviceDynamicText2 = false;
      this.$data.editingContent.serviceDynamicText3 = false;
      this.$data.editingContent.serviceDynamicText4 = false;
      this.$data.editingContent.serviceDynamicText5 = false;
      this.$data.editingContent.serviceDynamicText6 = false;
      this.$data.editingContent.serviceDynamicText7 = false;
      this.$data.editingContent.serviceDynamicText8 = false;
      this.$data.editingContent.serviceDynamicText9 = false;
      this.$data.editingContent.serviceDynamicText10 = false;
      this.$data.editingContent.serviceDynamicText11 = false;
      this.$data.editingContent.serviceDynamicText12 = false;
      this.$data.editingContent.serviceDynamicText13 = false;
      this.$data.editingContent.projectTitleTop = false;
      this.$data.editingContent.projectTitleMid = false;
      this.$data.editingContent.projectTitleBot = false;
      this.$data.editingContent.productTitleTop = false;
      this.$data.editingContent.productTitleMid = false;
      this.$data.editingContent.productTitleBot = false;
      this.$data.editingContent.contactTitleMid = false;
      this.$data.editingContent.contactTitleBot = false;
      this.$data.editingContent.contactDynamicText1 = false;
      this.$data.editingContent.contactDynamicText2 = false;
      this.$data.editingContent.contactDynamicText3 = false;
      this.$data.editingContent.contactDynamicText4 = false;
      this.$data.editingContent.aboutUsFooter = false;
      this.$data.editingContent.subscribeFooter = false;
      this.$data.editingContent.socialMediaFooter = false;
    },
    editContent: function editContent(id) {
      if (id === 'cPhoneNumber') {
        this.$data.editingPhoneNumber = true;
      } else if (id === 'homeTitleTop') {
        this.$data.editingContent.homeTitleTop = true;
      } else if (id === 'homeTitleMid') {
        this.$data.editingContent.homeTitleMid = true;
      } else if (id === 'homeTitleBot') {
        this.$data.editingContent.homeTitleBot = true;
      } else if (id === 'homeDynamicText1') {
        this.$data.editingContent.homeDynamicText1 = true;
      } else if (id === 'homeDynamicText2') {
        this.$data.editingContent.homeDynamicText2 = true;
      } else if (id === 'homeDynamicText3') {
        this.$data.editingContent.homeDynamicText3 = true;
      } else if (id === 'aboutTitleTop') {
        this.$data.editingContent.aboutTitleTop = true;
      } else if (id === 'aboutTitleMid') {
        this.$data.editingContent.aboutTitleMid = true;
      } else if (id === 'aboutTitleBot') {
        this.$data.editingContent.aboutTitleBot = true;
      } else if (id === 'aboutDynamicText1') {
        this.$data.editingContent.aboutDynamicText1 = true;
      } else if (id === 'aboutDynamicText2') {
        this.$data.editingContent.aboutDynamicText2 = true;
      } else if (id === 'aboutWhyUsTitle1') {
        this.$data.editingContent.aboutWhyUsTitle1 = true;
      } else if (id === 'aboutWhyUsDescription1') {
        this.$data.editingContent.aboutWhyUsDescription1 = true;
      } else if (id === 'aboutWhyUsTitle2') {
        this.$data.editingContent.aboutWhyUsTitle2 = true;
      } else if (id === 'aboutWhyUsDescription2') {
        this.$data.editingContent.aboutWhyUsDescription2 = true;
      } else if (id === 'aboutWhyUsTitle3') {
        this.$data.editingContent.aboutWhyUsTitle3 = true;
      } else if (id === 'aboutWhyUsDescription3') {
        this.$data.editingContent.aboutWhyUsDescription3 = true;
      } else if (id === 'aboutWhyUsTitle4') {
        this.$data.editingContent.aboutWhyUsTitle4 = true;
      } else if (id === 'aboutWhyUsDescription4') {
        this.$data.editingContent.aboutWhyUsDescription4 = true;
      } else if (id === 'visionMissionTitle1') {
        this.$data.editingContent.visionMissionTitle1 = true;
      } else if (id === 'visionMissionDescription1') {
        this.$data.editingContent.visionMissionDescription1 = true;
      } else if (id === 'visionMissionTitle2') {
        this.$data.editingContent.visionMissionTitle2 = true;
      } else if (id === 'visionMissionDescription2') {
        this.$data.editingContent.visionMissionDescription2 = true;
      } else if (id === 'visionMissionTitle3') {
        this.$data.editingContent.visionMissionTitle3 = true;
      } else if (id === 'visionMissionDescription3') {
        this.$data.editingContent.visionMissionDescription3 = true;
      } else if (id === 'visionMissionTitle4') {
        this.$data.editingContent.visionMissionTitle4 = true;
      } else if (id === 'visionMissionDescription4') {
        this.$data.editingContent.visionMissionDescription4 = true;
      } else if (id === 'visionMissionTitle5') {
        this.$data.editingContent.visionMissionTitle5 = true;
      } else if (id === 'visionMissionDescription5') {
        this.$data.editingContent.visionMissionDescription5 = true;
      } else if (id === 'visionMissionTitle6') {
        this.$data.editingContent.visionMissionTitle6 = true;
      } else if (id === 'visionMissionDescription6') {
        this.$data.editingContent.visionMissionDescription6 = true;
      } else if (id === 'visionMissionTitle7') {
        this.$data.editingContent.visionMissionTitle7 = true;
      } else if (id === 'visionMissionDescription7') {
        this.$data.editingContent.visionMissionDescription7 = true;
      } else if (id === 'visionMissionTitle8') {
        this.$data.editingContent.visionMissionTitle8 = true;
      } else if (id === 'visionMissionDescription8') {
        this.$data.editingContent.visionMissionDescription8 = true;
      } else if (id === 'serviceTitleTop') {
        this.$data.editingContent.serviceTitleTop = true;
      } else if (id === 'serviceTitleMid') {
        this.$data.editingContent.serviceTitleMid = true;
      } else if (id === 'serviceTitleBot') {
        this.$data.editingContent.serviceTitleBot = true;
      } else if (id === 'serviceDynamicText1') {
        this.$data.editingContent.serviceDynamicText1 = true;
      } else if (id === 'serviceDynamicText2') {
        this.$data.editingContent.serviceDynamicText2 = true;
      } else if (id === 'serviceDynamicText3') {
        this.$data.editingContent.serviceDynamicText3 = true;
      } else if (id === 'serviceDynamicText4') {
        this.$data.editingContent.serviceDynamicText4 = true;
      } else if (id === 'serviceDynamicText5') {
        this.$data.editingContent.serviceDynamicText5 = true;
      } else if (id === 'serviceDynamicText6') {
        this.$data.editingContent.serviceDynamicText6 = true;
      } else if (id === 'serviceDynamicText7') {
        this.$data.editingContent.serviceDynamicText7 = true;
      } else if (id === 'serviceDynamicText8') {
        this.$data.editingContent.serviceDynamicText8 = true;
      } else if (id === 'serviceDynamicText9') {
        this.$data.editingContent.serviceDynamicText9 = true;
      } else if (id === 'serviceDynamicText10') {
        this.$data.editingContent.serviceDynamicText10 = true;
      } else if (id === 'serviceDynamicText11') {
        this.$data.editingContent.serviceDynamicText11 = true;
      } else if (id === 'serviceDynamicText12') {
        this.$data.editingContent.serviceDynamicText12 = true;
      } else if (id === 'serviceDynamicText13') {
        this.$data.editingContent.serviceDynamicText13 = true;
      } else if (id === 'projectTitleTop') {
        this.$data.editingContent.projectTitleTop = true;
      } else if (id === 'projectTitleMid') {
        this.$data.editingContent.projectTitleMid = true;
      } else if (id === 'projectTitleBot') {
        this.$data.editingContent.projectTitleBot = true;
      } else if (id === 'productTitleTop') {
        this.$data.editingContent.productTitleTop = true;
      } else if (id === 'productTitleMid') {
        this.$data.editingContent.productTitleMid = true;
      } else if (id === 'productTitleBot') {
        this.$data.editingContent.productTitleBot = true;
      } else if (id === 'contactTitleMid') {
        this.$data.editingContent.contactTitleMid = true;
      } else if (id === 'contactTitleBot') {
        this.$data.editingContent.contactTitleBot = true;
      } else if (id === 'contactDynamicText1') {
        this.$data.editingContent.contactDynamicText1 = true;
      } else if (id === 'contactDynamicText2') {
        this.$data.editingContent.contactDynamicText2 = true;
      } else if (id === 'contactDynamicText3') {
        this.$data.editingContent.contactDynamicText3 = true;
      } else if (id === 'contactDynamicText4') {
        this.$data.editingContent.contactDynamicText4 = true;
      } else if (id === 'aboutUsFooter') {
        this.$data.editingContent.aboutUsFooter = true;
      } else if (id === 'subscribeFooter') {
        this.$data.editingContent.subscribeFooter = true;
      } else if (id === 'socialMediaFooter') {
        this.$data.editingContent.socialMediaFooter = true;
      }
    },
    getImage: function getImage(imageName, section) {
      return __WEBPACK_IMPORTED_MODULE_1__util___default.a.getImage(imageName, section);
    },
    toast: function toast(msg, type, icon) {
      this.$toasted.show(msg, {
        theme: 'bubble',
        position: 'top-center',
        fullWidth: true,
        type: type,
        icon: icon,
        duration: 2000
      });
    },
    saveContentById: function saveContentById(key, value) {
      var _this = this;

      var id = this.getIdByKey(key);
      this.$data.isLoading = true;
      if (this.validateContent(value)) {
        this.$store.dispatch('saveContentById', {
          data: {
            id: id,
            content: { value: value },
            token: this.$cookies.get('a').jwt
          },
          success: function success(res) {
            _this.toast('Edit success.', 'success', 'check');
          },
          fail: function fail() {
            console.log('Edit failed.');
          }
        }).then(function () {
          _this.$data.isLoading = false;
          _this.editingToFalse();
        }).catch(function (err) {
          console.error('error: ' + err);
        });
      } else {
        this.toast(this.$data.errors[0], 'error', 'error_outline');
        this.isLoading = false;
      }
    },
    validateContent: function validateContent(value) {
      if (value === '' || value.trim() === '') {
        this.$data.errors.push('Kolom tidak boleh kosong');
        return false;
      } else {
        return true;
      }
    },
    validatePhoneNumber: function validatePhoneNumber(data) {
      return true;
    },
    findContentById: function findContentById(id) {
      var _this2 = this;

      this.$data.isLoading = true;
      this.$store.dispatch('findContentById', {
        data: {
          id: id
        },
        success: function success() {},
        fail: function fail() {
          _this2.toast('Something went wrong. Try again later.', 'error', 'error_outline');
        }
      }).then(function () {
        _this2.$data.isLoading = false;
      }).catch(function (err) {
        console.error('error: ' + err);
      });
    },
    findAllContents: function findAllContents() {
      var _this3 = this;

      this.isLoading = true;
      this.$store.dispatch('findAllContents', {
        success: function success(res) {},
        fail: function fail() {
          _this3.toast('Could not get contents. Try again later.', 'error', 'error_outline');
        }
      }).then(function () {
        _this3.isLoading = false;
      }).catch(function (err) {
        console.error('error: ' + err);
      });
    },
    getIdByKey: function getIdByKey(key) {
      if (key === 'homeTitleTop') {
        return this.homeTitleTopId;
      } else if (key === 'cPhoneNumber') {
        return this.phoneNumberId;
      } else if (key === 'homeTitleTop') {
        return this.homeTitleTopId;
      } else if (key === 'homeTitleMid') {
        return this.homeTitleMidId;
      } else if (key === 'homeTitleBot') {
        return this.homeTitleBotId;
      } else if (key === 'homeDynamicText1') {
        return this.homeDynamicText1Id;
      } else if (key === 'homeDynamicText2') {
        return this.homeDynamicText2Id;
      } else if (key === 'homeDynamicText3') {
        return this.homeDynamicText3Id;
      } else if (key === 'aboutTitleTop') {
        return this.aboutTitleTopId;
      } else if (key === 'aboutTitleMid') {
        return this.aboutTitleMidId;
      } else if (key === 'aboutTitleBot') {
        return this.aboutTitleBotId;
      } else if (key === 'aboutDynamicText1') {
        return this.aboutDynamicText1Id;
      } else if (key === 'aboutDynamicText2') {
        return this.aboutDynamicText2Id;
      } else if (key === 'aboutWhyUsTitle1') {
        return this.aboutWhyUsTitle1Id;
      } else if (key === 'aboutWhyUsDescription1') {
        return this.aboutWhyUsDescription1Id;
      } else if (key === 'aboutWhyUsTitle2') {
        return this.aboutWhyUsTitle2Id;
      } else if (key === 'aboutWhyUsDescription2') {
        return this.aboutWhyUsDescription2Id;
      } else if (key === 'aboutWhyUsTitle3') {
        return this.aboutWhyUsTitle3Id;
      } else if (key === 'aboutWhyUsDescription3') {
        return this.aboutWhyUsDescription3Id;
      } else if (key === 'aboutWhyUsTitle4') {
        return this.aboutWhyUsTitle4Id;
      } else if (key === 'aboutWhyUsDescription4') {
        return this.aboutWhyUsDescription4Id;
      } else if (key === 'visionMissionTitle1') {
        return this.visionMissionTitle1Id;
      } else if (key === 'visionMissionDescription1') {
        return this.visionMissionDescription1Id;
      } else if (key === 'visionMissionTitle2') {
        return this.visionMissionTitle2Id;
      } else if (key === 'visionMissionDescription2') {
        return this.visionMissionDescription2Id;
      } else if (key === 'visionMissionTitle3') {
        return this.visionMissionTitle3Id;
      } else if (key === 'visionMissionDescription3') {
        return this.visionMissionDescription3Id;
      } else if (key === 'visionMissionTitle4') {
        return this.visionMissionTitle4Id;
      } else if (key === 'visionMissionDescription4') {
        return this.visionMissionDescription4Id;
      } else if (key === 'visionMissionTitle5') {
        return this.visionMissionTitle5Id;
      } else if (key === 'visionMissionDescription5') {
        return this.visionMissionDescription5Id;
      } else if (key === 'visionMissionTitle6') {
        return this.visionMissionTitle6Id;
      } else if (key === 'visionMissionDescription6') {
        return this.visionMissionDescription6Id;
      } else if (key === 'visionMissionTitle7') {
        return this.visionMissionTitle7Id;
      } else if (key === 'visionMissionDescription7') {
        return this.visionMissionDescription7Id;
      } else if (key === 'visionMissionTitle8') {
        return this.visionMissionTitle8Id;
      } else if (key === 'visionMissionDescription8') {
        return this.visionMissionDescription8Id;
      } else if (key === 'serviceTitleTop') {
        return this.serviceTitleTopId;
      } else if (key === 'serviceTitleMid') {
        return this.serviceTitleMidId;
      } else if (key === 'serviceTitleBot') {
        return this.serviceTitleBotId;
      } else if (key === 'serviceDynamicText1') {
        return this.serviceDynamicText1Id;
      } else if (key === 'serviceDynamicText2') {
        return this.serviceDynamicText2Id;
      } else if (key === 'serviceDynamicText3') {
        return this.serviceDynamicText3Id;
      } else if (key === 'serviceDynamicText4') {
        return this.serviceDynamicText4Id;
      } else if (key === 'serviceDynamicText5') {
        return this.serviceDynamicText5Id;
      } else if (key === 'serviceDynamicText6') {
        return this.serviceDynamicText6Id;
      } else if (key === 'serviceDynamicText7') {
        return this.serviceDynamicText7Id;
      } else if (key === 'serviceDynamicText8') {
        return this.serviceDynamicText8Id;
      } else if (key === 'serviceDynamicText9') {
        return this.serviceDynamicText9Id;
      } else if (key === 'serviceDynamicText10') {
        return this.serviceDynamicText10Id;
      } else if (key === 'serviceDynamicText11') {
        return this.serviceDynamicText11Id;
      } else if (key === 'serviceDynamicText12') {
        return this.serviceDynamicText12Id;
      } else if (key === 'serviceDynamicText13') {
        return this.serviceDynamicText13Id;
      } else if (key === 'projectTitleTop') {
        return this.projectTitleTopId;
      } else if (key === 'projectTitleMid') {
        return this.projectTitleMidId;
      } else if (key === 'projectTitleBot') {
        return this.projectTitleBotId;
      } else if (key === 'productTitleTop') {
        return this.productTitleTopId;
      } else if (key === 'productTitleMid') {
        return this.productTitleMidId;
      } else if (key === 'productTitleBot') {
        return this.productTitleBotId;
      } else if (key === 'contactTitleMid') {
        return this.contactTitleMidId;
      } else if (key === 'contactTitleBot') {
        return this.contactTitleBotId;
      } else if (key === 'contactDynamicText1') {
        return this.contactDynamicText1Id;
      } else if (key === 'contactDynamicText2') {
        return this.contactDynamicText2Id;
      } else if (key === 'contactDynamicText3') {
        return this.contactDynamicText3Id;
      } else if (key === 'contactDynamicText4') {
        return this.contactDynamicText4Id;
      } else if (key === 'aboutUsFooter') {
        return this.aboutUsFooterId;
      } else if (key === 'subscribeFooter') {
        return this.subscribeFooterId;
      } else if (key === 'socialMediaFooter') {
        return this.socialMediaFooterId;
      }
    }
  },
  created: function created() {
    this.findAllContents();
    // this.findPhoneNumber()
    // this.findContentById('homeTitleTop')
    // this.findContentById('homeTitleMid')
    // this.findContentById('homeTitleBot')
    // this.findContentById('homeDynamicText1')
    // this.findContentById('homeDynamicText2')
    // this.findContentById('homeDynamicText3')
    // this.findContentById('aboutTitleTop')
    // this.findContentById('aboutTitleMid')
    // this.findContentById('aboutTitleBot')
    // this.findContentById('aboutDynamicText1')
    // this.findContentById('aboutDynamicText2')
    // this.findContentById('aboutWhyUsTitle1')
    // this.findContentById('aboutWhyUsDescription1')
    // this.findContentById('aboutWhyUsTitle2')
    // this.findContentById('aboutWhyUsDescription2')
    // this.findContentById('aboutWhyUsTitle3')
    // this.findContentById('aboutWhyUsDescription3')
    // this.findContentById('aboutWhyUsTitle4')
    // this.findContentById('aboutWhyUsDescription4')
    // this.findContentById('visionMissionTitle1')
    // this.findContentById('visionMissionDescription1')
    // this.findContentById('visionMissionTitle2')
    // this.findContentById('visionMissionDescription2')
    // this.findContentById('visionMissionTitle3')
    // this.findContentById('visionMissionDescription3')
    // this.findContentById('visionMissionTitle4')
    // this.findContentById('visionMissionDescription4')
    // this.findContentById('visionMissionTitle5')
    // this.findContentById('visionMissionDescription5')
    // this.findContentById('visionMissionTitle6')
    // this.findContentById('visionMissionDescription6')
    // this.findContentById('visionMissionTitle7')
    // this.findContentById('visionMissionDescription7')
    // this.findContentById('visionMissionTitle8')
    // this.findContentById('visionMissionDescription8')
    // this.findContentById('serviceTitleTop')
    // this.findContentById('serviceTitleMid')
    // this.findContentById('serviceTitleBot')
    // this.findContentById('serviceDynamicText1')
    // this.findContentById('serviceDynamicText2')
    // this.findContentById('serviceDynamicText3')
    // this.findContentById('serviceDynamicText4')
    // this.findContentById('serviceDynamicText5')
    // this.findContentById('serviceDynamicText6')
    // this.findContentById('serviceDynamicText7')
    // this.findContentById('serviceDynamicText8')
    // this.findContentById('serviceDynamicText9')
    // this.findContentById('serviceDynamicText10')
    // this.findContentById('serviceDynamicText11')
    // this.findContentById('serviceDynamicText12')
    // this.findContentById('serviceDynamicText13')
    // this.findContentById('projectTitleTop')
    // this.findContentById('projectTitleMid')
    // this.findContentById('projectTitleBot')
    // this.findContentById('productTitleTop')
    // this.findContentById('productTitleMid')
    // this.findContentById('productTitleBot')
    // this.findContentById('contactTitleMid')
    // this.findContentById('contactTitleBot')
    // this.findContentById('contactDynamicText1')
    // this.findContentById('contactDynamicText2')
    // this.findContentById('contactDynamicText3')
    // this.findContentById('contactDynamicText4')
    // this.findContentById('aboutUsFooter')
    // this.findContentById('subscribeFooter')
    // this.findContentById('socialMediaFooter')
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['phoneNumber', 'phoneNumberId', 'homeTitleTop', 'homeTitleTopId', 'homeTitleMid', 'homeTitleBot', 'homeDynamicText1', 'homeDynamicText2', 'homeDynamicText3', 'aboutTitleTop', 'aboutTitleMid', 'aboutTitleBot', 'aboutDynamicText1', 'aboutDynamicText2', 'aboutWhyUsTitle1', 'aboutWhyUsDescription1', 'aboutWhyUsTitle2', 'aboutWhyUsDescription2', 'aboutWhyUsTitle3', 'aboutWhyUsDescription3', 'aboutWhyUsTitle4', 'aboutWhyUsDescription4', 'visionMissionTitle1', 'visionMissionDescription1', 'visionMissionTitle2', 'visionMissionDescription2', 'visionMissionTitle3', 'visionMissionDescription3', 'visionMissionTitle4', 'visionMissionDescription4', 'visionMissionTitle5', 'visionMissionDescription5', 'visionMissionTitle6', 'visionMissionDescription6', 'visionMissionTitle7', 'visionMissionDescription7', 'visionMissionTitle8', 'visionMissionDescription8', 'serviceTitleTop', 'serviceTitleMid', 'serviceTitleBot', 'serviceDynamicText1', 'serviceDynamicText2', 'serviceDynamicText3', 'serviceDynamicText4', 'serviceDynamicText5', 'serviceDynamicText6', 'serviceDynamicText7', 'serviceDynamicText8', 'serviceDynamicText9', 'serviceDynamicText10', 'serviceDynamicText11', 'serviceDynamicText12', 'serviceDynamicText13', 'projectTitleTop', 'projectTitleMid', 'projectTitleBot', 'productTitleTop', 'productTitleMid', 'productTitleBot', 'contactTitleMid', 'contactTitleBot', 'contactDynamicText1', 'contactDynamicText2', 'contactDynamicText3', 'contactDynamicText4', 'aboutUsFooter', 'subscribeFooter', 'socialMediaFooter', 'homeTitleMidId', 'homeTitleBotId', 'homeDynamicText1Id', 'homeDynamicText2Id', 'homeDynamicText3Id', 'aboutTitleTopId', 'aboutTitleMidId', 'aboutTitleBotId', 'aboutDynamicText1Id', 'aboutDynamicText2Id', 'aboutWhyUsTitle1Id', 'aboutWhyUsDescription1Id', 'aboutWhyUsTitle2Id', 'aboutWhyUsDescription2Id', 'aboutWhyUsTitle3Id', 'aboutWhyUsDescription3Id', 'aboutWhyUsTitle4Id', 'aboutWhyUsDescription4Id', 'visionMissionTitle1Id', 'visionMissionDescription1Id', 'visionMissionTitle2Id', 'visionMissionDescription2Id', 'visionMissionTitle3Id', 'visionMissionDescription3Id', 'visionMissionTitle4Id', 'visionMissionDescription4Id', 'visionMissionTitle5Id', 'visionMissionDescription5Id', 'visionMissionTitle6Id', 'visionMissionDescription6Id', 'visionMissionTitle7Id', 'visionMissionDescription7Id', 'visionMissionTitle8Id', 'visionMissionDescription8Id', 'serviceTitleTopId', 'serviceTitleMidId', 'serviceTitleBotId', 'serviceDynamicText1Id', 'serviceDynamicText2Id', 'serviceDynamicText3Id', 'serviceDynamicText4Id', 'serviceDynamicText5Id', 'serviceDynamicText6Id', 'serviceDynamicText7Id', 'serviceDynamicText8Id', 'serviceDynamicText9Id', 'serviceDynamicText10Id', 'serviceDynamicText11Id', 'serviceDynamicText12Id', 'serviceDynamicText13Id', 'projectTitleTopId', 'projectTitleMidId', 'projectTitleBotId', 'productTitleTopId', 'productTitleMidId', 'productTitleBotId', 'contactTitleMidId', 'contactTitleBotId', 'contactDynamicText1Id', 'contactDynamicText2Id', 'contactDynamicText3Id', 'contactDynamicText4Id', 'aboutUsFooterId', 'subscribeFooterId', 'socialMediaFooterId'])),
  watch: {
    homeTitleTop: function homeTitleTop(val) {
      this.$data.mHomeTitleTop = val;
    },
    phoneNumber: function phoneNumber(val) {
      this.$data.mphoneNumber = val;
    },
    homeTitleMid: function homeTitleMid(val) {
      this.$data.mhomeTitleMid = val;
    },
    homeTitleBot: function homeTitleBot(val) {
      this.$data.mhomeTitleBot = val;
    },
    homeDynamicText1: function homeDynamicText1(val) {
      this.$data.mhomeDynamicText1 = val;
    },
    homeDynamicText2: function homeDynamicText2(val) {
      this.$data.mhomeDynamicText2 = val;
    },
    homeDynamicText3: function homeDynamicText3(val) {
      this.$data.mhomeDynamicText3 = val;
    },
    aboutTitleTop: function aboutTitleTop(val) {
      this.$data.maboutTitleTop = val;
    },
    aboutTitleMid: function aboutTitleMid(val) {
      this.$data.maboutTitleMid = val;
    },
    aboutTitleBot: function aboutTitleBot(val) {
      this.$data.maboutTitleBot = val;
    },
    aboutDynamicText1: function aboutDynamicText1(val) {
      this.$data.maboutDynamicText1 = val;
    },
    aboutDynamicText2: function aboutDynamicText2(val) {
      this.$data.maboutDynamicText2 = val;
    },
    aboutWhyUsTitle1: function aboutWhyUsTitle1(val) {
      this.$data.maboutWhyUsTitle1 = val;
    },
    aboutWhyUsDescription1: function aboutWhyUsDescription1(val) {
      this.$data.maboutWhyUsDescription1 = val;
    },
    aboutWhyUsTitle2: function aboutWhyUsTitle2(val) {
      this.$data.maboutWhyUsTitle2 = val;
    },
    aboutWhyUsDescription2: function aboutWhyUsDescription2(val) {
      this.$data.maboutWhyUsDescription2 = val;
    },
    aboutWhyUsTitle3: function aboutWhyUsTitle3(val) {
      this.$data.maboutWhyUsTitle3 = val;
    },
    aboutWhyUsDescription3: function aboutWhyUsDescription3(val) {
      this.$data.maboutWhyUsDescription3 = val;
    },
    aboutWhyUsTitle4: function aboutWhyUsTitle4(val) {
      this.$data.maboutWhyUsTitle4 = val;
    },
    aboutWhyUsDescription4: function aboutWhyUsDescription4(val) {
      this.$data.maboutWhyUsDescription4 = val;
    },
    visionMissionTitle1: function visionMissionTitle1(val) {
      this.$data.mvisionMissionTitle1 = val;
    },
    visionMissionDescription1: function visionMissionDescription1(val) {
      this.$data.mvisionMissionDescription1 = val;
    },
    visionMissionTitle2: function visionMissionTitle2(val) {
      this.$data.mvisionMissionTitle2 = val;
    },
    visionMissionDescription2: function visionMissionDescription2(val) {
      this.$data.mvisionMissionDescription2 = val;
    },
    visionMissionTitle3: function visionMissionTitle3(val) {
      this.$data.mvisionMissionTitle3 = val;
    },
    visionMissionDescription3: function visionMissionDescription3(val) {
      this.$data.mvisionMissionDescription3 = val;
    },
    visionMissionTitle4: function visionMissionTitle4(val) {
      this.$data.mvisionMissionTitle4 = val;
    },
    visionMissionDescription4: function visionMissionDescription4(val) {
      this.$data.mvisionMissionDescription4 = val;
    },
    visionMissionTitle5: function visionMissionTitle5(val) {
      this.$data.mvisionMissionTitle5 = val;
    },
    visionMissionDescription5: function visionMissionDescription5(val) {
      this.$data.mvisionMissionDescription5 = val;
    },
    visionMissionTitle6: function visionMissionTitle6(val) {
      this.$data.mvisionMissionTitle6 = val;
    },
    visionMissionDescription6: function visionMissionDescription6(val) {
      this.$data.mvisionMissionDescription6 = val;
    },
    visionMissionTitle7: function visionMissionTitle7(val) {
      this.$data.mvisionMissionTitle7 = val;
    },
    visionMissionDescription7: function visionMissionDescription7(val) {
      this.$data.mvisionMissionDescription7 = val;
    },
    visionMissionTitle8: function visionMissionTitle8(val) {
      this.$data.mvisionMissionTitle8 = val;
    },
    visionMissionDescription8: function visionMissionDescription8(val) {
      this.$data.mvisionMissionDescription8 = val;
    },
    serviceTitleTop: function serviceTitleTop(val) {
      this.$data.mserviceTitleTop = val;
    },
    serviceTitleMid: function serviceTitleMid(val) {
      this.$data.mserviceTitleMid = val;
    },
    serviceTitleBot: function serviceTitleBot(val) {
      this.$data.mserviceTitleBot = val;
    },
    serviceDynamicText1: function serviceDynamicText1(val) {
      this.$data.mserviceDynamicText1 = val;
    },
    serviceDynamicText2: function serviceDynamicText2(val) {
      this.$data.mserviceDynamicText2 = val;
    },
    serviceDynamicText3: function serviceDynamicText3(val) {
      this.$data.mserviceDynamicText3 = val;
    },
    serviceDynamicText4: function serviceDynamicText4(val) {
      this.$data.mserviceDynamicText4 = val;
    },
    serviceDynamicText5: function serviceDynamicText5(val) {
      this.$data.mserviceDynamicText5 = val;
    },
    serviceDynamicText6: function serviceDynamicText6(val) {
      this.$data.mserviceDynamicText6 = val;
    },
    serviceDynamicText7: function serviceDynamicText7(val) {
      this.$data.mserviceDynamicText7 = val;
    },
    serviceDynamicText8: function serviceDynamicText8(val) {
      this.$data.mserviceDynamicText8 = val;
    },
    serviceDynamicText9: function serviceDynamicText9(val) {
      this.$data.mserviceDynamicText9 = val;
    },
    serviceDynamicText10: function serviceDynamicText10(val) {
      this.$data.mserviceDynamicText10 = val;
    },
    serviceDynamicText11: function serviceDynamicText11(val) {
      this.$data.mserviceDynamicText11 = val;
    },
    serviceDynamicText12: function serviceDynamicText12(val) {
      this.$data.mserviceDynamicText12 = val;
    },
    serviceDynamicText13: function serviceDynamicText13(val) {
      this.$data.mserviceDynamicText13 = val;
    },
    projectTitleTop: function projectTitleTop(val) {
      this.$data.mprojectTitleTop = val;
    },
    productTitleTop: function productTitleTop(val) {
      this.$data.mproductTitleTop = val;
    },
    productTitleMid: function productTitleMid(val) {
      this.$data.mproductTitleMid = val;
    },
    productTitleBot: function productTitleBot(val) {
      this.$data.mproductTitleBot = val;
    },
    projectTitleMid: function projectTitleMid(val) {
      this.$data.mprojectTitleMid = val;
    },
    projectTitleBot: function projectTitleBot(val) {
      this.$data.mprojectTitleBot = val;
    },
    contactTitleMid: function contactTitleMid(val) {
      this.$data.mcontactTitleMid = val;
    },
    contactTitleBot: function contactTitleBot(val) {
      this.$data.mcontactTitleBot = val;
    },
    contactDynamicText1: function contactDynamicText1(val) {
      this.$data.mcontactDynamicText1 = val;
    },
    contactDynamicText2: function contactDynamicText2(val) {
      this.$data.mcontactDynamicText2 = val;
    },
    contactDynamicText3: function contactDynamicText3(val) {
      this.$data.mcontactDynamicText3 = val;
    },
    contactDynamicText4: function contactDynamicText4(val) {
      this.$data.mcontactDynamicText4 = val;
    },
    aboutUsFooter: function aboutUsFooter(val) {
      this.$data.maboutUsFooter = val;
    },
    subscribeFooter: function subscribeFooter(val) {
      this.$data.msubscribeFooter = val;
    },
    socialMediaFooter: function socialMediaFooter(val) {
      this.$data.msocialMediaFooter = val;
    }
  }
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__util__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AddProduct',
  data: function data() {
    return {
      isLoading: false,
      errors: [],
      productSection: 'products',
      product: {
        name: '',
        description: ''
      },
      image: null,
      productImage: {}
    };
  },

  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    filesChange: function filesChange(filename, file) {
      this.$data.image = file;
    },
    addProduct: function addProduct() {
      var _this = this;

      if (this.validateProduct(this.$data.product)) {
        this.$store.dispatch('createProduct', {
          data: {
            product: this.$data.product,
            token: this.$cookies.get('a').jwt
          },
          success: function success(res) {
            _this.toast('Product added.', 'success', 'check');
            _this.uploadFile(res.body.data.id, _this.$data.image);
          },
          fail: function fail() {
            _this.toast('Something went wrong. Try again later.', 'error', 'error_outline');
          }
        });
      } else {
        this.toast(this.$data.errors[0], 'error', 'error_outline');
        this.isLoading = false;
      }
    },
    uploadFile: function uploadFile(id, files) {
      var _this2 = this;

      var fileToUpload = {
        files: files,
        refId: id,
        ref: 'api::dsk-product.dsk-product',
        field: 'image'
      };
      this.$store.dispatch('uploadFile', {
        data: {
          file: fileToUpload,
          token: this.$cookies.get('a').jwt
        },
        success: function success(res) {
          _this2.$router.push('/dproducts');
        },
        fail: function fail() {
          _this2.toast('Image upload failed.', 'error', 'error_outline');
        }
      }).then(function () {}).catch(function (err) {
        console.error('error: ' + err);
      });
    },
    validateProduct: function validateProduct(product) {
      if (this.$data.image == null) {
        this.toast('Please upload an image', 'error', 'error_outline');
        return false;
      } else if (this.$data.product.name === '' || this.$data.product.name.trim() === '' || this.$data.product.description === '' || this.$data.product.description.trim() === '') {
        this.toast('Please fill in the fields', 'error', 'error_outline');
        return false;
      } else {
        return true;
      }
    },
    getImage: function getImage(imageName, section) {
      return __WEBPACK_IMPORTED_MODULE_0__util___default.a.getImage(imageName, section);
    },
    toast: function toast(msg, type, icon) {
      this.$toasted.show(msg, {
        theme: 'bubble',
        position: 'top-center',
        fullWidth: true,
        type: type,
        icon: icon,
        duration: 2000
      });
    }
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'EditProduct',
  data: function data() {
    return {
      isLoading: false,
      errors: [],
      productSection: 'products',
      image: null,
      productImage: {}
    };
  },

  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    filesChange: function filesChange(filename, file) {
      console.log('filename: ' + filename + '. file: ' + file);
      this.$data.image = file;
    },
    findProductById: function findProductById(id) {
      var _this = this;

      this.$data.isLoading = true;
      this.$store.dispatch('findProductById', {
        data: {
          id: id
        },
        success: function success(res) {},
        fail: function fail() {
          _this.toast('Something went wrong. Try again later.', 'error', 'error_outline');
          console.log('failed get product by id');
          _this.$router.push('/dproducts');
        }
      }).then(function () {
        _this.isLoading = false;
      }).catch(function (err) {
        console.error('error: ' + err);
      });
    },
    editProduct: function editProduct(product) {
      var _this2 = this;

      // if (this.$data.image.name !== undefined) {
      //   if (product.images[0] != null) {
      //     product.deleteImages = [product.images[0].id]
      //   }
      //   product.images = this.$data.image
      // }
      if (this.validateProduct(product)) {
        this.$store.dispatch('editProduct', {
          data: {
            id: product.id,
            product: {
              name: product.attributes.name,
              description: product.attributes.description
            },
            token: this.$cookies.get('a').jwt
          },
          success: function success() {
            if (_this2.$data.image != null) {
              _this2.uploadFile(product.id, _this2.$data.image);
              var deleteImageId = product.attributes.image.data.id;
              _this2.deleteFile(deleteImageId);
            } else {
              _this2.$router.push('/dproducts');
            }
            _this2.toast('Edit success.', 'success', 'check');
          },
          fail: function fail() {
            _this2.toast('Edit failed. Try again later.', 'error', 'error_outline');
          }
        });
      } else {
        this.toast(this.$data.errors[0], 'error', 'error_outline');
        this.isLoading = false;
      }
    },
    validateProduct: function validateProduct(product) {
      return true;
    },
    deleteFile: function deleteFile(id) {
      var _this3 = this;

      this.$store.dispatch('deleteFile', {
        data: {
          id: id,
          token: this.$cookies.get('a').jwt
        },
        success: function success(res) {
          _this3.$router.push('/dproducts');
        },
        fail: function fail() {
          _this3.toast('Image delete failed.', 'error', 'error_outline');
        }
      }).then(function () {}).catch(function (err) {
        console.error('error: ' + err);
      });
    },
    uploadFile: function uploadFile(id, files) {
      var _this4 = this;

      var fileToUpload = {
        files: files,
        refId: id,
        ref: 'api::dsk-product.dsk-product',
        field: 'image'
      };
      this.$store.dispatch('uploadFile', {
        data: {
          file: fileToUpload,
          token: this.$cookies.get('a').jwt
        },
        success: function success(res) {},
        fail: function fail() {
          _this4.toast('Image upload failed.', 'error', 'error_outline');
        }
      }).then(function () {}).catch(function (err) {
        console.error('error: ' + err);
      });
    },
    getImage: function getImage(imageName, section) {
      return __WEBPACK_IMPORTED_MODULE_1__util___default.a.getImage(imageName, section);
    },
    toast: function toast(msg, type, icon) {
      this.$toasted.show(msg, {
        theme: 'bubble',
        position: 'top-center',
        fullWidth: true,
        type: type,
        icon: icon,
        duration: 2000
      });
    }
  },
  created: function created() {
    this.findProductById(this.$route.params.id);
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['editingProduct']))
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__util__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AddProject',
  data: function data() {
    return {
      isLoading: false,
      errors: [],
      project: {
        name: '',
        city: '',
        description: ''
      },
      image: {}
    };
  },

  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    filesChange: function filesChange(filename, file) {
      this.$data.image = file;
    },
    addProject: function addProject() {
      var _this = this;

      if (this.validateProject(this.$data.project)) {
        this.$store.dispatch('createProject', {
          data: {
            project: this.$data.project,
            token: this.$cookies.get('a').jwt
          },
          success: function success(res) {
            _this.toast('Project successfully added', 'success', 'check');
            _this.uploadFile(res.body.data.id, _this.$data.image);
          },
          fail: function fail() {
            console.log('failed add project');
          }
        });
      } else {
        this.toast(this.$data.errors[0], 'error', 'error_outline');
        this.isLoading = false;
      }
    },
    uploadFile: function uploadFile(id, files) {
      var _this2 = this;

      var fileToUpload = {
        files: files,
        refId: id,
        ref: 'api::dsk-project.dsk-project',
        field: 'images'
      };
      this.$store.dispatch('uploadFile', {
        data: {
          file: fileToUpload,
          token: this.$cookies.get('a').jwt
        },
        success: function success(res) {
          _this2.$router.push('/dprojects');
        },
        fail: function fail() {
          _this2.toast('Image upload failed.', 'error', 'error_outline');
        }
      }).then(function () {}).catch(function (err) {
        console.error('error: ' + err);
      });
    },
    validateProject: function validateProject(project) {
      return true;
    },
    getImage: function getImage(imageName, section) {
      return __WEBPACK_IMPORTED_MODULE_0__util___default.a.getImage(imageName, section);
    },
    toast: function toast(msg, type, icon) {
      this.$toasted.show(msg, {
        theme: 'bubble',
        position: 'top-center',
        fullWidth: true,
        type: type,
        icon: icon,
        duration: 2000
      });
    }
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__util__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AddClient',
  data: function data() {
    return {
      isLoading: false,
      errors: [],
      client: {
        name: ''
      },
      image: null
    };
  },

  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    filesChange: function filesChange(filename, file) {
      this.$data.image = file;
    },
    addClient: function addClient() {
      var _this = this;

      if (this.validateClient(this.$data.client)) {
        this.$store.dispatch('createClient', {
          data: {
            client: this.$data.client,
            token: this.$cookies.get('a').jwt
          },
          success: function success(res) {
            _this.uploadFile(res.body.data.id, _this.$data.image);
          },
          fail: function fail() {
            console.log('failed add client');
          }
        });
      } else {
        this.toast(this.$data.errors[0], 'error', 'error_outline');
        this.isLoading = false;
      }
    },
    uploadFile: function uploadFile(id, files) {
      var _this2 = this;

      var fileToUpload = {
        files: files,
        refId: id,
        ref: 'api::dsk-client.dsk-client',
        field: 'image'
      };
      this.$store.dispatch('uploadFile', {
        data: {
          file: fileToUpload,
          token: this.$cookies.get('a').jwt
        },
        success: function success(res) {
          _this2.toast('Client successfully added', 'success', 'check');
          _this2.$router.push('/dclients');
        },
        fail: function fail() {
          _this2.toast('Image upload failed.', 'error', 'error_outline');
        }
      }).then(function () {}).catch(function (err) {
        console.error('error: ' + err);
      });
    },
    validateClient: function validateClient(client) {
      if (client.name === '' || client.name.trim() === '' || this.$data.image == null) {
        this.toast('Please fill in all fields', 'error', 'error_outline');
        return false;
      } else {
        return true;
      }
    },
    getImage: function getImage(imageName, section) {
      return __WEBPACK_IMPORTED_MODULE_0__util___default.a.getImage(imageName, section);
    },
    toast: function toast(msg, type, icon) {
      this.$toasted.show(msg, {
        theme: 'bubble',
        position: 'top-center',
        fullWidth: true,
        type: type,
        icon: icon,
        duration: 2000
      });
    }
  }
});

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'EditProject',
  data: function data() {
    return {
      isLoading: false,
      errors: [],
      image: null,
      projectImage: {}
    };
  },

  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    filesChange: function filesChange(filename, file) {
      this.$data.image = file;
    },
    findProjectById: function findProjectById(id) {
      var _this = this;

      this.$data.isLoading = true;
      this.$store.dispatch('findProjectById', {
        data: {
          id: id
        },
        success: function success() {},
        fail: function fail() {
          _this.toast('Something went wrong. Try again later.', 'error', 'error_outline');
          console.log('failed get project by id');
          _this.$router.push('/dprojects');
        }
      }).then(function () {
        _this.isLoading = false;
      }).catch(function (err) {
        console.error('error: ' + err);
      });
    },
    editProject: function editProject(project) {
      var _this2 = this;

      if (this.validateProject(project)) {
        this.$store.dispatch('editProject', {
          data: {
            id: project.id,
            project: {
              name: project.attributes.name,
              city: project.attributes.city,
              description: project.attributes.description
            },
            token: this.$cookies.get('a').jwt
          },
          success: function success(res) {
            if (_this2.$data.image != null) {
              _this2.uploadFile(project.id, _this2.$data.image);
              var deleteImageId = project.attributes.images.data[0].id;
              _this2.deleteFile(deleteImageId);
            }
            _this2.toast('Edit success.', 'success', 'check');
            _this2.$router.push('/dprojects');
          },
          fail: function fail() {
            _this2.toast('Edit failed. Try again later.', 'error', 'error_outline');
          }
        });
      } else {
        this.toast(this.$data.errors[0], 'error', 'error_outline');
        this.isLoading = false;
      }
    },
    deleteFile: function deleteFile(id) {
      var _this3 = this;

      this.$store.dispatch('deleteFile', {
        data: {
          id: id,
          token: this.$cookies.get('a').jwt
        },
        success: function success(res) {},
        fail: function fail() {
          _this3.toast('Image upload failed.', 'error', 'error_outline');
        }
      }).then(function () {}).catch(function (err) {
        console.error('error: ' + err);
      });
    },
    uploadFile: function uploadFile(id, files) {
      var _this4 = this;

      var fileToUpload = {
        files: files,
        refId: id,
        ref: 'api::dsk-project.dsk-project',
        field: 'images'
      };
      this.$store.dispatch('uploadFile', {
        data: {
          file: fileToUpload,
          token: this.$cookies.get('a').jwt
        },
        success: function success(res) {},
        fail: function fail() {
          _this4.toast('Image upload failed.', 'error', 'error_outline');
        }
      }).then(function () {}).catch(function (err) {
        console.error('error: ' + err);
      });
    },
    validateProject: function validateProject(project) {
      if (project.attributes.name === '' || project.attributes.name.trim() === '' || project.attributes.city === '' || project.attributes.city.trim() === '' || project.attributes.description === '' || project.attributes.city.trim() === '') {
        this.$data.errors.push('Semua kolom wajib diisi');
        return false;
      }
      return true;
    },
    getImage: function getImage(imageName, section) {
      return __WEBPACK_IMPORTED_MODULE_1__util___default.a.getImage(imageName, section);
    },
    toast: function toast(msg, type, icon) {
      this.$toasted.show(msg, {
        theme: 'bubble',
        position: 'top-center',
        fullWidth: true,
        type: type,
        icon: icon,
        duration: 2000
      });
    }
  },
  created: function created() {
    this.findProjectById(this.$route.params.id);
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['editingProject']))
});

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Inquiries',
  data: function data() {
    return {
      isLoading: false,
      inquiries1: [{
        id: '1',
        name: 'Budi',
        email: 'budi@gmail.com',
        phoneNumber: '08528909991',
        inquiry: 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
        service: 'Construction'
      }, {
        id: '2',
        name: 'Dodi',
        email: 'dodi@yahoo.com',
        phoneNumber: '08528909392',
        inquiry: 'The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters.',
        service: 'Repairment'
      }, {
        id: '3',
        name: 'Ekanda',
        email: 'ekanda@commerce.com',
        phoneNumber: '08123458909',
        inquiry: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        service: 'Repairment'
      }, {
        id: '4',
        name: 'Fendi',
        email: 'fendi@yahoo.com',
        phoneNumber: '08123423423',
        inquiry: 'Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.',
        service: 'Construction'
      }, {
        id: '5',
        name: 'Gilang',
        email: 'gilang@mail.com',
        phoneNumber: '08528909392',
        inquiry: 'quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.',
        service: 'Repairment'
      }]
    };
  },

  methods: {
    getAllInquiries: function getAllInquiries(page) {
      var _this = this;

      this.isLoading = true;
      this.$store.dispatch('getAllInquiries', {
        data: {
          page: page
        },
        success: function success(res) {},
        fail: function fail() {
          _this.toast('Could not get inquiries. Try again later.', 'error', 'error_outline');
        }
      }).then(function () {
        _this.isLoading = false;
      }).catch(function (err) {
        console.error('error: ' + err);
      });
    },
    getImage: function getImage(imageName, section) {
      return __WEBPACK_IMPORTED_MODULE_1__util___default.a.getImage(imageName, section);
    },
    toast: function toast(msg, type, icon) {
      this.$toasted.show(msg, {
        theme: 'bubble',
        position: 'top-center',
        fullWidth: true,
        type: type,
        icon: icon,
        duration: 2000
      });
    }
  },
  created: function created() {
    this.getAllInquiries(0);
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['inquiries']))
});

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__util__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'incomingContactForms',
  data: function data() {
    return {
      lists: [{
        id: '1',
        name: 'Budi',
        email: 'budi@gmail.com',
        phoneNumber: '08528909991',
        message: 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
        subject: 'Construction'
      }, {
        id: '2',
        name: 'Dodi',
        email: 'dodi@yahoo.com',
        phoneNumber: '08528909392',
        message: 'The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters.',
        subject: 'Repairment'
      }, {
        id: '3',
        name: 'Ekanda',
        email: 'ekanda@commerce.com',
        phoneNumber: '08123458909',
        message: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        subject: 'Repairment'
      }, {
        id: '4',
        name: 'Fendi',
        email: 'fendi@yahoo.com',
        phoneNumber: '08123423423',
        message: 'Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.',
        subject: 'Construction'
      }, {
        id: '5',
        name: 'Gilang',
        email: 'gilang@mail.com',
        phoneNumber: '08528909392',
        message: 'quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.',
        subject: 'Repairment'
      }]
    };
  },

  methods: {
    getImage: function getImage(imageName, section) {
      return __WEBPACK_IMPORTED_MODULE_0__util___default.a.getImage(imageName, section);
    },
    toast: function toast(msg, type, icon) {
      this.$toasted.show(msg, {
        theme: 'bubble',
        position: 'top-center',
        fullWidth: true,
        type: type,
        icon: icon,
        duration: 2000
      });
    }
  }
});

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'EmailSubscriber',
  data: function data() {
    return {};
  },

  methods: {
    getImage: function getImage(imageName, section) {
      return __WEBPACK_IMPORTED_MODULE_1__util___default.a.getImage(imageName, section);
    },
    toast: function toast(msg, type, icon) {
      this.$toasted.show(msg, {
        theme: 'bubble',
        position: 'top-center',
        fullWidth: true,
        type: type,
        icon: icon,
        duration: 2000
      });
    },
    findAllSubscribers: function findAllSubscribers(page) {
      var _this = this;

      this.$store.dispatch('findAllSubscribers', {
        data: {
          page: page
        },
        success: function success(res) {
          console.log('success');
        },
        fail: function fail(res) {
          _this.toast('Something went wrong. Try again later.', 'error', 'error_outline');
        }
      }).then(function () {
        _this.isLoading = false;
      }).catch(function (err) {
        console.error('error: ' + err);
      });
    },
    unsubscribe: function unsubscribe(email) {
      var _this2 = this;

      this.$store.dispatch('unsubscribe', {
        data: {
          email: email
          // ,
          // success: (res) => {
          //   this.toast('Email removed.', 'success', 'check')
          // },
          // fail: (res) => {
          //   this.toast('Something went wrong. Try again later.', 'error', 'error_outline')
          // }
        } }).then(function () {
        _this2.isLoading = false;
        _this2.toast('Email removed.', 'success', 'check');
      }).catch(function (err) {
        console.error('error: ' + err);
      });
    }
  },
  created: function created() {
    this.findAllSubscribers(0);
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['subscribers']))
});

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_trix__ = __webpack_require__(305);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// doc: https://githubcom/basecamp/trix#readme



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ComposeEmail',
  data: function data() {
    return {
      emailSubject: '',
      emailContent: '',
      showConfirmationBox: false
    };
  },

  components: {
    VueTrix: __WEBPACK_IMPORTED_MODULE_1_vue_trix__["a" /* default */]
  },
  methods: {
    resetForm: function resetForm() {
      this.$data.emailSubject = '';
      this.$data.emailContent = '';
      var element = document.querySelector('trix-editor');
      element.editor.element.value = '';
    },
    showBox: function showBox() {
      this.showConfirmationBox = true;
    },
    hideBox: function hideBox() {
      this.showConfirmationBox = false;
    },
    getImage: function getImage(imageName, section) {
      return __WEBPACK_IMPORTED_MODULE_0__util___default.a.getImage(imageName, section);
    },
    blastEmail: function blastEmail() {
      this.toast('Blasted!' + this.$data.emailContent, 'success', 'check');
      this.showConfirmationBox = false;
      this.resetForm();
    },
    toast: function toast(msg, type, icon) {
      this.$toasted.show(msg, {
        theme: 'bubble',
        position: 'top-center',
        fullWidth: true,
        type: type,
        icon: icon,
        duration: 2000
      });
    }
  }
});

/***/ }),
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(442)));

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(446)));

/***/ }),
/* 170 */,
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(450)));

/***/ }),
/* 172 */,
/* 173 */,
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(455)));

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_store__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_material__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_material___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_material__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_toasted__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_toasted___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_toasted__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_animate_number__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_animate_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_animate_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_observe_visibility__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_material_dist_vue_material_min_css__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_material_dist_vue_material_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_material_dist_vue_material_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue2_google_maps__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue2_google_maps__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.














__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_material___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_toasted___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_animate_number___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_observe_visibility__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vue2_google_maps__, {
  load: {
    key: 'AIzaSyB6WgsrW4qoG-VsD5txgHyt588m7CuFA9U', // only mock
    libraries: 'places'
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

var app = void 0;
/* eslint-disable no-new */
if (!app) {
  /* eslint-disable no-new */
  app = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: '#app',
    store: __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */],
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
    render: function render(h) {
      return h(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);
    }
  });
}

/***/ }),
/* 176 */,
/* 177 */,
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(48);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16bb6bd6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(210);
function injectStyle (ssrContext) {
  __webpack_require__(179)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16bb6bd6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 179 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/spinner.4979b47.gif";

/***/ }),
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('header',[_c('md-toolbar',{staticClass:"md-primary"},[(_vm.showHamburgerMenu)?_c('md-button',{staticClass:"md-icon-button",on:{"click":function($event){_vm.showNavigation = true}}},[_c('md-icon',[_vm._v("menu")])],1):_vm._e(),_vm._v(" "),_c('span',{staticClass:"md-title",on:{"click":_vm.goToHomepage}},[(!_vm.showHamburgerMenu)?_c('img',{class:{dskLogoDesktop: !_vm.showHamburgerMenu},staticStyle:{"width":"50px"},attrs:{"src":__webpack_require__(54),"alt":"Duta Sarana Konstruksi"}}):_vm._e(),_vm._v("\n        PT. Duta Sarana Konstruksi\n      ")]),_vm._v(" "),(!_vm.showHamburgerMenu)?_c('div',{staticClass:"md-toolbar-section-end"},[(!_vm.isOffice)?_c('div',{staticClass:"top-menu",class:{topMenuSelected:(_vm.title == 'Homepage')},on:{"click":_vm.goToHomepage}},[_vm._v("Beranda")]):_vm._e(),_vm._v(" "),(!_vm.isOffice)?_c('div',{staticClass:"top-menu",class:{topMenuSelected:(_vm.title == 'About')},on:{"click":_vm.goToAbout}},[_vm._v("Tentang Kami")]):_vm._e(),_vm._v(" "),(!_vm.isOffice)?_c('div',{staticClass:"top-menu",class:{topMenuSelected:(_vm.title == 'Projects')},on:{"click":_vm.goToProjects}},[_vm._v("Portofolio")]):_vm._e(),_vm._v(" "),(!_vm.isOffice)?_c('div',{staticClass:"top-menu",class:{topMenuSelected:(_vm.title == 'Products')},on:{"click":_vm.goToProducts}},[_vm._v("Produk")]):_vm._e(),_vm._v(" "),(!_vm.isOffice)?_c('div',{staticClass:"top-menu",class:{topMenuSelected:(_vm.title == 'Contact')},on:{"click":_vm.goToContact}},[_vm._v("Hubungi Kami")]):_vm._e(),_vm._v(" "),(_vm.isOffice)?_c('div',{staticClass:"top-menu",class:{topMenuSelected:(_vm.title == 'Logout')},on:{"click":_vm.goToLogout}},[_vm._v("Keluar")]):_vm._e()]):_vm._e()],1),_vm._v(" "),(!_vm.isOffice)?_c('md-drawer',{attrs:{"md-active":_vm.showNavigation},on:{"update:mdActive":function($event){_vm.showNavigation=$event}}},[_c('md-toolbar',{staticClass:"md-transparent drawer-title",attrs:{"md-elevation":"0"}},[_c('span',{staticClass:"md-title"},[_vm._v("Duta Sarana Konstruksi")])]),_vm._v(" "),_c('md-list',[_c('md-list-item',{on:{"click":_vm.goToHomepage}},[_c('md-icon',[_vm._v("home")]),_vm._v(" "),_c('span',{staticClass:"md-list-item-text"},[_vm._v("Beranda")])],1),_vm._v(" "),_c('md-list-item',{on:{"click":_vm.goToAbout}},[_c('md-icon',[_vm._v("chat_bubble_outline")]),_vm._v(" "),_c('span',{staticClass:"md-list-item-text"},[_vm._v("Tentang Kami")])],1),_vm._v(" "),_c('md-list-item',{on:{"click":_vm.goToProjects}},[_c('md-icon',[_vm._v("work_outline")]),_vm._v(" "),_c('span',{staticClass:"md-list-item-text"},[_vm._v("Portofolio")])],1),_vm._v(" "),_c('md-list-item',{on:{"click":_vm.goToProducts}},[_c('md-icon',[_vm._v("widgets")]),_vm._v(" "),_c('span',{staticClass:"md-list-item-text"},[_vm._v("Produk")])],1),_vm._v(" "),_c('md-list-item',{on:{"click":_vm.goToContact}},[_c('md-icon',[_vm._v("help_outline")]),_vm._v(" "),_c('span',{staticClass:"md-list-item-text"},[_vm._v("Hubungi Kami")])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.isOffice)?_c('md-drawer',{staticClass:"officeDrawer",attrs:{"md-active":_vm.showNavigation,"md-permanent":_vm.type},on:{"update:mdActive":function($event){_vm.showNavigation=$event}}},[_c('md-toolbar',{staticClass:"md-transparent drawer-title",attrs:{"md-elevation":"0"}},[_c('span',{staticClass:"md-title"},[_vm._v("Office Menu")])]),_vm._v(" "),_c('md-list',[_c('md-list-item',{on:{"click":_vm.goToDashboard}},[_c('md-icon',[_vm._v("dashboard")]),_vm._v(" "),_c('span',{staticClass:"md-list-item-text"},[_vm._v("Dashboard")])],1),_vm._v(" "),_c('md-list-item',{on:{"click":_vm.goToDProjects}},[_c('md-icon',[_vm._v("work")]),_vm._v(" "),_c('span',{staticClass:"md-list-item-text"},[_vm._v("Portofolio")])],1),_vm._v(" "),_c('md-list-item',{on:{"click":_vm.goToDProducts}},[_c('md-icon',[_vm._v("category")]),_vm._v(" "),_c('span',{staticClass:"md-list-item-text"},[_vm._v("Produk")])],1),_vm._v(" "),_c('md-list-item',{on:{"click":_vm.goToDClients}},[_c('md-icon',[_vm._v("category")]),_vm._v(" "),_c('span',{staticClass:"md-list-item-text"},[_vm._v("Client")])],1),_vm._v(" "),_c('md-list-item',{on:{"click":_vm.goToSettings}},[_c('md-icon',[_vm._v("settings")]),_vm._v(" "),_c('span',{staticClass:"md-list-item-text"},[_vm._v("Pengaturan")])],1),_vm._v(" "),_c('md-list-item',{on:{"click":_vm.goToLogout}},[_c('md-icon',[_vm._v("logout")]),_vm._v(" "),_c('span',{staticClass:"md-list-item-text"},[_vm._v("Keluar")])],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('main',{class:{needMarginLeft: (_vm.isOffice && !_vm.showHamburgerMenu)},staticStyle:{"overflow":"hidden"}},[_c('router-view')],1),_vm._v(" "),_c('footer',[_c('b-container',{staticClass:"template",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticClass:"mb-5",attrs:{"lg":"5","md":"5","sm":"12","xs":"12"}},[_c('div',{staticClass:"mb-4"},[_c('h4',[_vm._v("Tentang Kami")])]),_vm._v(" "),_c('div',{staticClass:"text-justify"},[_vm._v("\n            "+_vm._s(_vm.aboutUsFooter)+"\n          ")])]),_vm._v(" "),_c('b-col',{staticClass:"mb-5",attrs:{"lg":"5","md":"5","sm":"12","xs":"12"}}),_vm._v(" "),_c('b-col',{staticClass:"mb-5",attrs:{"lg":"2","md":"2","sm":"12","xs":"12"}},[_c('div',{staticClass:"mb-4"},[_c('h4',[_vm._v("Ikuti Kami")])]),_vm._v(" "),_c('div',[_vm._v("\n            "+_vm._s(_vm.socialMediaFooter)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"socialMedia"},[_c('img',{staticClass:"fb",attrs:{"src":__webpack_require__(55),"alt":"Facebook"}}),_vm._v(" "),_c('img',{staticClass:"twitter",attrs:{"src":__webpack_require__(56),"alt":"Twitter"}})])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"lg":"12","md":"12","sm":"12","xs":"12"}},[_c('div',[_vm._v("\n            Copyright © 2024 All rights reserved.\n          ")])])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cookies__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_cookies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Hello__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Homepage__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_About__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Service__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Projects__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Products__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ContactUs__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Login__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Dashboard__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_DProducts__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_DProjects__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_DClients__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Settings__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_AddProduct__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_EditProduct__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_AddProject__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_AddClient__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_EditProject__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Inquiries__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_IncomingContactForms__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_EmailSubscribers__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_ComposeEmail__ = __webpack_require__(303);
/* global gtag */



























__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_cookies___default.a);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Homepage',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Homepage__["a" /* default */]
  }, {
    path: '*',
    name: 'All',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Homepage__["a" /* default */]
  }, {
    path: '/hello',
    name: 'Hello',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Hello__["a" /* default */]
  }, {
    path: '/about',
    name: 'About',
    component: __WEBPACK_IMPORTED_MODULE_5__components_About__["a" /* default */]
  }, {
    path: '/service',
    name: 'Service',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Service__["a" /* default */]
  }, {
    path: '/projects',
    name: 'Projects',
    component: __WEBPACK_IMPORTED_MODULE_7__components_Projects__["a" /* default */]
  }, {
    path: '/products',
    name: 'Products',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Products__["a" /* default */]
  }, {
    path: '/contact',
    name: 'ContactUs',
    component: __WEBPACK_IMPORTED_MODULE_9__components_ContactUs__["a" /* default */]
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_10__components_Login__["a" /* default */]
  }, {
    path: '/dashboard',
    name: 'Dashboard',
    component: __WEBPACK_IMPORTED_MODULE_11__components_Dashboard__["a" /* default */],
    meta: {
      auth: true
    }
  }, {
    path: '/dproducts',
    name: 'DProducts',
    component: __WEBPACK_IMPORTED_MODULE_12__components_DProducts__["a" /* default */],
    meta: {
      auth: true
    }
  }, {
    path: '/dclients',
    name: 'DClients',
    component: __WEBPACK_IMPORTED_MODULE_14__components_DClients__["a" /* default */],
    meta: {
      auth: true
    }
  }, {
    path: '/dprojects',
    name: 'DProjects',
    component: __WEBPACK_IMPORTED_MODULE_13__components_DProjects__["a" /* default */],
    meta: {
      auth: true
    }
  }, {
    path: '/editproject/:id',
    name: 'EditProject',
    component: __WEBPACK_IMPORTED_MODULE_20__components_EditProject__["a" /* default */],
    props: true,
    meta: {
      auth: true
    }
  }, {
    path: '/settings',
    name: 'Settings',
    component: __WEBPACK_IMPORTED_MODULE_15__components_Settings__["a" /* default */],
    meta: {
      auth: true
    }
  }, {
    path: '/addproduct',
    name: 'AddProduct',
    component: __WEBPACK_IMPORTED_MODULE_16__components_AddProduct__["a" /* default */],
    meta: {
      auth: true
    }
  }, {
    path: '/editproduct/:id',
    name: 'EditProduct',
    component: __WEBPACK_IMPORTED_MODULE_17__components_EditProduct__["a" /* default */],
    props: true,
    meta: {
      auth: true
    }
  }, {
    path: '/addProject',
    name: 'AddProject',
    component: __WEBPACK_IMPORTED_MODULE_18__components_AddProject__["a" /* default */],
    meta: {
      auth: true
    }
  }, {
    path: '/addClient',
    name: 'AddClient',
    component: __WEBPACK_IMPORTED_MODULE_19__components_AddClient__["a" /* default */],
    meta: {
      auth: true
    }
  }, {
    path: '/inquiries',
    name: 'Inquiries',
    component: __WEBPACK_IMPORTED_MODULE_21__components_Inquiries__["a" /* default */],
    meta: {
      auth: true
    }
  }, {
    path: '/contactforms',
    name: 'IncomingContactForms',
    component: __WEBPACK_IMPORTED_MODULE_22__components_IncomingContactForms__["a" /* default */],
    meta: {
      auth: true
    }
  }, {
    path: '/subscribers',
    name: 'EmailSubscribers',
    component: __WEBPACK_IMPORTED_MODULE_23__components_EmailSubscribers__["a" /* default */],
    meta: {
      auth: true
    }
  }, {
    path: '/composeemail',
    name: 'ComposeEmail',
    component: __WEBPACK_IMPORTED_MODULE_24__components_ComposeEmail__["a" /* default */],
    meta: {
      auth: true
    }
  }]
});

router.beforeEach(function (to, from, next) {
  if (to.meta.auth) {
    if (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].cookies.get('uses') === null || __WEBPACK_IMPORTED_MODULE_0_vue__["default"].cookies.get('uses') === undefined) {} else {
      next();
    }
  } else {
    next();
  }
});

router.afterEach(function (to, from) {
  if (to.path === '/contact') {
    if (typeof gtag !== 'undefined') {
      console.log('[Google Ads] Firing conversion event');
      gtag('event', 'conversion', {
        'send_to': 'AW-17042046818/K0JsCPLXoL8aEOL-o74_',
        'value': 1.0,
        'currency': 'IDR'
      });
    } else {
      console.warn('gtag not defined yet');
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 212 */,
/* 213 */,
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__ = __webpack_require__(57);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f9ce4b7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__ = __webpack_require__(216);
function injectStyle (ssrContext) {
  __webpack_require__(215)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f9ce4b7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 215 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('h1',[_vm._v(_vm._s(_vm.msg))]),_vm._v(" "),_c('h2',{on:{"click":_vm.goToHomepage}},[_vm._v("Go to homepage")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('h2',[_vm._v("Ecosystem")]),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_c('a',{attrs:{"href":"https://vuejs.org","target":"_blank","rel":"noopener"}},[_vm._v("Core Docs")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://forum.vuejs.org","target":"_blank","rel":"noopener"}},[_vm._v("Forum")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"http://chat.vuejs.org/","target":"_blank","rel":"noopener"}},[_vm._v("Vue Community Chat")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://twitter.com/vuejs","target":"_blank","rel":"noopener"}},[_vm._v("Twitter")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"http://vuejs-templates.github.io/webpack/","target":"_blank","rel":"noopener"}},[_vm._v("Docs for This Template")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_c('a',{attrs:{"href":"http://router.vuejs.org/","target":"_blank","rel":"noopener"}},[_vm._v("vue-router")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"http://vuex.vuejs.org/","target":"_blank","rel":"noopener"}},[_vm._v("vuex")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"http://vue-loader.vuejs.org/","target":"_blank","rel":"noopener"}},[_vm._v("vue-loader")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://github.com/vuejs/awesome-vue","target":"_blank","rel":"noopener"}},[_vm._v("awesome-vue")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Homepage_vue__ = __webpack_require__(58);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a587192_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Homepage_vue__ = __webpack_require__(245);
function injectStyle (ssrContext) {
  __webpack_require__(218)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2a587192"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Homepage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a587192_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Homepage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 218 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./p1.jpg": 61,
	"./p10.jpg": 62,
	"./p2.jpg": 63,
	"./p3.png": 64,
	"./p4.png": 65,
	"./p5.jpg": 66,
	"./p6.jpg": 67,
	"./p7.jpg": 68,
	"./p8.jpg": 69,
	"./p9.jpg": 70
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 219;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./client-bentara.jpg": 71,
	"./client-egs.png": 72,
	"./client-petrosea.png": 73,
	"./client1.jpg": 74,
	"./client2.jpg": 75,
	"./client3.jpg": 76
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 220;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Bahu shoulder 15 cm & 35 cm DSK.jpg": 77,
	"./Cat walk 120 dsk.jpg": 78,
	"./Horizontal Frame 1,2m.jpg": 79,
	"./Horizontal shore 0,9 meter.jpg": 80,
	"./Horizontal shore 1,2 meter & 0,9 meter - Salin.jpg": 81,
	"./Horizontal shore 1,2 meter.jpg": 82,
	"./Jack base 60cm solid.jpg": 83,
	"./Kuncian siku tembereng (tie rod 50cm).jpg": 84,
	"./Main beam (hollow 50x50) 2,4m,,3.0m,,4.0m.jpg": 85,
	"./Main beam 2,4m (Hollow 50x50 x2,4m).jpg": 86,
	"./Main beam 3.0m (hollow 50x50 x3.0m).jpg": 87,
	"./Main beam 4.0m (hollow 50x50x4.0m).jpg": 88,
	"./Metal Plank 250mm X 2,5m.jpg": 89,
	"./Pipa 40 cm joint sock 20cm.jpg": 90,
	"./Pipa 40cm polos & pipa 40cm joint sock 20cm.jpg": 91,
	"./Pipa 40cm polos.jpg": 92,
	"./Post shore 1,2,3 meter.jpg": 93,
	"./Post shore 1.0 meter.jpg": 94,
	"./Post shore 2.0 meter.jpg": 95,
	"./Post shore 3.0 meter.jpg": 96,
	"./Push pull 3.0m tampak samping.jpg": 97,
	"./Push pull 3.0m.jpg": 98,
	"./Siku tembereng 30-50.jpg": 99,
	"./Sub beam 2,4m (hollow 40x40x2,4m).jpg": 100,
	"./Sub beam 3.0m (hollow 40x40x3.0m).jpg": 101,
	"./Sub beam 4,8m (hollow 40x40x4,8m).jpg": 102,
	"./Sub beam 4,8m,,3.0m,,2,4m (hollow 40x40).jpg": 103,
	"./Suri-suri 170cm tampak samping.jpg": 104,
	"./Suri-suri 170cm.jpg": 105,
	"./Swipel Clamp (Hidup).jpg": 106,
	"./Tangga DSK Versi 2.jpg": 107,
	"./Tangga DSK tampak samping.jpg": 108,
	"./Tangga dsk.jpg": 109,
	"./U- head 60cm hollow DSK.jpg": 110,
	"./U-head 60cm solid.jpg": 111,
	"./Whell 8 inch (Roda Scaffolding 8 x 2).jpg": 112
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 221;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./1.png": 223,
	"./2.png": 113,
	"./clients/client-bentara.jpg": 71,
	"./clients/client-egs.png": 72,
	"./clients/client-petrosea.png": 73,
	"./clients/client1.jpg": 74,
	"./clients/client2.jpg": 75,
	"./clients/client3.jpg": 76,
	"./crane-64.png": 224,
	"./defaultImage.jpeg": 60,
	"./dsk-about-bg.jpg": 225,
	"./dsk-about-bg1.jpg": 226,
	"./dsk-contact-bg.jpg": 227,
	"./dsk-contact-bg1.jpg": 228,
	"./dsk-fact.jpg": 229,
	"./dsk-home-bg.jpg": 230,
	"./dsk-home-bg1.jpg": 231,
	"./dsk-products-bg.jpg": 232,
	"./dsk-projects-bg.jpg": 233,
	"./dsk-projects-bg1.jpg": 234,
	"./dsk-service-bg.jpg": 235,
	"./dsk-service-bg1.jpg": 236,
	"./dsk.jpg": 54,
	"./fb.png": 55,
	"./fonts/GourmetHearth.otf": 237,
	"./formBg.jpg": 238,
	"./hammer256.png": 114,
	"./logo.png": 59,
	"./nail-64.png": 239,
	"./products/Bahu shoulder 15 cm & 35 cm DSK.jpg": 77,
	"./products/Cat walk 120 dsk.jpg": 78,
	"./products/Horizontal Frame 1,2m.jpg": 79,
	"./products/Horizontal shore 0,9 meter.jpg": 80,
	"./products/Horizontal shore 1,2 meter & 0,9 meter - Salin.jpg": 81,
	"./products/Horizontal shore 1,2 meter.jpg": 82,
	"./products/Jack base 60cm solid.jpg": 83,
	"./products/Kuncian siku tembereng (tie rod 50cm).jpg": 84,
	"./products/Main beam (hollow 50x50) 2,4m,,3.0m,,4.0m.jpg": 85,
	"./products/Main beam 2,4m (Hollow 50x50 x2,4m).jpg": 86,
	"./products/Main beam 3.0m (hollow 50x50 x3.0m).jpg": 87,
	"./products/Main beam 4.0m (hollow 50x50x4.0m).jpg": 88,
	"./products/Metal Plank 250mm X 2,5m.jpg": 89,
	"./products/Pipa 40 cm joint sock 20cm.jpg": 90,
	"./products/Pipa 40cm polos & pipa 40cm joint sock 20cm.jpg": 91,
	"./products/Pipa 40cm polos.jpg": 92,
	"./products/Post shore 1,2,3 meter.jpg": 93,
	"./products/Post shore 1.0 meter.jpg": 94,
	"./products/Post shore 2.0 meter.jpg": 95,
	"./products/Post shore 3.0 meter.jpg": 96,
	"./products/Push pull 3.0m tampak samping.jpg": 97,
	"./products/Push pull 3.0m.jpg": 98,
	"./products/Siku tembereng 30-50.jpg": 99,
	"./products/Sub beam 2,4m (hollow 40x40x2,4m).jpg": 100,
	"./products/Sub beam 3.0m (hollow 40x40x3.0m).jpg": 101,
	"./products/Sub beam 4,8m (hollow 40x40x4,8m).jpg": 102,
	"./products/Sub beam 4,8m,,3.0m,,2,4m (hollow 40x40).jpg": 103,
	"./products/Suri-suri 170cm tampak samping.jpg": 104,
	"./products/Suri-suri 170cm.jpg": 105,
	"./products/Swipel Clamp (Hidup).jpg": 106,
	"./products/Tangga DSK Versi 2.jpg": 107,
	"./products/Tangga DSK tampak samping.jpg": 108,
	"./products/Tangga dsk.jpg": 109,
	"./products/U- head 60cm hollow DSK.jpg": 110,
	"./products/U-head 60cm solid.jpg": 111,
	"./products/Whell 8 inch (Roda Scaffolding 8 x 2).jpg": 112,
	"./projects/p1.jpg": 61,
	"./projects/p10.jpg": 62,
	"./projects/p2.jpg": 63,
	"./projects/p3.png": 64,
	"./projects/p4.png": 65,
	"./projects/p5.jpg": 66,
	"./projects/p6.jpg": 67,
	"./projects/p7.jpg": 68,
	"./projects/p8.jpg": 69,
	"./projects/p9.jpg": 70,
	"./repair-64.png": 240,
	"./scaff-64.jpg": 241,
	"./scaffolding-64.png": 242,
	"./sketch-64.png": 243,
	"./sketch256.png": 115,
	"./spinner.gif": 180,
	"./twitter.png": 56,
	"./why-us.png": 116,
	"./why-us1.jpg": 244
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 222;

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1.69ff448.png";

/***/ }),
/* 224 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dsk-about-bg.a25e9f0.jpg";

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dsk-about-bg1.c345225.jpg";

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dsk-contact-bg.912b233.jpg";

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dsk-contact-bg1.a7dc121.jpg";

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dsk-fact.dc5908a.jpg";

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dsk-home-bg.a27796f.jpg";

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dsk-home-bg1.20b27b6.jpg";

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dsk-products-bg.37c4781.jpg";

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dsk-projects-bg.cd51a70.jpg";

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dsk-projects-bg1.1721945.jpg";

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dsk-service-bg.28da733.jpg";

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dsk-service-bg1.44d8061.jpg";

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/GourmetHearth.5eaec03.otf";

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/formBg.330b3bd.jpg";

/***/ }),
/* 239 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAQAAAAAYLlVAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAAHdElNRQfjAQ0PCRxdkZLaAAAEc0lEQVRo3u3ZaYhWVRzH8c84MzhqKU6mlEr0RINigZlmIemU2SKaEEUEmamvWsAXBUoomQWVRaQUke35JlvAKM2lNCtbtd0iqmkic3dwbMYmc7y9mDPPMs99ZtF5rhD+Lhf+92z/7733nHvu/xwK60KLrLfDIVHe0WxxgVrVGmLKFzreLeR8mi86qLoFlTaoU6fONqeHmnO74D4SxTkf5B2RyGGrzVFthFSb4w6RLSptzWpoYqg9T2S1lJQJIlGo8Z3IHVJSFousyuSX5bkfaZUzHfGUxbYXeD57MNy3Bjtgup3eNFhJVn6DmrTdYv2DPWpQl5vfFuB876lU4wZfttM79qG33g6YZEtovn3tx964jFyA/laq9I1J8YXT2uhyA/C53zt03aLphvkA1ONAIYBlUna4OrgfYbRz9fezx2MQuqY99gTrOfsL9f1bRZqNx+nm+y2rgw3poPlfRa4I9jyRV0Eqq5ePdrfyNrVSuaPgbPUiDxrokTCS//W9V0JPPl6AzSJTQR+3GZzJb30FpZbra7teavTBT5ZZbi9ujHFY4jqnYbNtnXwFPVEBZllqjFmtGa0A9xiHIebgR/db4Wg7zU3yOmg0xfudRGhVn3DmAIyxIFx37Bz64aBdqrztNjv16iJElloAlijHDx4o4Pw8/XOuU/hZtdUu9XJIixyTWgDWYalXC975m7GpDSZ70QVgR7sfrmy1AW0BWGhhwQqvm6ifHhr8Cyr0cthfVqLB9V2+5U1qrepqpexhNjc9zOKVGYYVtlkXUreI3NCmZCp+Muo+NRnRcaEeRQSI1yVqzUgGoNwqz+SljneWyckADDHZ7LzUktzLYgKU5LvLV/J94IQDNIYzqLjDkL/z7Occ9lYyADvMsD/Yc4y3FhzydHahYgJIT1RstTW+SHH7wAXODdZA1cEqdaVTkwE4zWc+DvZyG10GZlrroWQA+ik3IA0j2APSVtEBOqWTACcBigmw38F0GF7rqNq4QsX8EtarSgfuNxsUH0mXmW9Cm7TDHg6h9PFqd9pqKhTIl5mT/VkI+qNbAErcZ7cnwRTXmKshDuB+S7DED+AW4zR6tFvuf6gFjgSA+cZab2V+oR6e8D7Ged4ynxiNeX7pFoAymT5WRt76QAA4apa/jXYRZutpU2BOSD3wm53ojV749FjDzGMHSELN4cxTcf+IMnrMtTacSIAVVgQrkhOiJ/UKSlUGa62vvJY8wEt2GQm+NsobyQMMU57+Qc1R8tNxtXq3n0iAsfpmT3/JAyQYnndKJwH+1wDZ6wO5qU2Zy6TWBzJ6QUX2QmdS6wMZ1WfHxq2voBkDw9ncYbOd1yhVeWllrspfH1iDuww3NdjdowE+tTkvdaY1+esDD2syykqlNvgwpqlI5gtWorN7A32z1gcyyqwUhAcCf3rWnaqwKLapGue4Ua1mFabi1w5cnyKFoRA2vHpioBQq2+QHneGQyHsFGpyWs93cGD+xBh3z5vW99rmwYLM3+d4RkSYfubjdu5/Qpe37df8BjIG1QO5MG5AAAAAldEVYdGRhdGU6Y3JlYXRlADIwMTktMDEtMTNUMTQ6MDk6MjgrMDE6MDDFS2yzAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDE5LTAxLTEzVDE0OjA5OjI4KzAxOjAwtBbUDwAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAAASUVORK5CYII="

/***/ }),
/* 240 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/scaff-64.2469562.jpg";

/***/ }),
/* 242 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAABdAAAAXQBljCEAgAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAtfSURBVHic7Zt/kFxVlcc/9/VLMkM2JjXyw6yCRqpEeoOEBUQ2m0BEFAQUlcA6uEkENql1zUIAo6Gn38l5bRhI7WayBVoStaJBSzbRUhSl+CEIAsFVIJukxkVXJhPWJVAT8nNMMul5d/+4t8eel87MdE/3hCr2WzXz+r1777nne/q8e88997ax1qKqM4BHgON5c6AHuFhENgUAxpgLePOQBzjecyYEsNYaX7AJuLRGoeOBB4Es8Avg06PTsSLuAT4GbCsWix8Kw7C3BhkPAjNKnEP/MPDXGcaY+VEU3VmLdoVC4e+SJPk1cCFwlYjcXYucSlDVz+DI9wdB0FooFP5QrYw4jr9orZ3hb4OBf0BSqmStvUNVl9aiZD6f3wLc5m9Xqup7a5GThqqeApSMeXs+n99Yg4yl1to7yh4l8GcDlPCiv94Zx/EXqtYUEJEO4DGgGfjumjVrxtUipwRVDYB1wGTgN0BcrQzPpeTVL5aXGT8L3AR0APfjxgEBMMa8aK3dVm2Hxpgma+1M3Cv2EvD7amWUYRrwHmNMv7V2I1DVe2+MeZe19jR/q8AM4OPAEhFZHaYbiMhyVZ0KLPQNT0vXGQ7W2vLbd/u/UcFamwH+dhS6rPHcflRenjZAs7+uBRaWPf8B8Gi1nQPXAefi5t0VwMGRNgyCIEySZBnwl8BW4CtV9v0h4FNl92v9tbm80iADGGMuUtUrgR3+0R7cu/cpY8zTURR1VKOBqt4HbAZOBt4nItdV0XYVjnwpaNkxTJMBxHG8xFpbIl/igKpeaYy5qNxDjbUWEVkSBMEq/ywB/g1YAnQD38KPCbh5eMSKeEwD5vnP/w78V4PalPA2YJH/rMAC4J24Me5G/MCfJMnNqtoRAgRBYAGMMV3W2mk48hhjiKJouaoaICoTXCuuGaM2ALGILI/jeIH/xkucuqy100qcB70C1trNxph7rLXtOO84oaOjoxloxxkAY8xaa21flcoElMUajWpnjBlvrf2sv23v6Ohottae4O+tMWaZtfZ8nIcBRw6CRFF0p6q+AnwdOG7v3r0/D8NwbrFYdFKsvVlEdtdApuFQ1SnAZwHCMHzr3r17NwDHAYeBG6IoWpeeBdKBkAEQkXVBEHwY2AWcXywWn2i49nWG1/l8YFcQBBeLyDpfZMrrDTKAnwUuBMjn809kMpmZuIHw1MarXHecCnRnMpmZ+Xz+CQBVvdAYc1F5pfQYMBF4TFVXA7eJyG9V9QP4FdQYKV4vbAIubWtr26GqTcDtwE1lK1/gyFegG+ciS4DnCoXC2X7+vXgsNK4zLhaRHYVC4WzgeRwng+M4gLQBNhljLgdeBbJJkjyrqhFVRHBvIBxU1ShJkmeB03GcLsN5xgDSBiCKop8aY+b72xAXTDzeYGUbgV/gdA8BjDHzReRn6UpHGADAWrvHf+wBdgPnlMoOHjxoKrV5IyCl29m4WawHBnEahIoGKENvGIbTKVsINTU1/XDFihUnj1LXukNVT2lqaiqf4x8Nw/AMhlk+D2cAcrncH/fs2fOxskcXFIvFLXEc/32NutYdqjoPt+iaXfb4ilwu98fh2h4RCVbC5MmTyxf4vwHOsdau8yvHRSLSU43C9UJ7e/sJfX199wCf8I9+jVt+jxjDekAahw4dusQY04YLLz8JbI3j+Ipq5YwWcRx/vK+vbyuOfB+QO3ToUNUZ7bQB3quqLUM1mDBhQn8URSuCIDgPl6g4yVr7Y1X95sqVKydVq0C1UNW3qOpaa+2PgBOBLcB5InL7hAkT+odp2wIMStSmDXAa0MUIlr35fP6FlpaWc4B/wa3Yrjtw4MDmQqFwwcjpVAcfpm/GrfETYGVLS8u5IrJpqHYei3DcBqX40mPAPuAtvgOAzFASFy9efAj4QqFQ+HGSJN8GpiVJUgqlcyJSlwDKh7LtuISGwSVa54vIUyNoXuKwwF/3AQOeOsgDrLWP43Z0SuHikC5VQj6f/2Vzc/OZwDe8zJuB51T1r0fSfiio6jm4UPYmHPk1wJkjJA9/5tANfNpzHEB6NWhF5D6gtVpFly5duk9E/gG4Apc2ywLPxnGc37Bhw5CeVAmqGsZxLMBGXCj7CnCZiCwSkf3VygNaReQ+Y8yglPXRZoFasjcAiMgD48ePnw58HxhnrY07OzufUdX3jFSG31F6xlq7HPeargemVwplq0BFTlVPgyPBsmXLdorIXGPMZ3Ch9PuBTar6eVIJiRRMHMc34lz+XGCXMaZVRK4RkdcboWtDDFBCFEXfBc7AnT1oBu5S1YdV9R3puqp6iqo+aq1d7es+FIbhGVEUfa+ROjbUAAAi8j8i8hFgMfAn3IbFFr/bC0Acx/Nx8/kHgV5jzOdE5JKRhLKjxYhC4TrAisjdqvowbqPzPOBeVb0G9yV81NfbCMyLoui/x0ivxntAOUTkd9lsdiaQx01Pl+PIF40xt2Wz2VkiMmbkYYwNANDZ2TkRl7AsnxpDa+2pXV1dx421PhUN0N/f35CkRxzHc3Dv+gIgMcb8K7AaN0Vdf+DAgc2qOnsIETXjaJzSY8C7VfUHmUzmg/XsvFIoGwTBvHw+/7Qv/yHwbeBdwOOq2tHS0pLzoXZdkMlkfqaqj5Haqk97wBm4Je6UenXsQ9kXSIWyJfIAIvJkc3Pz+4Bvep1uef31158rFApn1UsPHKdP4jgOIO0BrxljVgM91to1o+lNVUNjTA5o8/28Yoy5PoqiByvVX7p06T7ghjiO77fWfh34qyRJfhXHsZ5++ul3zJ07d0TrkiGwCHcU8EbcMho40gM2RlHUbq3dMpqefCi7MR3KHo18OaIo+gkwHXcoY5y19sudnZ1PVxNKHwWbReR23FQ7gHrPAsafN3oBl0muKZQVkR4RucoYMw93wOE84IU4jv+JoUPpqlE3A/hQ9ue4gwhNwEO4b73mUDaKont9ZvdR4Dhr7d2q+lClULpW1MUAqroAN73NwaWh/1FELhGR/x2t7Fwu97KIfNgY88/AAdw23ZY4jq8drWwYpQFU9US/374Wl0l6BpghIl+rh3JlsFEU3ZXJZM4C/gOYYq39jqpuaG9vf+toBNdsAJ8S34o7c9cHLMtms7MbGcq2tbW9mM1m/8YYE+Gy0lf19fVtjeP4slplHm0xdNSQNAzDST7nV9o/3OyDmv+sVYlq4KfDgqr+FLgXyFprH1DVb4RhuLx0kqUCKnI6wgNU9XJgg7/9Xbq8WCw+gyOf4I6fnjtW5MshIs/j9v9WARa4oVgsPl2haonDBs9tENIeMB34if/8bBiG11cQ+A7gD0EQzC+P5o4FfNb5Fp+V/hYulB6EMAyvLxaL64EP4LgNOmWe9oDSUZhVU6dOnZ3L5V5OCzTGrJ04ceKZx5p8OfL5/BM+lP5OuiyXy708derU2ThPgdRxn7QBDhtjrhSRWxYuXHi4UmfW2ptvvfXWWn6o0FD4UHpxpbKFCxceFpFbjDFX4gbPAaQN8EgURfc3SMdjDs/tkfJnR3hAulFra+tJ3d3dD+/YsYOuri6eeuqpL82ZM6duq8V64dprr33n9u3bHyjp+eSTT7bNmTPnLypUHdIDKuGkKVOmzGpubmb79u0cPnz4i9RxuVwvWGtPnjx58sympia2bdtGf39/DqhkgEEY85TYGw1vegMMmxYvFov7ent7ewCSJHneWmvDMDzQeNWqQxiGu3t7e3uSJLHW2ucB+vv7h02pDWuA9evXdwEnDFfvWGPdunVbqUHP4Oqrr8729PSctX//fnbt2jV51qxZo/59zxsVra2tF+zevfvt+/fv59VXX337zJkzTwwnTpy4aty4cR957bXX6O7uvjAIgq8ClxxrZRuBSZMmfd8Yc/xLL73Ezp07bx0/fvzON/0g+P8GONYKHGv8H1PyVZTbMbd+AAAAAElFTkSuQmCC"

/***/ }),
/* 243 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAQAAAAAYLlVAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADdcAAA3XAUIom3gAAAAHdElNRQfiCxkQEQCCZrlNAAAEY0lEQVRo3r3ZW4hVVRjA8Z+OjuMlpyzyXhpeehHMKAO1dDCMQJBK06ZAIdShlyihguqpqAcfggjswVJSsjSvD0ZoThh0oUazIm9jY/hQhuYVG8fO6uFc5lz2zHj23s43L/ssvnX+/2+ttfdaZ0+NGx/1mrxrouPO9QKtIsY4JgiCy2b3lDzAyBuC32G41wWXPNhV4hBv+8FVGfemiB/tmOAz/cEqwSUzohJnaRVknBMsSA0/ylFBsKrQ8oLg58rEaToEa4z3TooCIx0RfOWy4PlC60eCWaWJtX4SNEGKAiP8JtihVkORQo1mGZNKU5sE23LXaQlk8cEyKCj087Hgi/LkjYJpqQpk8V/rcE1jkcIBQasx5elHXVWbokAWv1k/TxQpPCwITrijskPGycJ1coFOPAoKNTYIjrszqkvQlppAKb5TYb+g1djoTukJVOJhsSD4PWrwUZYMG3XEFBigzhZLXCtqqzE/J3eoqLXdyvyd1zd2veXw+kj8ek9pd157SdG3m9f5MY0pyG45W8rGM7v02owry35EsCb/IY0RGGOfCbZaXFF9o5NmFxUYEckFsvht8fDJBbL47Z4sWbrXjU8qkMXvsCguPqnABybYaWF8fNRzoJr4xEGvJsHHF6h3j2Zry1qrxsedgpG+tc+E5Ph4AqPsc7ctWpPj40zBKPtMstUSITm++hEYrdkk2+M+dpIK9LXXRDuT3PfJBBpMxpDcD40U8NUKNOIfDXYZlA6+OoE6j7limgMFhWT4QTZYV815YKFgE4ZpEex1Uxf7fU+RPQ8MslcQqrkNG/EXzpprjwYn3Jag+l0aspfFI7DY3yZ30eUW7YLgNbUW2C3Eqj4/AhlBi9NCqUB3sTz3miG4KAjOW9fVSfc6BIIWw7RVCvTvsltzQeCKLR5XFwsuN/cthqGtfA0s8577/VLS1mgiagrvNk7Y4YIppnQDyfjU4S7wuzQ4YK6z+abu74KhMoXKq/nb0GP1okagMi6YY3zVw5yx5/qq73kE0ovy6nMjkNYvo57xkdUnPRPGx9/qGXXqKZ6CGutvyBREDf6qwnLNCdxlo7OC4NFewDPUUiudyQssdUHQbrs3DOwFfD5yT8Jrgg6rjU659ij8S3YaUC4QBM+lDo/CvyUIpmOazzX7Ny/wYS/igwfwbPEiDLE21Z5iewT+nEM5AUYY51RW4MwNwPO9byrw020qCJBbA6e1x95arzfyeEUCg93sD4HNle+vE8UQO/1aUlInvlPgaf/l18AKwR59UsPvF3xX9H3F+E6BWQ46rEOg1o+CN1N5XZXFt0TMfT4i1gCTXRTsN7+rl6mp4SME+uGIqdZ6yMwUxqB4x3vFy2jVlPt3CAoyA81TZ7DCXPWxyAxTjY25GuoML8PzpTkRmcF4J71odR6cRgyx28yK48Zg90XknnIcI61Qp8nQdPD7u9nxuou2kpccvY5PRSAJPgWBZHjahGSL8H3L0SETs/+ApKfiw/5M1J+9/wMtNjYpyM9yuQAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxOC0xMS0yNVQxNjoxNzowMCswMTowMHneEncAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTgtMTEtMjVUMTY6MTc6MDArMDE6MDAIg6rLAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAABJRU5ErkJggg=="

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/why-us1.613641d.jpg";

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticStyle:{"padding":"0px"}},[_c('div',{staticClass:"text-center backgroundImg",style:({background: 'url(' + _vm.getImage(_vm.bannerImg, 'banner') +')'})},[_c('div',{staticClass:"title-top text-uppercase"},[_vm._v(_vm._s(_vm.homeTitleTop))]),_vm._v(" "),_c('div',{staticClass:"title-middle text-uppercase primaryColor"},[_vm._v(_vm._s(_vm.homeTitleMid))]),_vm._v(" "),_c('center',[_c('div',{staticClass:"title-bottom"},[_vm._v(_vm._s(_vm.homeTitleBot))])])],1)])],1),_vm._v(" "),_c('b-row',{staticClass:"sections section1",class:{section1Desktop: !_vm.isMobile}},[_c('b-col',{staticClass:"bcol",attrs:{"lg":"4","md":"4","sm":"12","xs":"12"}},[_c('div',{staticClass:"homeIcon"},[_c('img',{attrs:{"src":__webpack_require__(113),"alt":"We Sketch"}})]),_vm._v(" "),_c('div',{staticClass:"homeIconTitle",class:{homeIconTitleDesktop: !_vm.isMobile}},[_vm._v("\n          Scaffolding Lebih Kokoh\n        ")]),_vm._v(" "),_c('div',{staticClass:"homeIconDesc"},[_vm._v("\n          Kami menyediakan scaffolding yang lebih kokoh untuk segala kebutuhan pembangunan dalam skala kecil maupun besar.\n        ")])]),_vm._v(" "),_c('b-col',{staticClass:"bcol",attrs:{"lg":"4","md":"4","sm":"12","xs":"12"}},[_c('div',{staticClass:"homeIcon"},[_c('img',{attrs:{"src":__webpack_require__(115),"alt":"We Sketch"}})]),_vm._v(" "),_c('div',{staticClass:"homeIconTitle",class:{homeIconTitleDesktop: !_vm.isMobile}},[_vm._v("\n          Biaya Formwork Terencana\n        ")]),_vm._v(" "),_c('div',{staticClass:"homeIconDesc"},[_vm._v("\n          Perencanaan formwork dengan efisiensi tenaga kerja, biaya, dan waktu.\n        ")])]),_vm._v(" "),_c('b-col',{staticClass:"bcol",attrs:{"lg":"4","md":"4","sm":"12","xs":"12"}},[_c('div',{staticClass:"homeIcon"},[_c('img',{attrs:{"src":__webpack_require__(114),"alt":"We Sketch"}})]),_vm._v(" "),_c('div',{staticClass:"homeIconTitle",class:{homeIconTitleDesktop: !_vm.isMobile}},[_vm._v("\n          Penggunaan Kayu & Paku Minimal\n        ")]),_vm._v(" "),_c('div',{staticClass:"homeIconDesc"},[_vm._v("\n          Sistem penyangga bekisting bangunan memenuhi kebutuhan konstruksi dengan penggunaan kayu & paku minimal.\n        ")])])],1),_vm._v(" "),_c('b-row',{staticClass:"sections section2 text-left"},[_c('b-col',{staticClass:"bcol",attrs:{"lg":"8","md":"8","sm":"12","xs":"12"}},[_c('div',{staticClass:"preTitle primaryColor"},[_vm._v("\n          "+_vm._s(_vm.homeDynamicText1)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("\n          "+_vm._s(_vm.homeDynamicText2)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"description"},[_vm._v("\n          "+_vm._s(_vm.homeDynamicText3)+"\n        ")]),_vm._v(" "),_c('div',[_c('button',{staticClass:"goToProductsBtn primaryBtn",on:{"click":function($event){_vm.goToProducts()}}},[_vm._v("Lihat produk kami")])])]),_vm._v(" "),_c('b-col',{staticClass:"bcol quoteForm",style:({background: 'url(' + _vm.getImage(_vm.quoteFormBg, 'banner') +')'}),attrs:{"lg":"4","md":"4","sm":"12","xs":"12"}},[_c('div',{staticClass:"formTitle"},[_vm._v("\n          Hubungi Kami\n        ")]),_vm._v(" "),_c('div',{staticClass:"form"},[(false)?_c('div',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedService),expression:"selectedService"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedService=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.services),function(service,index){return _c('option',{key:index,domProps:{"value":service}},[_vm._v(_vm._s(service))])}))]):_vm._e(),_vm._v(" "),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inquiry.name),expression:"inquiry.name"}],attrs:{"type":"text","placeholder":"Name"},domProps:{"value":(_vm.inquiry.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inquiry, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inquiry.phoneNumber),expression:"inquiry.phoneNumber"}],attrs:{"type":"number","placeholder":"Phone Number"},domProps:{"value":(_vm.inquiry.phoneNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inquiry, "phoneNumber", $event.target.value)}}})]),_vm._v(" "),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inquiry.email),expression:"inquiry.email"}],attrs:{"type":"email","placeholder":"Email"},domProps:{"value":(_vm.inquiry.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inquiry, "email", $event.target.value)}}})]),_vm._v(" "),_c('div',[_c('button',{staticClass:"primaryBtn",on:{"click":function($event){_vm.createInquiry()}}},[_vm._v("Kirim")])])])])],1),_vm._v(" "),(false)?_c('b-row',{staticClass:"sections section3"},[_c('b-col',{staticClass:"bcol",attrs:{"lg":"3","md":"3","sm":"3","xs":"1"}},[_c('center',[_c('div',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:({callback: _vm.visibilityChanged1, once: true}),expression:"{callback: visibilityChanged1, once: true}"}],staticClass:"anumber"},[_c('animate-number',{ref:"num1",attrs:{"from":_vm.from,"to":_vm.until,"mode":"manual","duration":"3000","easing":"easeOutQuad","animate-end":_vm.afterParty}})],1),_vm._v(" "),_c('div',{staticClass:"anumberText"},[_vm._v("Projects Completed")])])],1),_vm._v(" "),_c('b-col',{staticClass:"bcol",attrs:{"lg":"3","md":"3","sm":"3","xs":"1"}},[_c('center',[_c('div',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:({callback: _vm.visibilityChanged2, once: true}),expression:"{callback: visibilityChanged2, once: true}"}],staticClass:"anumber"},[_c('animate-number',{ref:"num2",attrs:{"from":_vm.from,"to":_vm.until,"mode":"manual","duration":"3000","easing":"easeOutQuad","animate-end":_vm.afterParty}})],1),_vm._v(" "),_c('div',{staticClass:"anumberText"},[_vm._v("Happy Clients")])])],1),_vm._v(" "),_c('b-col',{staticClass:"bcol",attrs:{"lg":"3","md":"3","sm":"3","xs":"1"}},[_c('center',[_c('div',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:({callback: _vm.visibilityChanged3, once: true}),expression:"{callback: visibilityChanged3, once: true}"}],staticClass:"anumber"},[_c('animate-number',{ref:"num3",attrs:{"from":_vm.from,"to":_vm.until,"mode":"manual","duration":"3000","easing":"easeOutQuad","animate-end":_vm.afterParty}})],1),_vm._v(" "),_c('div',{staticClass:"anumberText"},[_vm._v("Total Employees")])])],1),_vm._v(" "),_c('b-col',{staticClass:"bcol",attrs:{"lg":"3","md":"3","sm":"3","xs":"1"}},[_c('center',[_c('div',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:({callback: _vm.visibilityChanged4, once: true}),expression:"{callback: visibilityChanged4, once: true}"}],staticClass:"anumber"},[_c('animate-number',{ref:"num4",attrs:{"from":_vm.from,"to":_vm.until,"mode":"manual","duration":"3000","easing":"easeOutQuad","animate-end":_vm.afterParty}})],1),_vm._v(" "),_c('div',{staticClass:"anumberText"},[_vm._v("Ticket Submitted")])])],1)],1):_vm._e(),_vm._v(" "),_c('b-row',{staticClass:"sections latestProjects p-5"},[_c('b-col',{attrs:{"lg":"12","md":"12","sm":"12","xs":"12"}},[_c('div',[_c('h3',[_vm._v("Portofolio")])])])],1),_vm._v(" "),(_vm.projectList != null && _vm.projectList.data != null && _vm.projectList.data.length > 0)?_c('b-row',{staticClass:"sections sectionProject"},[_c('b-col',{staticClass:"bcol project",attrs:{"lg":"8","md":"8","sm":"12","xs":"12"},on:{"mouseover":function($event){_vm.p1Active = true},"mouseleave":function($event){_vm.p1Active = false}}},[_c('img',{staticClass:"img",attrs:{"src":_vm.getImage(_vm.projectList.data[0].attributes.images.data[0].attributes.url, 'url')}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.p1Active),expression:"p1Active"}],staticClass:"centered"},[_c('h4',[_vm._v(_vm._s(_vm.projectList.data[0].attributes.name))]),_vm._v(" "),_c('button',{staticClass:"goToProductsBtn primaryBtn",on:{"click":function($event){_vm.goToProject()}}},[_vm._v("See all projects")])])]),_vm._v(" "),(_vm.projectList.data.length > 1)?_c('b-col',{staticClass:"bcol project",attrs:{"lg":"4","md":"4","sm":"12","xs":"12"},on:{"mouseover":function($event){_vm.p2Active = true},"mouseleave":function($event){_vm.p2Active = false}}},[_c('img',{staticClass:"img",attrs:{"src":_vm.getImage(_vm.projectList.data[1].attributes.images.data[0].attributes.url, 'url')}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.p2Active),expression:"p2Active"}],staticClass:"centered"},[_c('h4',[_vm._v(_vm._s(_vm.projectList.data[1].attributes.name))]),_vm._v(" "),_c('button',{staticClass:"goToProductsBtn primaryBtn",on:{"click":function($event){_vm.goToProject()}}},[_vm._v("See all projects")])])]):_vm._e(),_vm._v(" "),(_vm.projectList.data.length > 2)?_c('b-col',{staticClass:"bcol project",attrs:{"lg":"6","md":"6","sm":"12","xs":"12"},on:{"mouseover":function($event){_vm.p3Active = true},"mouseleave":function($event){_vm.p3Active = false}}},[_c('img',{staticClass:"img",attrs:{"src":_vm.getImage(_vm.projectList.data[2].attributes.images.data[0].attributes.url, 'url')}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.p3Active),expression:"p3Active"}],staticClass:"centered"},[_c('h4',[_vm._v(_vm._s(_vm.projectList.data[2].attributes.name))]),_vm._v(" "),_c('button',{staticClass:"goToProductsBtn primaryBtn",on:{"click":function($event){_vm.goToProject()}}},[_vm._v("See all projects")])])]):_vm._e(),_vm._v(" "),(_vm.projectList.data.length > 3)?_c('b-col',{staticClass:"bcol project",attrs:{"lg":"6","md":"6","sm":"12","xs":"12"},on:{"mouseover":function($event){_vm.p4Active = true},"mouseleave":function($event){_vm.p4Active = false}}},[_c('img',{staticClass:"img",attrs:{"src":_vm.getImage(_vm.projectList.data[3].attributes.images.data[0].attributes.url, 'url')}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.p4Active),expression:"p4Active"}],staticClass:"centered"},[_c('h4',[_vm._v(_vm._s(_vm.projectList.data[3].attributes.name))]),_vm._v(" "),_c('button',{staticClass:"goToProductsBtn primaryBtn",on:{"click":function($event){_vm.goToProject()}}},[_vm._v("See all projects")])])]):_vm._e()],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__ = __webpack_require__(117);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7716a69b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__ = __webpack_require__(248);
function injectStyle (ssrContext) {
  __webpack_require__(247)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7716a69b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7716a69b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 247 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"about",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticStyle:{"padding":"0px"}},[_c('div',{staticClass:"text-center backgroundImg",style:({background: 'url(' + _vm.getImage(_vm.bannerImg, 'banner') +')'})},[_c('div',{staticClass:"title-top text-uppercase"},[_vm._v(_vm._s(_vm.aboutTitleTop))]),_vm._v(" "),_c('div',{staticClass:"title-middle text-uppercase primaryColor"},[_vm._v(_vm._s(_vm.aboutTitleMid))]),_vm._v(" "),_c('center',[_c('div',{staticClass:"title-bottom"},[_vm._v("\n                "+_vm._s(_vm.aboutTitleBot)+"\n            ")])])],1)])],1),_vm._v(" "),_c('b-row',{staticClass:"section1"},[_c('b-col',{staticClass:"mb-5",attrs:{"lg":"6","md":"6","sm":"12","xs":"12"}},[_c('div',{staticClass:"text-uppercase text-center p-3 mt-5 mb-3 whyUs"},[_c('h2',[_vm._v(_vm._s(_vm.aboutDynamicText1))])]),_vm._v(" "),_c('div',{staticClass:"mb-5"},[_vm._v("\n          "+_vm._s(_vm.aboutDynamicText2)+"\n        ")]),_vm._v(" "),_c('div',[_c('b-row',{staticClass:"text-left"},[_c('b-col',{staticClass:"p-3",attrs:{"lg":"6","md":"6","sm":"12","xs":"12"}},[_c('div',{staticClass:"title text-uppercase primaryColor"},[_vm._v(_vm._s(_vm.aboutWhyUsTitle1))]),_vm._v(" "),_c('div',[_vm._v("\n                "+_vm._s(_vm.aboutWhyUsDescription1)+"\n              ")])]),_vm._v(" "),_c('b-col',{staticClass:"p-3",attrs:{"lg":"6","md":"6","sm":"12","xs":"12"}},[_c('div',{staticClass:"title text-uppercase primaryColor"},[_vm._v(_vm._s(_vm.aboutWhyUsTitle2))]),_vm._v(" "),_c('div',[_vm._v("\n                "+_vm._s(_vm.aboutWhyUsDescription2)+"\n              ")])]),_vm._v(" "),_c('b-col',{staticClass:"p-3",attrs:{"lg":"6","md":"6","sm":"12","xs":"12"}},[_c('div',{staticClass:"title text-uppercase primaryColor"},[_vm._v(_vm._s(_vm.aboutWhyUsTitle3))]),_vm._v(" "),_c('div',[_vm._v("\n                "+_vm._s(_vm.aboutWhyUsDescription3)+"\n              ")])]),_vm._v(" "),_c('b-col',{staticClass:"p-3",attrs:{"lg":"6","md":"6","sm":"12","xs":"12"}},[_c('div',{staticClass:"title text-uppercase primaryColor"},[_vm._v(_vm._s(_vm.aboutWhyUsTitle4))]),_vm._v(" "),_c('div',[_vm._v("\n                "+_vm._s(_vm.aboutWhyUsDescription4)+"\n              ")])])],1)],1)]),_vm._v(" "),_c('b-col',{staticClass:"d-none d-md-block",attrs:{"lg":"6","md":"6"}},[_c('img',{attrs:{"src":__webpack_require__(116),"alt":"Why Us"}})])],1),_vm._v(" "),_c('b-row',{staticClass:"section2 p-5"},[_c('b-col',{attrs:{"lg":"12","md":"12","sm":"12","xs":"12"}},[_c('div',[_c('h3',[_vm._v("Klien Kami")])])])],1),_vm._v(" "),_c('b-row',{staticClass:"section3 m-5"},_vm._l((_vm.clients),function(client,index){return _c('b-col',{key:index,attrs:{"lg":"4","md":"4","sm":"12","xs":"12"}},[_c('center',[_c('img',{staticClass:"clientLogo",attrs:{"src":_vm.getImage(client.attributes.image.data.attributes.url, 'url')}})])],1)})),_vm._v(" "),_c('b-row',{staticClass:"section4 p-5 text-left"},[_c('b-col',{attrs:{"lg":"12","md":"12","sm":"12","xs":"12"}},[_c('div',{attrs:{"id":"promises"}},[_vm._v("Visi & Misi Kami")])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"6","md":"6","sm":"12","xs":"12"}},[(_vm.visionMissionTitle1 != '-')?_c('div',{attrs:{"id":"promise"}},[_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.visionMissionTitle1))]),_vm._v(" "),_c('div',[_vm._v("\n            "+_vm._s(_vm.visionMissionDescription1)+"\n          ")])]):_vm._e(),_vm._v(" "),(_vm.visionMissionTitle3 != '-')?_c('div',{attrs:{"id":"promise"}},[_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.visionMissionTitle3))]),_vm._v(" "),_c('div',[_vm._v("\n            "+_vm._s(_vm.visionMissionDescription3)+"\n          ")])]):_vm._e(),_vm._v(" "),(_vm.visionMissionTitle5 != '-')?_c('div',{attrs:{"id":"promise"}},[_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.visionMissionTitle5))]),_vm._v(" "),_c('div',[_vm._v("\n            "+_vm._s(_vm.visionMissionDescription5)+"\n          ")])]):_vm._e(),_vm._v(" "),(_vm.visionMissionTitle7 != '-')?_c('div',{attrs:{"id":"promise"}},[_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.visionMissionTitle7))]),_vm._v(" "),_c('div',[_vm._v("\n            "+_vm._s(_vm.visionMissionDescription7)+"\n          ")])]):_vm._e()]),_vm._v(" "),_c('b-col',{attrs:{"lg":"6","md":"6","sm":"12","xs":"12"}},[(_vm.visionMissionTitle2 != '-')?_c('div',{attrs:{"id":"promise"}},[_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.visionMissionTitle2))]),_vm._v(" "),_c('div',[_vm._v("\n            "+_vm._s(_vm.visionMissionDescription2)+"\n          ")])]):_vm._e(),_vm._v(" "),(_vm.visionMissionTitle4 != '-')?_c('div',{attrs:{"id":"promise"}},[_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.visionMissionTitle4))]),_vm._v(" "),_c('div',[_vm._v("\n            "+_vm._s(_vm.visionMissionDescription4)+"\n          ")])]):_vm._e(),_vm._v(" "),(_vm.visionMissionTitle6 != '-')?_c('div',{attrs:{"id":"promise"}},[_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.visionMissionTitle6))]),_vm._v(" "),_c('div',[_vm._v("\n            "+_vm._s(_vm.visionMissionDescription6)+"\n          ")])]):_vm._e(),_vm._v(" "),(_vm.visionMissionTitle8 != '-')?_c('div',{attrs:{"id":"promise"}},[_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.visionMissionTitle8))]),_vm._v(" "),_c('div',[_vm._v("\n            "+_vm._s(_vm.visionMissionDescription8)+"\n          ")])]):_vm._e()])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Service_vue__ = __webpack_require__(118);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_707661eb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Service_vue__ = __webpack_require__(251);
function injectStyle (ssrContext) {
  __webpack_require__(250)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-707661eb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Service_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_707661eb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Service_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 250 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"service",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticStyle:{"padding":"0px"}},[_c('div',{staticClass:"text-center backgroundImg",style:({background: 'url(' + _vm.getImage(_vm.bannerImg, 'banner') +')'})},[_c('div',{staticClass:"title-top text-uppercase"},[_vm._v(_vm._s(_vm.serviceTitleTop))]),_vm._v(" "),_c('div',{staticClass:"title-middle text-uppercase primaryColor"},[_vm._v(_vm._s(_vm.serviceTitleMid))]),_vm._v(" "),_c('center',[_c('div',{staticClass:"title-bottom"},[_vm._v("\n              "+_vm._s(_vm.serviceTitleBot)+"\n            ")])])],1)])],1),_vm._v(" "),_c('b-row',{staticClass:"section1 p-4"},[_c('b-col',{staticClass:"text-left p-5",attrs:{"lg":"8","md":"8","sm":"12","xs":"12"}},[_c('div',{staticClass:"text-uppercase text-left"},[_vm._v("\n          "+_vm._s(_vm.serviceDynamicText1)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"dash"},[_c('h3',[_vm._v(_vm._s(_vm.serviceDynamicText2))])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{staticClass:"text-justify"},[_vm._v("\n          "+_vm._s(_vm.serviceDynamicText3)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_vm._v("\n          "+_vm._s(_vm.serviceDynamicText4)+"\n        ")])]),_vm._v(" "),_c('b-col',{staticClass:"right p-5",attrs:{"lg":"3","md":"3","sm":"12","xs":"12"}},[_c('div',{staticClass:"text-uppercase text-left"},[_vm._v("\n          "+_vm._s(_vm.serviceDynamicText5)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"dash text-left"},[_c('h3',[_vm._v(_vm._s(_vm.serviceDynamicText6))])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{staticClass:"text-justify"},[_vm._v("\n          "+_vm._s(_vm.serviceDynamicText7)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"text-left"},[_c('b-row',[_c('b-col',{staticClass:"text-center mt-4",attrs:{"lg":"3","md":"12","sm":"12","xs":"12"}},[_c('i',{staticClass:"material-icons right-icon"},[_vm._v("extension")])]),_vm._v(" "),_c('b-col',{staticClass:"mt-3",attrs:{"lg":"9","md":"12","sm":"12","xs":"12"}},[_c('div',{staticClass:"right-title"},[_vm._v(_vm._s(_vm.serviceDynamicText8))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.serviceDynamicText9))])]),_vm._v(" "),_c('b-col',{staticClass:"text-center mt-4",attrs:{"lg":"3","md":"12","sm":"12","xs":"12"}},[_c('i',{staticClass:"material-icons right-icon"},[_vm._v("donut_small")])]),_vm._v(" "),_c('b-col',{staticClass:"mt-3",attrs:{"lg":"9","md":"12","sm":"12","xs":"12"}},[_c('div',{staticClass:"right-title"},[_vm._v(_vm._s(_vm.serviceDynamicText10))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.serviceDynamicText11))])]),_vm._v(" "),_c('b-col',{staticClass:"text-center mt-4",attrs:{"lg":"3","md":"12","sm":"12","xs":"12"}},[_c('i',{staticClass:"material-icons right-icon"},[_vm._v("trending_up")])]),_vm._v(" "),_c('b-col',{staticClass:"mt-3",attrs:{"lg":"9","md":"12","sm":"12","xs":"12"}},[_c('div',{staticClass:"right-title"},[_vm._v(_vm._s(_vm.serviceDynamicText12))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.serviceDynamicText13))])])],1)],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Projects_vue__ = __webpack_require__(119);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_948bfa90_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Projects_vue__ = __webpack_require__(254);
function injectStyle (ssrContext) {
  __webpack_require__(253)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-948bfa90"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Projects_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_948bfa90_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Projects_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 253 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"projects",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticStyle:{"padding":"0px"}},[_c('div',{staticClass:"text-center backgroundImg",style:({background: 'url(' + _vm.getImage(_vm.bannerImg, 'banner') +')'})},[_c('div',{staticClass:"title-top text-uppercase"},[_vm._v(_vm._s(_vm.projectTitleTop))]),_vm._v(" "),_c('div',{staticClass:"title-middle text-uppercase primaryColor"},[_vm._v(_vm._s(_vm.projectTitleMid))]),_vm._v(" "),_c('center',[_c('div',{staticClass:"title-bottom"},[_vm._v("\n              "+_vm._s(_vm.projectTitleBot)+"\n            ")])])],1)])],1),_vm._v(" "),_c('b-row',{staticClass:"section1 pt-5 pb-5"},[_c('b-col',{staticClass:"customized"},[_vm._l((_vm.projectList.data),function(project,index){return _c('div',{key:index,staticClass:"project"},[_c('div',{staticClass:"location text-uppercase mb-3"},[_vm._v(_vm._s(project.attributes.city))]),_vm._v(" "),_c('img',{attrs:{"src":_vm.getImage(project.attributes.images.data[0].attributes.url, 'url')}}),_vm._v(" "),_c('div',{staticClass:"name m-3"},[_vm._v(_vm._s(project.attributes.name))]),_vm._v(" "),_c('div',{staticClass:"description"},[_vm._v(_vm._s(project.attributes.desc))])])}),_vm._v(" "),(_vm.projectList.length == 0)?_c('div',[_vm._v("\n          Tidak ada project yang tersedia saat ini\n        ")]):_vm._e()],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Products_vue__ = __webpack_require__(120);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40f1dfa2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Products_vue__ = __webpack_require__(257);
function injectStyle (ssrContext) {
  __webpack_require__(256)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-40f1dfa2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Products_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40f1dfa2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Products_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 256 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"products",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticStyle:{"padding":"0px"}},[_c('div',{staticClass:"text-center backgroundImg",style:({background: 'url(' + _vm.getImage(_vm.bannerImg, 'banner') +')'})},[_c('div',{staticClass:"title-top text-uppercase"},[_vm._v(_vm._s(_vm.productTitleTop))]),_vm._v(" "),_c('div',{staticClass:"title-middle text-uppercase primaryColor"},[_vm._v(_vm._s(_vm.productTitleMid))]),_vm._v(" "),_c('center',[_c('div',{staticClass:"title-bottom"},[_vm._v("\n              "+_vm._s(_vm.productTitleBot)+"\n            ")])])],1)])],1),_vm._v(" "),_c('b-row',{staticClass:"section1 p-5"},[_vm._l((_vm.productList),function(product,index){return _c('b-col',{key:index,attrs:{"lg":"3","md":"3","sm":"12","xs":"12"}},[_c('div',{staticClass:"product mb-4"},[_c('div',{staticClass:"thumbnail"},[_c('img',{attrs:{"src":_vm.getImage(product.attributes.image.data.attributes.url, 'url')}})]),_vm._v(" "),_c('div',{staticClass:"name m-3"},[_vm._v(_vm._s(product.attributes.name))]),_vm._v(" "),_c('div',{staticClass:"description"},[_vm._v(_vm._s(product.attributes.description))])])])}),_vm._v(" "),(_vm.productList != null & _vm.productList.data != null && _vm.productList.data.length < 1)?_c('b-col',{attrs:{"lg":"12"}},[_vm._v("\n        Tidak ada produk yang tersedia saat ini\n      ")]):_vm._e()],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactUs_vue__ = __webpack_require__(121);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_319d2b1c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactUs_vue__ = __webpack_require__(260);
function injectStyle (ssrContext) {
  __webpack_require__(259)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-319d2b1c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactUs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_319d2b1c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactUs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 259 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"contact",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticStyle:{"padding":"0px"}},[_c('div',{staticClass:"text-center backgroundImg",style:({background: 'url(' + _vm.getImage(_vm.bannerImg, 'banner') +')'})},[_c('div',{staticClass:"title-top text-uppercase"},[_vm._v("Call us @ "),_c('b',[_vm._v(_vm._s(_vm.phoneNumber))])]),_vm._v(" "),_c('div',{staticClass:"title-middle text-uppercase primaryColor"},[_vm._v(_vm._s(_vm.contactTitleMid))]),_vm._v(" "),_c('center',[_c('div',{staticClass:"title-bottom"},[_vm._v("\n              "+_vm._s(_vm.contactTitleBot)+"\n            ")])])],1)])],1),_vm._v(" "),_c('b-row',{staticClass:"text-center"},[_c('b-col',{staticClass:"mt-5",attrs:{"lg":"12","md":"12","sm":"12","xs":"12"}},[_c('h4',[_vm._v("Email kami di: "),_c('u',[_vm._v("sekretariat@dutasaranakonstruksi.com")])])])],1),_vm._v(" "),_c('b-row',{staticClass:"section1 p-5 text-left"},[_c('b-col',{staticClass:"mb-5",attrs:{"lg":"6","md":"6","sm":"12","xs":"12"}},[_c('div',{staticClass:"text-uppercase"},[_vm._v("\n          "+_vm._s(_vm.contactDynamicText1)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"dash"},[_c('h3',[_vm._v(_vm._s(_vm.contactDynamicText2))])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{staticClass:"form"},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inquiry.name),expression:"inquiry.name"}],attrs:{"type":"text","placeholder":"Nama Anda"},domProps:{"value":(_vm.inquiry.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inquiry, "name", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("face")])])]),_vm._v(" "),_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inquiry.email),expression:"inquiry.email"}],attrs:{"type":"email","placeholder":"Email Anda"},domProps:{"value":(_vm.inquiry.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inquiry, "email", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("email")])])]),_vm._v(" "),_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inquiry.phoneNumber),expression:"inquiry.phoneNumber"}],attrs:{"type":"text","placeholder":"Nomor Telepon"},domProps:{"value":(_vm.inquiry.phoneNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inquiry, "phoneNumber", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("phone")])])]),_vm._v(" "),_c('div',{staticClass:"submitEmail p-3 text-center text-uppercase",on:{"click":_vm.sendEmail}},[_vm._v("\n            Kirim\n          ")])])]),_vm._v(" "),_c('b-col',{staticClass:"mb-3",attrs:{"lg":"6","md":"6","sm":"12","xs":"12"}},[_c('div',{staticClass:"text-uppercase"},[_vm._v("\n          "+_vm._s(_vm.contactDynamicText3)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"dash"},[_c('h3',[_vm._v(_vm._s(_vm.contactDynamicText4))])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('GmapMap',{staticStyle:{"width":"100%","height":"350px"},attrs:{"center":_vm.position,"zoom":15,"map-type-id":"terrain"}},[_c('GmapMarker',{attrs:{"position":_vm.position,"clickable":false,"draggable":false}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(122);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02544d77_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(263);
function injectStyle (ssrContext) {
  __webpack_require__(262)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-02544d77"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02544d77_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 262 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"login",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticStyle:{"padding":"0px"}},[_c('div',{staticClass:"text-center login-banner",style:({background: 'url(' + _vm.getImage(_vm.bannerImg, 'banner') +')'})},[_c('div',{staticClass:"title-top text-uppercase"},[_vm._v("Duta Sarana Konstruksi")]),_vm._v(" "),_c('center',[_c('div',{staticClass:"title-bottom"},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.username),expression:"username"}],attrs:{"type":"text","placeholder":"Username"},domProps:{"value":(_vm.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.username=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("person_pin")])])]),_vm._v(" "),_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],attrs:{"type":"password","placeholder":"Password"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("visibility")])])]),_vm._v(" "),_c('div',{staticClass:"loginBtn p-2 text-center text-uppercase",on:{"click":_vm.login}},[_vm._v("\n                Login\n              ")])])])],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(123);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2010fc2e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(266);
function injectStyle (ssrContext) {
  __webpack_require__(265)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2010fc2e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2010fc2e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 265 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"dashboard",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('div',{staticClass:"text-left text-uppercase title p-3"},[_vm._v("\n          Dashboard\n        ")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3",attrs:{"lg":"4","md":"4","sm":"12","xs":"12"}},[_c('div',{staticClass:"section p-3"},[_vm._v("\n          Total Portfolios\n          "),_c('div',{staticClass:"bigNumber"},[_vm._v("\n            "+_vm._s(_vm.totalPortfolios)+"\n          ")])])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3",attrs:{"lg":"4","md":"4","sm":"12","xs":"12"}},[_c('div',{staticClass:"section contactUs p-3"},[_vm._v("\n          Total Products\n          "),_c('div',{staticClass:"bigNumber"},[_vm._v("\n            "+_vm._s(_vm.totalProducts)+"\n          ")])])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3",attrs:{"lg":"4","md":"4","sm":"12","xs":"12"}},[_c('div',{staticClass:"section subscriber p-3"},[_vm._v("\n          Total Clients\n          "),_c('div',{staticClass:"bigNumber"},[_vm._v("\n            "+_vm._s(_vm.totalClients)+"\n          ")])])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DProducts_vue__ = __webpack_require__(124);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_452e7cc5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DProducts_vue__ = __webpack_require__(269);
function injectStyle (ssrContext) {
  __webpack_require__(268)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-452e7cc5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DProducts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_452e7cc5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DProducts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 268 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"dproducts",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[(_vm.isLoading)?_c('div',{staticClass:"loadingOverlay"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-left text-uppercase title p-3"},[_vm._v("\n          All Products\n          "),_c('span',{staticClass:"addBtn",on:{"click":_vm.goToAddProduct}},[_vm._v(" + Add Product")])])])],1),_vm._v(" "),(!_vm.isLoading)?_c('b-row',{staticClass:"m-2"},_vm._l((_vm.productList),function(product,index){return _c('b-col',{key:index,staticClass:"box text-left mb-3 pb-3",attrs:{"lg":"12","md":"12","sm":"12","xs":"12"}},[_c('b-row',[_c('b-col',{attrs:{"lg":"3","md":"3","sm":"12","xs":"12"}},[_c('img',{attrs:{"src":_vm.getImage(product.attributes.image.data.attributes.url, 'url')}})]),_vm._v(" "),_c('b-col',{attrs:{"lg":"9","md":"9","sm":"12","xs":"12"}},[_c('div',{staticClass:"text-right"},[_c('div',{staticClass:"actionBtn",on:{"click":function($event){_vm.deleteProduct(product)}}},[_vm._v("Remove")]),_vm._v(" "),_c('div',{staticClass:"actionBtn",on:{"click":function($event){_vm.editProduct(product.id)}}},[_vm._v("Edit")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',[_vm._v("Product : "+_vm._s(product.attributes.name))]),_vm._v(" "),_c('div',[_vm._v("Description : "+_vm._s(product.attributes.description))])])],1)],1)})):_vm._e(),_vm._v(" "),(_vm.productList.length < 1)?_c('b-row',{staticClass:"m-2"},[_c('b-col',{staticClass:"box text-left mb-3 pb-3",attrs:{"lg":"12","md":"12","sm":"12","xs":"12"}},[_vm._v("\n        No product available yet.\n      ")])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DProjects_vue__ = __webpack_require__(125);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d7de6f2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DProjects_vue__ = __webpack_require__(272);
function injectStyle (ssrContext) {
  __webpack_require__(271)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2d7de6f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DProjects_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d7de6f2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DProjects_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 271 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"dprojects",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('div',{staticClass:"text-left text-uppercase title p-3"},[_vm._v("\n          All Projects\n          "),_c('span',{staticClass:"addBtn",on:{"click":_vm.goToAddProject}},[_vm._v(" + Add Project")])])])],1),_vm._v(" "),_c('b-row',{staticClass:"m-2"},_vm._l((_vm.projectList),function(project,index){return _c('b-col',{key:index,staticClass:"box text-left mb-3 pb-3",attrs:{"lg":"12","md":"12","sm":"12","xs":"12"}},[_c('b-row',[_c('b-col',{attrs:{"lg":"3","md":"3","sm":"12","xs":"12"}},[(project.attributes.images != null && project.attributes.images.data != null)?_c('img',{attrs:{"src":_vm.getImage(project.attributes.images.data[0].attributes.url, 'url')}}):_vm._e()]),_vm._v(" "),_c('b-col',{attrs:{"lg":"9","md":"9","sm":"12","xs":"12"}},[_c('div',{staticClass:"text-right"},[_c('div',{staticClass:"actionBtn",on:{"click":function($event){_vm.deleteProject(project)}}},[_vm._v("Remove")]),_vm._v(" "),_c('div',{staticClass:"actionBtn",on:{"click":function($event){_vm.editProject(project.id)}}},[_vm._v("Edit")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',[_vm._v("Project : "+_vm._s(project.attributes.name))]),_vm._v(" "),_c('div',[_vm._v("Lokasi : "+_vm._s(project.attributes.city))]),_vm._v(" "),_c('div',[_vm._v("Deskripsi : "+_vm._s(project.attributes.description))])])],1)],1)})),_vm._v(" "),(_vm.projectList.length < 1)?_c('b-row',{staticClass:"m-2"},[_c('b-col',{staticClass:"box text-left mb-3 pb-3",attrs:{"lg":"12","md":"12","sm":"12","xs":"12"}},[_vm._v("\n        No project available yet.\n      ")])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DClients_vue__ = __webpack_require__(126);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20f4278c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DClients_vue__ = __webpack_require__(275);
function injectStyle (ssrContext) {
  __webpack_require__(274)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-20f4278c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DClients_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20f4278c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DClients_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 274 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"dclients",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[(_vm.isLoading)?_c('div',{staticClass:"loadingOverlay"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-left text-uppercase title p-3"},[_vm._v("\n          All Clients\n          "),_c('span',{staticClass:"addBtn",on:{"click":_vm.goToAddClient}},[_vm._v(" + Add Client")])])])],1),_vm._v(" "),(!_vm.isLoading)?_c('b-row',{staticClass:"m-2"},_vm._l((_vm.clientList),function(client,index){return _c('b-col',{key:index,staticClass:"box text-left mb-3 pb-3",attrs:{"lg":"12","md":"12","sm":"12","xs":"12"}},[_c('b-row',[_c('b-col',{attrs:{"lg":"3","md":"3","sm":"12","xs":"12"}},[(client.attributes.image != null && client.attributes.image.data != null)?_c('img',{attrs:{"src":_vm.getImage(client.attributes.image.data.attributes.url, 'url')}}):_vm._e()]),_vm._v(" "),_c('b-col',{attrs:{"lg":"9","md":"9","sm":"12","xs":"12"}},[_c('div',{staticClass:"text-right"},[_c('div',{staticClass:"actionBtn",on:{"click":function($event){_vm.deleteClient(client)}}},[_vm._v("Remove")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',[_vm._v("Client : "+_vm._s(client.attributes.name))])])],1)],1)})):_vm._e(),_vm._v(" "),(_vm.clientList.length < 1)?_c('b-row',{staticClass:"m-2"},[_c('b-col',{staticClass:"box text-left mb-3 pb-3",attrs:{"lg":"12","md":"12","sm":"12","xs":"12"}},[_vm._v("\n        No client available yet.\n      ")])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__ = __webpack_require__(127);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4abf23d0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__ = __webpack_require__(278);
function injectStyle (ssrContext) {
  __webpack_require__(277)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4abf23d0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4abf23d0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 277 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"settings",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('div',{staticClass:"text-left text-uppercase title p-3"},[_vm._v("\n          Settings\n        ")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mphoneNumber),expression:"mphoneNumber"}],attrs:{"type":"text","placeholder":"Phone Number","disabled":!_vm.editingPhoneNumber},domProps:{"value":(_vm.mphoneNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mphoneNumber=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("phone")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Company Phone Number")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingPhoneNumber)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('cPhoneNumber')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingPhoneNumber)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('cPhoneNumber', _vm.mphoneNumber)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mHomeTitleTop),expression:"mHomeTitleTop"}],attrs:{"type":"text","placeholder":"Homepage title top","disabled":!_vm.editingContent.homeTitleTop},domProps:{"value":(_vm.mHomeTitleTop)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mHomeTitleTop=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("short_text")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Homepage Title Top")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.homeTitleTop)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('homeTitleTop')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.homeTitleTop)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('homeTitleTop', _vm.mHomeTitleTop)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mhomeTitleMid),expression:"mhomeTitleMid"}],attrs:{"type":"text","placeholder":"Homepage title middle","disabled":!_vm.editingContent.homeTitleMid},domProps:{"value":(_vm.mhomeTitleMid)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mhomeTitleMid=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("short_text")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Homepage Title Middle")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.homeTitleMid)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('homeTitleMid')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.homeTitleMid)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('homeTitleMid', _vm.mhomeTitleMid)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mhomeTitleBot),expression:"mhomeTitleBot"}],attrs:{"type":"text","placeholder":"Homepage title bottom","disabled":!_vm.editingContent.homeTitleBot},domProps:{"value":(_vm.mhomeTitleBot)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mhomeTitleBot=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("short_text")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Homepage Title Bottom")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.homeTitleBot)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('homeTitleBot')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.homeTitleBot)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('homeTitleBot', _vm.mhomeTitleBot)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mhomeDynamicText1),expression:"mhomeDynamicText1"}],attrs:{"type":"text","placeholder":"Homepage dynamic text 1","disabled":!_vm.editingContent.homeDynamicText1},domProps:{"value":(_vm.mhomeDynamicText1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mhomeDynamicText1=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("short_text")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Homepage Dynamic Text 1")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.homeDynamicText1)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('homeDynamicText1')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.homeDynamicText1)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('homeDynamicText1', _vm.mhomeDynamicText1)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mhomeDynamicText2),expression:"mhomeDynamicText2"}],attrs:{"type":"text","placeholder":"Homepage dynamic text 1","disabled":!_vm.editingContent.homeDynamicText2},domProps:{"value":(_vm.mhomeDynamicText2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mhomeDynamicText2=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("short_text")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Homepage Dynamic Text 2")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.homeDynamicText2)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('homeDynamicText2')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.homeDynamicText2)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('homeDynamicText2', _vm.mhomeDynamicText2)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mhomeDynamicText3),expression:"mhomeDynamicText3"}],attrs:{"type":"text","placeholder":"Homepage dynamic text 3","disabled":!_vm.editingContent.homeDynamicText3},domProps:{"value":(_vm.mhomeDynamicText3)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mhomeDynamicText3=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("short_text")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Homepage Dynamic Text 3")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.homeDynamicText3)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('homeDynamicText3')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.homeDynamicText3)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('homeDynamicText3', _vm.mhomeDynamicText3)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.maboutTitleTop),expression:"maboutTitleTop"}],attrs:{"type":"text","placeholder":"About title top","disabled":!_vm.editingContent.aboutTitleTop},domProps:{"value":(_vm.maboutTitleTop)},on:{"input":function($event){if($event.target.composing){ return; }_vm.maboutTitleTop=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("About Title Top")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.aboutTitleTop)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('aboutTitleTop')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.aboutTitleTop)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('aboutTitleTop', _vm.maboutTitleTop)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.maboutTitleMid),expression:"maboutTitleMid"}],attrs:{"type":"text","placeholder":"About title middle","disabled":!_vm.editingContent.aboutTitleMid},domProps:{"value":(_vm.maboutTitleMid)},on:{"input":function($event){if($event.target.composing){ return; }_vm.maboutTitleMid=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("About Title Middle")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.aboutTitleMid)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('aboutTitleMid')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.aboutTitleMid)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('aboutTitleMid', _vm.maboutTitleMid)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.maboutTitleBot),expression:"maboutTitleBot"}],attrs:{"type":"text","placeholder":"About title bottom","disabled":!_vm.editingContent.aboutTitleBot},domProps:{"value":(_vm.maboutTitleBot)},on:{"input":function($event){if($event.target.composing){ return; }_vm.maboutTitleBot=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("About Title Bottom")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.aboutTitleBot)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('aboutTitleBot')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.aboutTitleBot)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('aboutTitleBot', _vm.maboutTitleBot)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.maboutDynamicText1),expression:"maboutDynamicText1"}],attrs:{"type":"text","placeholder":"About Why Us Title","disabled":!_vm.editingContent.aboutDynamicText1},domProps:{"value":(_vm.maboutDynamicText1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.maboutDynamicText1=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("About Why Us Title")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.aboutDynamicText1)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('aboutDynamicText1')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.aboutDynamicText1)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('aboutDynamicText1', _vm.maboutDynamicText1)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.maboutDynamicText2),expression:"maboutDynamicText2"}],attrs:{"type":"text","placeholder":"About Why Us Description","disabled":!_vm.editingContent.aboutDynamicText2},domProps:{"value":(_vm.maboutDynamicText2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.maboutDynamicText2=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("About Why Us Description")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.aboutDynamicText2)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('aboutDynamicText2')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.aboutDynamicText2)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('aboutDynamicText2', _vm.maboutDynamicText2)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.maboutWhyUsTitle1),expression:"maboutWhyUsTitle1"}],attrs:{"type":"text","placeholder":"About Why Us Point 1 Title","disabled":!_vm.editingContent.aboutWhyUsTitle1},domProps:{"value":(_vm.maboutWhyUsTitle1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.maboutWhyUsTitle1=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("About Why Us Point 1 Title")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.aboutWhyUsTitle1)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('aboutWhyUsTitle1')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.aboutWhyUsTitle1)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('aboutWhyUsTitle1', _vm.maboutWhyUsTitle1)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.maboutWhyUsDescription1),expression:"maboutWhyUsDescription1"}],attrs:{"type":"text","placeholder":"About Why Us Point 1 Description","disabled":!_vm.editingContent.aboutWhyUsDescription1},domProps:{"value":(_vm.maboutWhyUsDescription1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.maboutWhyUsDescription1=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("About Why Us Point 1 Description")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.aboutWhyUsDescription1)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('aboutWhyUsDescription1')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.aboutWhyUsDescription1)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('aboutWhyUsDescription1', _vm.maboutWhyUsDescription1)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.maboutWhyUsTitle2),expression:"maboutWhyUsTitle2"}],attrs:{"type":"text","placeholder":"About Why Us Point 2 Title","disabled":!_vm.editingContent.aboutWhyUsTitle2},domProps:{"value":(_vm.maboutWhyUsTitle2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.maboutWhyUsTitle2=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("About Why Us Point 2 Title")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.aboutWhyUsTitle2)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('aboutWhyUsTitle2')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.aboutWhyUsTitle2)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('aboutWhyUsTitle2', _vm.maboutWhyUsTitle2)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.maboutWhyUsDescription2),expression:"maboutWhyUsDescription2"}],attrs:{"type":"text","placeholder":"About Why Us Point 2 Description","disabled":!_vm.editingContent.aboutWhyUsDescription2},domProps:{"value":(_vm.maboutWhyUsDescription2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.maboutWhyUsDescription2=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("About Why Us Point 2 Description")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.aboutWhyUsDescription2)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('aboutWhyUsDescription2')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.aboutWhyUsDescription2)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('aboutWhyUsDescription2', _vm.maboutWhyUsDescription2)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.maboutWhyUsTitle3),expression:"maboutWhyUsTitle3"}],attrs:{"type":"text","placeholder":"About Why Us Point 3 Title","disabled":!_vm.editingContent.aboutWhyUsTitle3},domProps:{"value":(_vm.maboutWhyUsTitle3)},on:{"input":function($event){if($event.target.composing){ return; }_vm.maboutWhyUsTitle3=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("About Why Us Point 3 Title")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.aboutWhyUsTitle3)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('aboutWhyUsTitle3')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.aboutWhyUsTitle3)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('aboutWhyUsTitle3', _vm.maboutWhyUsTitle3)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.maboutWhyUsDescription3),expression:"maboutWhyUsDescription3"}],attrs:{"type":"text","placeholder":"About Why Us Point 3 Description","disabled":!_vm.editingContent.aboutWhyUsDescription3},domProps:{"value":(_vm.maboutWhyUsDescription3)},on:{"input":function($event){if($event.target.composing){ return; }_vm.maboutWhyUsDescription3=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("About Why Us Point 3 Description")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.aboutWhyUsDescription3)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('aboutWhyUsDescription3')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.aboutWhyUsDescription3)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('aboutWhyUsDescription3', _vm.maboutWhyUsDescription3)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.maboutWhyUsTitle4),expression:"maboutWhyUsTitle4"}],attrs:{"type":"text","placeholder":"About Why Us Point 4 Title","disabled":!_vm.editingContent.aboutWhyUsTitle4},domProps:{"value":(_vm.maboutWhyUsTitle4)},on:{"input":function($event){if($event.target.composing){ return; }_vm.maboutWhyUsTitle4=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("About Why Us Point 4 Title")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.aboutWhyUsTitle4)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('aboutWhyUsTitle4')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.aboutWhyUsTitle4)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('aboutWhyUsTitle4', _vm.maboutWhyUsTitle4)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.maboutWhyUsDescription4),expression:"maboutWhyUsDescription4"}],attrs:{"type":"text","placeholder":"About Why Us Point 4 Description","disabled":!_vm.editingContent.aboutWhyUsDescription4},domProps:{"value":(_vm.maboutWhyUsDescription4)},on:{"input":function($event){if($event.target.composing){ return; }_vm.maboutWhyUsDescription4=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("About Why Us Point 4 Description")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.aboutWhyUsDescription4)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('aboutWhyUsDescription4')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.aboutWhyUsDescription4)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('aboutWhyUsDescription4', _vm.maboutWhyUsDescription4)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mvisionMissionTitle1),expression:"mvisionMissionTitle1"}],attrs:{"type":"text","placeholder":"Vision & Mission Title 1","disabled":!_vm.editingContent.visionMissionTitle1},domProps:{"value":(_vm.mvisionMissionTitle1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mvisionMissionTitle1=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Vision & Mission Title 1")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.visionMissionTitle1)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('visionMissionTitle1')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.visionMissionTitle1)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('visionMissionTitle1', _vm.mvisionMissionTitle1)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mvisionMissionDescription1),expression:"mvisionMissionDescription1"}],attrs:{"type":"text","placeholder":"Vision & Mission Description 1","disabled":!_vm.editingContent.visionMissionDescription1},domProps:{"value":(_vm.mvisionMissionDescription1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mvisionMissionDescription1=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Vision & Mission Description 1")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.visionMissionDescription1)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('visionMissionDescription1')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.visionMissionDescription1)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('visionMissionDescription1', _vm.mvisionMissionDescription1)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mvisionMissionTitle2),expression:"mvisionMissionTitle2"}],attrs:{"type":"text","placeholder":"Vision & Mission Title 2","disabled":!_vm.editingContent.visionMissionTitle2},domProps:{"value":(_vm.mvisionMissionTitle2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mvisionMissionTitle2=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Vision & Mission Title 2")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.visionMissionTitle2)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('visionMissionTitle2')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.visionMissionTitle2)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('visionMissionTitle2', _vm.mvisionMissionTitle2)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mvisionMissionDescription2),expression:"mvisionMissionDescription2"}],attrs:{"type":"text","placeholder":"Vision & Mission Description 2","disabled":!_vm.editingContent.visionMissionDescription2},domProps:{"value":(_vm.mvisionMissionDescription2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mvisionMissionDescription2=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Vision & Mission Description 2")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.visionMissionDescription2)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('visionMissionDescription2')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.visionMissionDescription2)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('visionMissionDescription2', _vm.mvisionMissionDescription2)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mvisionMissionTitle3),expression:"mvisionMissionTitle3"}],attrs:{"type":"text","placeholder":"Vision & Mission Title 3","disabled":!_vm.editingContent.visionMissionTitle3},domProps:{"value":(_vm.mvisionMissionTitle3)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mvisionMissionTitle3=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Vision & Mission Title 3")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.visionMissionTitle3)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('visionMissionTitle3')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.visionMissionTitle3)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('visionMissionTitle3', _vm.mvisionMissionTitle3)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mvisionMissionDescription3),expression:"mvisionMissionDescription3"}],attrs:{"type":"text","placeholder":"Vision & Mission Description 3","disabled":!_vm.editingContent.visionMissionDescription3},domProps:{"value":(_vm.mvisionMissionDescription3)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mvisionMissionDescription3=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Vision & Mission Description 3")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.visionMissionDescription3)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('visionMissionDescription3')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.visionMissionDescription3)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('visionMissionDescription3', _vm.mvisionMissionDescription3)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mvisionMissionTitle4),expression:"mvisionMissionTitle4"}],attrs:{"type":"text","placeholder":"Vision & Mission Title 4","disabled":!_vm.editingContent.visionMissionTitle4},domProps:{"value":(_vm.mvisionMissionTitle4)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mvisionMissionTitle4=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Vision & Mission Title 4")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.visionMissionTitle4)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('visionMissionTitle4')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.visionMissionTitle4)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('visionMissionTitle4', _vm.mvisionMissionTitle4)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mvisionMissionDescription4),expression:"mvisionMissionDescription4"}],attrs:{"type":"text","placeholder":"Vision & Mission Description 4","disabled":!_vm.editingContent.visionMissionDescription4},domProps:{"value":(_vm.mvisionMissionDescription4)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mvisionMissionDescription4=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Vision & Mission Description 4")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.visionMissionDescription4)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('visionMissionDescription4')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.visionMissionDescription4)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('visionMissionDescription4', _vm.mvisionMissionDescription4)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mvisionMissionTitle5),expression:"mvisionMissionTitle5"}],attrs:{"type":"text","placeholder":"Vision & Mission Title 5","disabled":!_vm.editingContent.visionMissionTitle5},domProps:{"value":(_vm.mvisionMissionTitle5)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mvisionMissionTitle5=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Vision & Mission Title 5")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.visionMissionTitle5)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('visionMissionTitle5')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.visionMissionTitle5)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('visionMissionTitle5', _vm.mvisionMissionTitle5)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mvisionMissionDescription5),expression:"mvisionMissionDescription5"}],attrs:{"type":"text","placeholder":"Vision & Mission Description 5","disabled":!_vm.editingContent.visionMissionDescription5},domProps:{"value":(_vm.mvisionMissionDescription5)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mvisionMissionDescription5=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Vision & Mission Description 5")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.visionMissionDescription5)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('visionMissionDescription5')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.visionMissionDescription5)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('visionMissionDescription5', _vm.mvisionMissionDescription5)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mvisionMissionTitle6),expression:"mvisionMissionTitle6"}],attrs:{"type":"text","placeholder":"Vision & Mission Title 6","disabled":!_vm.editingContent.visionMissionTitle6},domProps:{"value":(_vm.mvisionMissionTitle6)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mvisionMissionTitle6=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Vision & Mission Title 6")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.visionMissionTitle6)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('visionMissionTitle6')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.visionMissionTitle6)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('visionMissionTitle6', _vm.mvisionMissionTitle6)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mvisionMissionDescription6),expression:"mvisionMissionDescription6"}],attrs:{"type":"text","placeholder":"Vision & Mission Description 6","disabled":!_vm.editingContent.visionMissionDescription6},domProps:{"value":(_vm.mvisionMissionDescription6)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mvisionMissionDescription6=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Vision & Mission Description 6")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.visionMissionDescription6)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('visionMissionDescription6')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.visionMissionDescription6)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('visionMissionDescription6', _vm.mvisionMissionDescription6)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mvisionMissionTitle7),expression:"mvisionMissionTitle7"}],attrs:{"type":"text","placeholder":"Vision & Mission Title 7","disabled":!_vm.editingContent.visionMissionTitle7},domProps:{"value":(_vm.mvisionMissionTitle7)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mvisionMissionTitle7=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Vision & Mission Title 7")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.visionMissionTitle7)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('visionMissionTitle7')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.visionMissionTitle7)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('visionMissionTitle7', _vm.mvisionMissionTitle7)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mvisionMissionDescription7),expression:"mvisionMissionDescription7"}],attrs:{"type":"text","placeholder":"Vision & Mission Description 7","disabled":!_vm.editingContent.visionMissionDescription7},domProps:{"value":(_vm.mvisionMissionDescription7)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mvisionMissionDescription7=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Vision & Mission Description 7")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.visionMissionDescription7)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('visionMissionDescription7')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.visionMissionDescription7)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('visionMissionDescription7', _vm.mvisionMissionDescription7)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mvisionMissionTitle8),expression:"mvisionMissionTitle8"}],attrs:{"type":"text","placeholder":"Vision & Mission Title 8","disabled":!_vm.editingContent.visionMissionTitle8},domProps:{"value":(_vm.mvisionMissionTitle8)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mvisionMissionTitle8=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Vision & Mission Title 8")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.visionMissionTitle8)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('visionMissionTitle8')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.visionMissionTitle8)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('visionMissionTitle8', _vm.mvisionMissionTitle8)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mvisionMissionDescription8),expression:"mvisionMissionDescription8"}],attrs:{"type":"text","placeholder":"Vision & Mission Description 8","disabled":!_vm.editingContent.visionMissionDescription8},domProps:{"value":(_vm.mvisionMissionDescription8)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mvisionMissionDescription8=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Vision & Mission Description 8")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.visionMissionDescription8)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('visionMissionDescription8')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.visionMissionDescription8)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('visionMissionDescription8', _vm.mvisionMissionDescription8)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mserviceTitleTop),expression:"mserviceTitleTop"}],attrs:{"type":"text","placeholder":"Service title top","disabled":!_vm.editingContent.serviceTitleTop},domProps:{"value":(_vm.mserviceTitleTop)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mserviceTitleTop=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Service Title Top")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.serviceTitleTop)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('serviceTitleTop')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.serviceTitleTop)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('serviceTitleTop', _vm.mserviceTitleTop)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mserviceTitleMid),expression:"mserviceTitleMid"}],attrs:{"type":"text","placeholder":"Service title middle","disabled":!_vm.editingContent.serviceTitleMid},domProps:{"value":(_vm.mserviceTitleMid)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mserviceTitleMid=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Service Title Middle")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.serviceTitleMid)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('serviceTitleMid')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.serviceTitleMid)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('serviceTitleMid', _vm.mserviceTitleMid)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mserviceTitleBot),expression:"mserviceTitleBot"}],attrs:{"type":"text","placeholder":"Service title bottom","disabled":!_vm.editingContent.serviceTitleBot},domProps:{"value":(_vm.mserviceTitleBot)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mserviceTitleBot=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Service Title Bottom")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.serviceTitleBot)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('serviceTitleBot')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.serviceTitleBot)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('serviceTitleBot', _vm.mserviceTitleBot)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mserviceDynamicText1),expression:"mserviceDynamicText1"}],attrs:{"type":"text","placeholder":"Service Dynamic Text 1","disabled":!_vm.editingContent.serviceDynamicText1},domProps:{"value":(_vm.mserviceDynamicText1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mserviceDynamicText1=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Service Dyamic Text 1")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.serviceDynamicText1)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('serviceDynamicText1')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.serviceDynamicText1)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('serviceDynamicText1', _vm.mserviceDynamicText1)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mserviceDynamicText2),expression:"mserviceDynamicText2"}],attrs:{"type":"text","placeholder":"Service Dynamic Text 2","disabled":!_vm.editingContent.serviceDynamicText2},domProps:{"value":(_vm.mserviceDynamicText2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mserviceDynamicText2=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Service Dyamic Text 2")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.serviceDynamicText2)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('serviceDynamicText2')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.serviceDynamicText2)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('serviceDynamicText2', _vm.mserviceDynamicText2)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mserviceDynamicText3),expression:"mserviceDynamicText3"}],attrs:{"type":"text","placeholder":"Service Dynamic Text 3","disabled":!_vm.editingContent.serviceDynamicText3},domProps:{"value":(_vm.mserviceDynamicText3)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mserviceDynamicText3=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Service Dyamic Text 3")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.serviceDynamicText3)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('serviceDynamicText3')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.serviceDynamicText3)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('serviceDynamicText3', _vm.mserviceDynamicText3)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mserviceDynamicText4),expression:"mserviceDynamicText4"}],attrs:{"type":"text","placeholder":"Service Dynamic Text 4","disabled":!_vm.editingContent.serviceDynamicText4},domProps:{"value":(_vm.mserviceDynamicText4)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mserviceDynamicText4=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Service Dyamic Text 4")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.serviceDynamicText4)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('serviceDynamicText4')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.serviceDynamicText4)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('serviceDynamicText4', _vm.mserviceDynamicText4)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mserviceDynamicText5),expression:"mserviceDynamicText5"}],attrs:{"type":"text","placeholder":"Service Dynamic Text 5","disabled":!_vm.editingContent.serviceDynamicText5},domProps:{"value":(_vm.mserviceDynamicText5)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mserviceDynamicText5=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Service Dyamic Text 5")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.serviceDynamicText5)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('serviceDynamicText5')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.serviceDynamicText5)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('serviceDynamicText5', _vm.mserviceDynamicText5)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mserviceDynamicText6),expression:"mserviceDynamicText6"}],attrs:{"type":"text","placeholder":"Service Dynamic Text 6","disabled":!_vm.editingContent.serviceDynamicText6},domProps:{"value":(_vm.mserviceDynamicText6)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mserviceDynamicText6=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Service Dyamic Text 6")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.serviceDynamicText6)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('serviceDynamicText6')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.serviceDynamicText6)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('serviceDynamicText6', _vm.mserviceDynamicText6)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mserviceDynamicText7),expression:"mserviceDynamicText7"}],attrs:{"type":"text","placeholder":"Service Dynamic Text 7","disabled":!_vm.editingContent.serviceDynamicText7},domProps:{"value":(_vm.mserviceDynamicText7)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mserviceDynamicText7=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Service Dyamic Text 7")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.serviceDynamicText7)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('serviceDynamicText7')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.serviceDynamicText7)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('serviceDynamicText7', _vm.mserviceDynamicText7)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mserviceDynamicText8),expression:"mserviceDynamicText8"}],attrs:{"type":"text","placeholder":"Service Dynamic Text 8","disabled":!_vm.editingContent.serviceDynamicText8},domProps:{"value":(_vm.mserviceDynamicText8)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mserviceDynamicText8=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Service Dyamic Text 8")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.serviceDynamicText8)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('serviceDynamicText8')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.serviceDynamicText8)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('serviceDynamicText8', _vm.mserviceDynamicText8)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mserviceDynamicText9),expression:"mserviceDynamicText9"}],attrs:{"type":"text","placeholder":"Service Dynamic Text 9","disabled":!_vm.editingContent.serviceDynamicText9},domProps:{"value":(_vm.mserviceDynamicText9)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mserviceDynamicText9=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Service Dyamic Text 9")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.serviceDynamicText9)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('serviceDynamicText9')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.serviceDynamicText9)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('serviceDynamicText9', _vm.mserviceDynamicText9)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mserviceDynamicText10),expression:"mserviceDynamicText10"}],attrs:{"type":"text","placeholder":"Service Dynamic Text 10","disabled":!_vm.editingContent.serviceDynamicText10},domProps:{"value":(_vm.mserviceDynamicText10)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mserviceDynamicText10=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Service Dyamic Text 10")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.serviceDynamicText10)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('serviceDynamicText10')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.serviceDynamicText10)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('serviceDynamicText10', _vm.mserviceDynamicText10)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mserviceDynamicText11),expression:"mserviceDynamicText11"}],attrs:{"type":"text","placeholder":"Service Dynamic Text 11","disabled":!_vm.editingContent.serviceDynamicText11},domProps:{"value":(_vm.mserviceDynamicText11)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mserviceDynamicText11=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Service Dyamic Text 11")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.serviceDynamicText11)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('serviceDynamicText11')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.serviceDynamicText11)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('serviceDynamicText11', _vm.mserviceDynamicText11)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mserviceDynamicText12),expression:"mserviceDynamicText12"}],attrs:{"type":"text","placeholder":"Service Dynamic Text 12","disabled":!_vm.editingContent.serviceDynamicText12},domProps:{"value":(_vm.mserviceDynamicText12)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mserviceDynamicText12=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Service Dyamic Text 12")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.serviceDynamicText12)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('serviceDynamicText12')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.serviceDynamicText12)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('serviceDynamicText12', _vm.mserviceDynamicText12)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mserviceDynamicText13),expression:"mserviceDynamicText13"}],attrs:{"type":"text","placeholder":"Service Dynamic Text 13","disabled":!_vm.editingContent.serviceDynamicText13},domProps:{"value":(_vm.mserviceDynamicText13)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mserviceDynamicText13=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Service Dyamic Text 13")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.serviceDynamicText13)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('serviceDynamicText13')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.serviceDynamicText13)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('serviceDynamicText13', _vm.mserviceDynamicText13)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mprojectTitleTop),expression:"mprojectTitleTop"}],attrs:{"type":"text","placeholder":"Project Title Top","disabled":!_vm.editingContent.projectTitleTop},domProps:{"value":(_vm.mprojectTitleTop)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mprojectTitleTop=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Project Title Top")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.projectTitleTop)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('projectTitleTop')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.projectTitleTop)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('projectTitleTop', _vm.mprojectTitleTop)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mprojectTitleMid),expression:"mprojectTitleMid"}],attrs:{"type":"text","placeholder":"Project Title Middle","disabled":!_vm.editingContent.projectTitleMid},domProps:{"value":(_vm.mprojectTitleMid)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mprojectTitleMid=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Project Title Middle")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.projectTitleMid)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('projectTitleMid')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.projectTitleMid)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('projectTitleMid', _vm.mprojectTitleMid)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mprojectTitleBot),expression:"mprojectTitleBot"}],attrs:{"type":"text","placeholder":"Project Title Bottom","disabled":!_vm.editingContent.projectTitleBot},domProps:{"value":(_vm.mprojectTitleBot)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mprojectTitleBot=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Project Title Bottom")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.projectTitleBot)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('projectTitleBot')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.projectTitleBot)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('projectTitleBot', _vm.mprojectTitleBot)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mproductTitleTop),expression:"mproductTitleTop"}],attrs:{"type":"text","placeholder":"Product Title Top","disabled":!_vm.editingContent.productTitleTop},domProps:{"value":(_vm.mproductTitleTop)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mproductTitleTop=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Product Title Top")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.productTitleTop)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('productTitleTop')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.productTitleTop)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('productTitleTop', _vm.mproductTitleTop)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mproductTitleMid),expression:"mproductTitleMid"}],attrs:{"type":"text","placeholder":"Product Title Middle","disabled":!_vm.editingContent.productTitleMid},domProps:{"value":(_vm.mproductTitleMid)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mproductTitleMid=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Product Title Middle")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.productTitleMid)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('productTitleMid')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.productTitleMid)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('productTitleMid', _vm.mproductTitleMid)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mproductTitleBot),expression:"mproductTitleBot"}],attrs:{"type":"text","placeholder":"Product Title Bottom","disabled":!_vm.editingContent.productTitleBot},domProps:{"value":(_vm.mproductTitleBot)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mproductTitleBot=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Product Title Bottom")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.productTitleBot)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('productTitleBot')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.productTitleBot)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('productTitleBot', _vm.mproductTitleBot)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mcontactTitleMid),expression:"mcontactTitleMid"}],attrs:{"type":"text","placeholder":"Contact Title Middle","disabled":!_vm.editingContent.contactTitleMid},domProps:{"value":(_vm.mcontactTitleMid)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mcontactTitleMid=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Contact Title Middle")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.contactTitleMid)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('contactTitleMid')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.contactTitleMid)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('contactTitleMid', _vm.mcontactTitleMid)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mcontactTitleBot),expression:"mcontactTitleBot"}],attrs:{"type":"text","placeholder":"Contact Title Bottom","disabled":!_vm.editingContent.contactTitleBot},domProps:{"value":(_vm.mcontactTitleBot)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mcontactTitleBot=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Contact Title Bottom")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.contactTitleBot)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('contactTitleBot')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.contactTitleBot)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('contactTitleBot', _vm.mcontactTitleBot)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mcontactDynamicText1),expression:"mcontactDynamicText1"}],attrs:{"type":"text","placeholder":"Contact Dynamic Text 1","disabled":!_vm.editingContent.contactDynamicText1},domProps:{"value":(_vm.mcontactDynamicText1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mcontactDynamicText1=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Contact Dynamic Text 1")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.contactDynamicText1)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('contactDynamicText1')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.contactDynamicText1)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('contactDynamicText1', _vm.mcontactDynamicText1)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mcontactDynamicText2),expression:"mcontactDynamicText2"}],attrs:{"type":"text","placeholder":"Contact Dynamic Text 2","disabled":!_vm.editingContent.contactDynamicText2},domProps:{"value":(_vm.mcontactDynamicText2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mcontactDynamicText2=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Contact Dynamic Text 2")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.contactDynamicText2)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('contactDynamicText2')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.contactDynamicText2)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('contactDynamicText2', _vm.mcontactDynamicText2)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mcontactDynamicText3),expression:"mcontactDynamicText3"}],attrs:{"type":"text","placeholder":"Contact Dynamic Text 3","disabled":!_vm.editingContent.contactDynamicText3},domProps:{"value":(_vm.mcontactDynamicText3)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mcontactDynamicText3=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Contact Dynamic Text 3")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.contactDynamicText3)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('contactDynamicText3')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.contactDynamicText3)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('contactDynamicText3', _vm.mcontactDynamicText3)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mcontactDynamicText4),expression:"mcontactDynamicText4"}],attrs:{"type":"text","placeholder":"Contact Dynamic Text 4","disabled":!_vm.editingContent.contactDynamicText4},domProps:{"value":(_vm.mcontactDynamicText4)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mcontactDynamicText4=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Contact Dynamic Text 4")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.contactDynamicText4)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('contactDynamicText4')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.contactDynamicText4)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('contactDynamicText4', _vm.mcontactDynamicText4)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.maboutUsFooter),expression:"maboutUsFooter"}],attrs:{"type":"text","placeholder":"About Us Footer","disabled":!_vm.editingContent.aboutUsFooter},domProps:{"value":(_vm.maboutUsFooter)},on:{"input":function($event){if($event.target.composing){ return; }_vm.maboutUsFooter=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("About Us Footer")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.aboutUsFooter)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('aboutUsFooter')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.aboutUsFooter)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('aboutUsFooter', _vm.maboutUsFooter)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.msubscribeFooter),expression:"msubscribeFooter"}],attrs:{"type":"text","placeholder":"Subscribe Footer","disabled":!_vm.editingContent.subscribeFooter},domProps:{"value":(_vm.msubscribeFooter)},on:{"input":function($event){if($event.target.composing){ return; }_vm.msubscribeFooter=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Subscribe Footer")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.subscribeFooter)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('subscribeFooter')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.subscribeFooter)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('subscribeFooter', _vm.msubscribeFooter)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"11","md":"11","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.msocialMediaFooter),expression:"msocialMediaFooter"}],attrs:{"type":"text","placeholder":"Social Media Footer","disabled":!_vm.editingContent.socialMediaFooter},domProps:{"value":(_vm.msocialMediaFooter)},on:{"input":function($event){if($event.target.composing){ return; }_vm.msocialMediaFooter=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("sort")])])]),_vm._v(" "),_c('div',{staticClass:"sectionTitle"},[_vm._v("Social Media Footer")])]),_vm._v(" "),_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"1","md":"1","sm":"12","xs":"12"}},[(!_vm.editingContent.socialMediaFooter)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.editContent('socialMediaFooter')}}},[_vm._v("\n          Edit\n        ")]):_vm._e(),_vm._v(" "),(_vm.editingContent.socialMediaFooter)?_c('div',{staticClass:"text-center text-uppercase actionBtn",on:{"click":function($event){_vm.saveContentById('socialMediaFooter', _vm.msocialMediaFooter)}}},[_vm._v("\n          Save\n        ")]):_vm._e()])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddProduct_vue__ = __webpack_require__(128);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2660de5a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddProduct_vue__ = __webpack_require__(281);
function injectStyle (ssrContext) {
  __webpack_require__(280)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2660de5a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddProduct_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2660de5a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddProduct_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 280 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"addProduct",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('div',{staticClass:"text-left text-uppercase title p-3"},[_c('i',{staticClass:"material-icons smallIcon",on:{"click":_vm.goBack}},[_vm._v("arrow_back_ios")]),_vm._v("\n          Add Product\n        ")])])],1),_vm._v(" "),_c('b-row',{staticClass:"m-4"},[_c('b-col',{staticClass:"box text-left questionBox",attrs:{"lg":"3","md":"3","sm":"12","xs":"12"}},[_vm._v("\n        Product Name\n      ")]),_vm._v(" "),_c('b-col',{staticClass:"box text-left answerBox",attrs:{"lg":"9","md":"9","sm":"12","xs":"12"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.name),expression:"product.name"}],attrs:{"type":"text","placeholder":"Product Name"},domProps:{"value":(_vm.product.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "name", $event.target.value)}}})]),_vm._v(" "),_c('b-col',{staticClass:"box text-left questionBox",attrs:{"lg":"3","md":"3","sm":"12","xs":"12"}},[_vm._v("\n        Description\n      ")]),_vm._v(" "),_c('b-col',{staticClass:"box text-left answerBox",attrs:{"lg":"9","md":"9","sm":"12","xs":"12"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.description),expression:"product.description"}],attrs:{"type":"text","placeholder":"Description"},domProps:{"value":(_vm.product.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "description", $event.target.value)}}})]),_vm._v(" "),_c('b-col',{staticClass:"box text-left questionBox",attrs:{"lg":"3","md":"3","sm":"12","xs":"12"}},[_vm._v("\n        Image File\n      ")]),_vm._v(" "),_c('b-col',{staticClass:"box text-left answerBox",attrs:{"lg":"9","md":"9","sm":"12","xs":"12"}},[_c('input',{attrs:{"type":"file","name":_vm.productImage,"disabled":false,"accept":"image/*"},on:{"change":function($event){_vm.filesChange($event.target.name, $event.target.files[0]); _vm.fileCount = $event.target.files.length}}})]),_vm._v(" "),_c('b-col',{staticClass:"submitBtn text-left mt-5",attrs:{"lg":"12","md":"12","sm":"12","xs":"12"}},[_c('div',{staticClass:"p-3 text-center text-uppercase",on:{"click":function($event){_vm.addProduct()}}},[_vm._v("\n          Add\n        ")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditProduct_vue__ = __webpack_require__(129);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ddc255c2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditProduct_vue__ = __webpack_require__(284);
function injectStyle (ssrContext) {
  __webpack_require__(283)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ddc255c2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditProduct_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ddc255c2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditProduct_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 283 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"editProduct",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('div',{staticClass:"text-left text-uppercase title p-3"},[_c('i',{staticClass:"material-icons smallIcon",on:{"click":_vm.goBack}},[_vm._v("arrow_back_ios")]),_vm._v("\n          Edit Product\n        ")])])],1),_vm._v(" "),(_vm.editingProduct != null && _vm.editingProduct.attributes != null)?_c('b-row',{staticClass:"m-4"},[_c('b-col',{staticClass:"box text-left questionBox",attrs:{"lg":"3","md":"3","sm":"12","xs":"12"}},[_vm._v("\n        Product Name\n      ")]),_vm._v(" "),_c('b-col',{staticClass:"box text-left answerBox",attrs:{"lg":"9","md":"9","sm":"12","xs":"12"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editingProduct.attributes.name),expression:"editingProduct.attributes.name"}],attrs:{"type":"text","placeholder":"Product Name"},domProps:{"value":(_vm.editingProduct.attributes.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editingProduct.attributes, "name", $event.target.value)}}})]),_vm._v(" "),_c('b-col',{staticClass:"box text-left questionBox",attrs:{"lg":"3","md":"3","sm":"12","xs":"12"}},[_vm._v("\n        Description\n      ")]),_vm._v(" "),_c('b-col',{staticClass:"box text-left answerBox",attrs:{"lg":"9","md":"9","sm":"12","xs":"12"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editingProduct.attributes.description),expression:"editingProduct.attributes.description"}],attrs:{"type":"text","placeholder":"Description"},domProps:{"value":(_vm.editingProduct.attributes.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editingProduct.attributes, "description", $event.target.value)}}})]),_vm._v(" "),_c('b-col',{staticClass:"box text-left questionBox",attrs:{"lg":"3","md":"3","sm":"12","xs":"12"}},[_vm._v("\n        Image\n      ")]),_vm._v(" "),_c('b-col',{staticClass:"box text-left answerBox",attrs:{"lg":"9","md":"9","sm":"12","xs":"12"}},[(_vm.editingProduct.attributes.image != null)?_c('img',{staticStyle:{"width":"500px"},attrs:{"src":_vm.getImage(_vm.editingProduct.attributes.image.data.attributes.url, 'url')}}):_vm._e()]),_vm._v(" "),_c('b-col',{staticClass:"box text-left questionBox",attrs:{"lg":"3","md":"3","sm":"12","xs":"12"}},[_vm._v("\n        Change Image\n      ")]),_vm._v(" "),_c('b-col',{staticClass:"box text-left answerBox",attrs:{"lg":"9","md":"9","sm":"12","xs":"12"}},[_c('input',{attrs:{"type":"file","multiple":"","name":_vm.productImage,"disabled":false,"accept":"image/*"},on:{"change":function($event){_vm.filesChange($event.target.name, $event.target.files[0]); _vm.fileCount = $event.target.files.length}}})]),_vm._v(" "),_c('b-col',{staticClass:"submitBtn text-left",attrs:{"lg":"12","md":"12","sm":"12","xs":"12"}},[_c('div',{staticClass:"p-3 text-center text-uppercase",on:{"click":function($event){_vm.editProduct(_vm.editingProduct)}}},[_vm._v("\n          Edit\n        ")])])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddProject_vue__ = __webpack_require__(130);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_903ce904_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddProject_vue__ = __webpack_require__(287);
function injectStyle (ssrContext) {
  __webpack_require__(286)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-903ce904"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddProject_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_903ce904_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddProject_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 286 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"addProject",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('div',{staticClass:"text-left text-uppercase title p-3"},[_c('i',{staticClass:"material-icons smallIcon",on:{"click":_vm.goBack}},[_vm._v("arrow_back_ios")]),_vm._v("\n          Add Project\n        ")])])],1),_vm._v(" "),_c('b-row',{staticClass:"m-4"},[_c('b-col',{staticClass:"box text-left questionBox",attrs:{"lg":"3","md":"3","sm":"12","xs":"12"}},[_vm._v("\n        Project Name\n      ")]),_vm._v(" "),_c('b-col',{staticClass:"box text-left answerBox",attrs:{"lg":"9","md":"9","sm":"12","xs":"12"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.project.name),expression:"project.name"}],attrs:{"type":"text","placeholder":"Project Name"},domProps:{"value":(_vm.project.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.project, "name", $event.target.value)}}})]),_vm._v(" "),_c('b-col',{staticClass:"box text-left questionBox",attrs:{"lg":"3","md":"3","sm":"12","xs":"12"}},[_vm._v("\n        City\n      ")]),_vm._v(" "),_c('b-col',{staticClass:"box text-left answerBox",attrs:{"lg":"9","md":"9","sm":"12","xs":"12"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.project.city),expression:"project.city"}],attrs:{"type":"text","placeholder":"City"},domProps:{"value":(_vm.project.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.project, "city", $event.target.value)}}})]),_vm._v(" "),_c('b-col',{staticClass:"box text-left questionBox",attrs:{"lg":"3","md":"3","sm":"12","xs":"12"}},[_vm._v("\n        Description\n      ")]),_vm._v(" "),_c('b-col',{staticClass:"box text-left answerBox",attrs:{"lg":"9","md":"9","sm":"12","xs":"12"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.project.description),expression:"project.description"}],attrs:{"type":"text","placeholder":"Description"},domProps:{"value":(_vm.project.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.project, "description", $event.target.value)}}})]),_vm._v(" "),_c('b-col',{staticClass:"box text-left questionBox",attrs:{"lg":"3","md":"3","sm":"12","xs":"12"}},[_vm._v("\n        Image File\n      ")]),_vm._v(" "),_c('b-col',{staticClass:"box text-left answerBox",attrs:{"lg":"9","md":"9","sm":"12","xs":"12"}},[_c('input',{attrs:{"type":"file","disabled":false,"accept":"image/*"},on:{"change":function($event){_vm.filesChange($event.target.name, $event.target.files[0]); _vm.fileCount = $event.target.files.length}}})]),_vm._v(" "),_c('b-col',{staticClass:"submitBtn text-left mt-5",attrs:{"lg":"12","md":"12","sm":"12","xs":"12"}},[_c('div',{staticClass:"p-3 text-center text-uppercase",on:{"click":function($event){_vm.addProject()}}},[_vm._v("\n          Add\n        ")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddClient_vue__ = __webpack_require__(131);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0eef107c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddClient_vue__ = __webpack_require__(290);
function injectStyle (ssrContext) {
  __webpack_require__(289)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0eef107c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddClient_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0eef107c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddClient_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 289 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"addClient",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('div',{staticClass:"text-left text-uppercase title p-3"},[_c('i',{staticClass:"material-icons smallIcon",on:{"click":_vm.goBack}},[_vm._v("arrow_back_ios")]),_vm._v("\n          Add Client\n        ")])])],1),_vm._v(" "),_c('b-row',{staticClass:"m-4"},[_c('b-col',{staticClass:"box text-left questionBox",attrs:{"lg":"3","md":"3","sm":"12","xs":"12"}},[_vm._v("\n        Client Name\n      ")]),_vm._v(" "),_c('b-col',{staticClass:"box text-left answerBox",attrs:{"lg":"9","md":"9","sm":"12","xs":"12"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.client.name),expression:"client.name"}],attrs:{"type":"text","placeholder":"Client Name"},domProps:{"value":(_vm.client.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.client, "name", $event.target.value)}}})]),_vm._v(" "),_c('b-col',{staticClass:"box text-left questionBox",attrs:{"lg":"3","md":"3","sm":"12","xs":"12"}},[_vm._v("\n        Image File\n      ")]),_vm._v(" "),_c('b-col',{staticClass:"box text-left answerBox",attrs:{"lg":"9","md":"9","sm":"12","xs":"12"}},[_c('input',{attrs:{"type":"file","multiple":"","disabled":false,"accept":"image/*"},on:{"change":function($event){_vm.filesChange($event.target.name, $event.target.files[0]); _vm.fileCount = $event.target.files.length}}})]),_vm._v(" "),_c('b-col',{staticClass:"submitBtn text-left mt-5",attrs:{"lg":"12","md":"12","sm":"12","xs":"12"}},[_c('div',{staticClass:"p-3 text-center text-uppercase",on:{"click":function($event){_vm.addClient()}}},[_vm._v("\n          Add\n        ")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditProject_vue__ = __webpack_require__(132);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d607d75_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditProject_vue__ = __webpack_require__(293);
function injectStyle (ssrContext) {
  __webpack_require__(292)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1d607d75"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditProject_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d607d75_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditProject_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 292 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"editProject",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('div',{staticClass:"text-left text-uppercase title p-3"},[_c('i',{staticClass:"material-icons smallIcon",on:{"click":_vm.goBack}},[_vm._v("arrow_back_ios")]),_vm._v("\n          Edit Project\n        ")])])],1),_vm._v(" "),(_vm.editingProject != null && _vm.editingProject.attributes != null)?_c('b-row',{staticClass:"m-4"},[_c('b-col',{staticClass:"box text-left questionBox",attrs:{"lg":"3","md":"3","sm":"12","xs":"12"}},[_vm._v("\n        Project Name\n      ")]),_vm._v(" "),_c('b-col',{staticClass:"box text-left answerBox",attrs:{"lg":"9","md":"9","sm":"12","xs":"12"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editingProject.attributes.name),expression:"editingProject.attributes.name"}],attrs:{"type":"text","placeholder":"Project Name"},domProps:{"value":(_vm.editingProject.attributes.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editingProject.attributes, "name", $event.target.value)}}})]),_vm._v(" "),_c('b-col',{staticClass:"box text-left questionBox",attrs:{"lg":"3","md":"3","sm":"12","xs":"12"}},[_vm._v("\n        City\n      ")]),_vm._v(" "),_c('b-col',{staticClass:"box text-left answerBox",attrs:{"lg":"9","md":"9","sm":"12","xs":"12"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editingProject.attributes.city),expression:"editingProject.attributes.city"}],attrs:{"type":"text","placeholder":"City"},domProps:{"value":(_vm.editingProject.attributes.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editingProject.attributes, "city", $event.target.value)}}})]),_vm._v(" "),_c('b-col',{staticClass:"box text-left questionBox",attrs:{"lg":"3","md":"3","sm":"12","xs":"12"}},[_vm._v("\n        Description\n      ")]),_vm._v(" "),_c('b-col',{staticClass:"box text-left answerBox",attrs:{"lg":"9","md":"9","sm":"12","xs":"12"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editingProject.attributes.description),expression:"editingProject.attributes.description"}],attrs:{"type":"text","placeholder":"Description"},domProps:{"value":(_vm.editingProject.attributes.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editingProject.attributes, "description", $event.target.value)}}})]),_vm._v(" "),_c('b-col',{staticClass:"box text-left questionBox",attrs:{"lg":"3","md":"3","sm":"12","xs":"12"}},[_vm._v("\n        Image\n      ")]),_vm._v(" "),_c('b-col',{staticClass:"box text-left answerBox",attrs:{"lg":"9","md":"9","sm":"12","xs":"12"}},[(_vm.editingProject.attributes.images.data.length > 0)?_c('img',{staticStyle:{"width":"500px"},attrs:{"src":_vm.getImage(_vm.editingProject.attributes.images.data[0].attributes.url, 'url')}}):_vm._e()]),_vm._v(" "),_c('b-col',{staticClass:"box text-left questionBox",attrs:{"lg":"3","md":"3","sm":"12","xs":"12"}},[_vm._v("\n        Change Image\n      ")]),_vm._v(" "),_c('b-col',{staticClass:"box text-left answerBox",attrs:{"lg":"9","md":"9","sm":"12","xs":"12"}},[_c('input',{attrs:{"type":"file","multiple":"","name":_vm.projectImage,"disabled":false,"accept":"image/*"},on:{"change":function($event){_vm.filesChange($event.target.name, $event.target.files[0]); _vm.fileCount = $event.target.files.length}}})]),_vm._v(" "),_c('b-col',{staticClass:"submitBtn text-left mt-5",attrs:{"lg":"12","md":"12","sm":"12","xs":"12"}},[_c('div',{staticClass:"p-3 text-center text-uppercase",on:{"click":function($event){_vm.editProject(_vm.editingProject)}}},[_vm._v("\n          Edit\n        ")])])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Inquiries_vue__ = __webpack_require__(133);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59c0c97e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Inquiries_vue__ = __webpack_require__(296);
function injectStyle (ssrContext) {
  __webpack_require__(295)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-59c0c97e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Inquiries_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59c0c97e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Inquiries_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 295 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"inquiries",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('div',{staticClass:"text-left text-uppercase title p-3"},[_vm._v("\n          All Inquiries\n        ")])])],1),_vm._v(" "),_c('b-row',{staticClass:"m-2"},_vm._l((_vm.inquiries),function(inquiry,index){return _c('b-col',{key:index,staticClass:"box text-left mb-3 pb-3 pt-2",class:{even:index%2},attrs:{"lg":"4","md":"4","sm":"12","xs":"12"}},[_c('div',[_vm._v("Name : "+_vm._s(inquiry.name))]),_vm._v(" "),_c('div',[_vm._v("Email : "+_vm._s(inquiry.email))]),_vm._v(" "),_c('div',[_vm._v("Phone No. : "+_vm._s(inquiry.phoneNumber))])])}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IncomingContactForms_vue__ = __webpack_require__(134);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25a7b0cc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IncomingContactForms_vue__ = __webpack_require__(299);
function injectStyle (ssrContext) {
  __webpack_require__(298)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-25a7b0cc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IncomingContactForms_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25a7b0cc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IncomingContactForms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 298 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"incomingContactForms",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('div',{staticClass:"text-left text-uppercase title p-3"},[_vm._v("\n          All Incoming Contact Forms\n        ")])])],1),_vm._v(" "),_c('b-row',{staticClass:"m-2"},_vm._l((_vm.lists),function(contact,index){return _c('b-col',{key:index,staticClass:"box text-left mb-3 pb-3 pt-2",class:{even:index%2},attrs:{"lg":"4","md":"4","sm":"12","xs":"12"}},[_c('div',[_vm._v("Subject : "+_vm._s(contact.subject))]),_vm._v(" "),_c('div',[_vm._v("Name : "+_vm._s(contact.name))]),_vm._v(" "),_c('div',[_vm._v("Email : "+_vm._s(contact.email))]),_vm._v(" "),_c('div',[_vm._v("Phone Number : "+_vm._s(contact.phoneNumber))]),_vm._v(" "),_c('div',{staticClass:"text-justify"},[_vm._v("Message : "+_vm._s(contact.message))])])}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmailSubscribers_vue__ = __webpack_require__(135);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_995b8246_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmailSubscribers_vue__ = __webpack_require__(302);
function injectStyle (ssrContext) {
  __webpack_require__(301)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-995b8246"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmailSubscribers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_995b8246_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmailSubscribers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 301 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"subscribers",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('div',{staticClass:"text-left text-uppercase title p-3"},[_vm._v("\n          All Subscribers\n        ")])])],1),_vm._v(" "),(_vm.subscribers.length < 1)?_c('b-row',{staticClass:"m-2"},[_c('b-col',{staticClass:"box pb-3 pt-2",attrs:{"lg":"12","md":"12","sm":"12","xs":"12"}},[_vm._v("\n        No subscribers.\n      ")])],1):_vm._e(),_vm._v(" "),(_vm.subscribers.length > 0)?_c('b-row',{staticClass:"m-2"},_vm._l((_vm.subscribers),function(subscriber,index){return _c('b-col',{key:index,staticClass:"box text-left pb-3 pt-2",class:{even:index%2},attrs:{"lg":"12","md":"12","sm":"12","xs":"12"}},[_c('div',{staticClass:"remove",on:{"click":function($event){_vm.unsubscribe(subscriber)}}},[_vm._v("Unsubscribe")]),_vm._v(" "+_vm._s(subscriber)+"\n      ")])})):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComposeEmail_vue__ = __webpack_require__(136);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_288eb8be_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComposeEmail_vue__ = __webpack_require__(309);
function injectStyle (ssrContext) {
  __webpack_require__(304)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-288eb8be"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComposeEmail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_288eb8be_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComposeEmail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 304 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"composeEmail",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('div',{staticClass:"text-left text-uppercase title p-3"},[_vm._v("\n        Compose Email\n      ")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"box mt-3 text-left",attrs:{"lg":"12","md":"12","sm":"12","xs":"12"}},[_c('div',{staticClass:"fieldWrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.emailSubject),expression:"emailSubject"}],attrs:{"type":"text","placeholder":"Email Subject"},domProps:{"value":(_vm.emailSubject)},on:{"input":function($event){if($event.target.composing){ return; }_vm.emailSubject=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"prefixIcon"},[_c('i',{staticClass:"material-icons"},[_vm._v("email")])])]),_vm._v(" "),_c('VueTrix',{attrs:{"inputId":"editor1"},model:{value:(_vm.emailContent),callback:function ($$v) {_vm.emailContent=$$v},expression:"emailContent"}}),_vm._v(" "),(!_vm.showConfirmationBox)?_c('div',{staticClass:"generalBtn p-3 text-center text-uppercase",on:{"click":function($event){_vm.showBox()}}},[_vm._v("\n        Blast Email\n      ")]):_vm._e(),_vm._v(" "),(_vm.showConfirmationBox)?_c('div',[_c('div',{staticClass:"p-3 text-center text-uppercase"},[_vm._v("\n          Are you sure?\n          "),_c('b-row',{staticClass:"mt-3"},[_c('b-col',{staticClass:"noBtn p-3 text-center text-uppercase",attrs:{"lg":"6","md":"6","sm":"6","xs":"6"},on:{"click":function($event){_vm.hideBox()}}},[_vm._v("\n              No\n            ")]),_vm._v(" "),_c('b-col',{staticClass:"yesBtn p-3 text-center text-uppercase",attrs:{"lg":"6","md":"6","sm":"6","xs":"6"},on:{"click":function($event){_vm.blastEmail()}}},[_vm._v("\n              Yes\n            ")])],1)],1)]):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_backend__ = __webpack_require__(311);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]); // to activate vuex

var state = {
  totalInquiries: 0,
  totalSubscribers: 0,
  phoneNumber: {},
  phoneNumberId: 0,
  homeTitleTop: {},
  homeTitleTopId: 0,
  homeTitleMid: {},
  homeTitleMidId: {},
  homeTitleBot: {},
  homeTitleBotId: {},
  homeDynamicText1: {},
  homeDynamicText2: {},
  homeDynamicText3: {},
  aboutTitleTop: {},
  aboutTitleMid: {},
  aboutTitleBot: {},
  aboutDynamicText1: {},
  aboutDynamicText2: {},
  aboutWhyUsTitle1: {},
  aboutWhyUsDescription1: {},
  aboutWhyUsTitle2: {},
  aboutWhyUsDescription2: {},
  aboutWhyUsTitle3: {},
  aboutWhyUsDescription3: {},
  aboutWhyUsTitle4: {},
  aboutWhyUsDescription4: {},
  visionMissionTitle1: {},
  visionMissionDescription1: {},
  visionMissionTitle2: {},
  visionMissionDescription2: {},
  visionMissionTitle3: {},
  visionMissionDescription3: {},
  visionMissionTitle4: {},
  visionMissionDescription4: {},
  visionMissionTitle5: {},
  visionMissionDescription5: {},
  visionMissionTitle6: {},
  visionMissionDescription6: {},
  visionMissionTitle7: {},
  visionMissionDescription7: {},
  visionMissionTitle8: {},
  visionMissionDescription8: {},
  serviceTitleTop: {},
  serviceTitleMid: {},
  serviceTitleBot: {},
  serviceDynamicText1: {},
  serviceDynamicText2: {},
  serviceDynamicText3: {},
  serviceDynamicText4: {},
  serviceDynamicText5: {},
  serviceDynamicText6: {},
  serviceDynamicText7: {},
  serviceDynamicText8: {},
  serviceDynamicText9: {},
  serviceDynamicText10: {},
  serviceDynamicText11: {},
  serviceDynamicText12: {},
  serviceDynamicText13: {},
  projectTitleTop: {},
  projectTitleMid: {},
  projectTitleBot: {},
  productTitleTop: {},
  productTitleMid: {},
  productTitleBot: {},
  contactTitleMid: {},
  contactTitleBot: {},
  contactDynamicText1: {},
  contactDynamicText2: {},
  contactDynamicText3: {},
  contactDynamicText4: {},
  homeDynamicText1Id: {},
  homeDynamicText2Id: {},
  homeDynamicText3Id: {},
  aboutTitleTopId: {},
  aboutTitleMidId: {},
  aboutTitleBotId: {},
  aboutDynamicText1Id: {},
  aboutDynamicText2Id: {},
  aboutWhyUsTitle1Id: {},
  aboutWhyUsDescription1Id: {},
  aboutWhyUsTitle2Id: {},
  aboutWhyUsDescription2Id: {},
  aboutWhyUsTitle3Id: {},
  aboutWhyUsDescription3Id: {},
  aboutWhyUsTitle4Id: {},
  aboutWhyUsDescription4Id: {},
  visionMissionTitle1Id: {},
  visionMissionDescription1Id: {},
  visionMissionTitle2Id: {},
  visionMissionDescription2Id: {},
  visionMissionTitle3Id: {},
  visionMissionDescription3Id: {},
  visionMissionTitle4Id: {},
  visionMissionDescription4Id: {},
  visionMissionTitle5Id: {},
  visionMissionDescription5Id: {},
  visionMissionTitle6Id: {},
  visionMissionDescription6Id: {},
  visionMissionTitle7Id: {},
  visionMissionDescription7Id: {},
  visionMissionTitle8Id: {},
  visionMissionDescription8Id: {},
  serviceTitleTopId: {},
  serviceTitleMidId: {},
  serviceTitleBotId: {},
  serviceDynamicText1Id: {},
  serviceDynamicText2Id: {},
  serviceDynamicText3Id: {},
  serviceDynamicText4Id: {},
  serviceDynamicText5Id: {},
  serviceDynamicText6Id: {},
  serviceDynamicText7Id: {},
  serviceDynamicText8Id: {},
  serviceDynamicText9Id: {},
  serviceDynamicText10Id: {},
  serviceDynamicText11Id: {},
  serviceDynamicText12Id: {},
  serviceDynamicText13Id: {},
  projectTitleTopId: {},
  projectTitleMidId: {},
  projectTitleBotId: {},
  productTitleTopId: {},
  productTitleMidId: {},
  productTitleBotId: {},
  contactTitleMidId: {},
  contactTitleBotId: {},
  contactDynamicText1Id: {},
  contactDynamicText2Id: {},
  contactDynamicText3Id: {},
  contactDynamicText4Id: {},
  aboutUsFooter: {},
  subscribeFooter: {},
  socialMediaFooter: {},
  inquiries: [],
  editingProduct: {},
  editingProject: {},
  products: [],
  projects: [],
  clients: [],
  subscribers: [],
  isLoggedIn: false,
  user: {},
  username: '',
  memberId: '',
  isLoading: false,
  choosingBank: false,
  paymentLimit: 0,
  editingAddress: {},
  countTotalItemInCart: 0,
  deliveryMethod: '',
  choosenOutlet: {
    id: '0',
    name: ''
  },
  totalCartWeight: 0,
  nearestOutlet: {},
  choosenPayment: {
    type: '',
    bankName: ''
  },
  shippingDestination: {},
  cart: {
    totalAmount: 0,
    orderAmount: 0,
    shippingAmount: 0,
    deliveryMethod: '',
    outlet: {
      id: '0',
      name: ''
    },
    payment: {
      type: '',
      bankId: '',
      bankName: ''
    },
    cartItems: [],
    shippingDestination: {}
  },
  profile: {},
  thankYou: {},
  orderList: {
    ongoing: [],
    finished: [],
    cancelled: []
  },
  pagingOrderOngoing: {},
  pagingOrderDone: {},
  pagingOrderCancelled: {},
  pagingOutlets: {}
};

var mutations = {
  setContentById: function setContentById(state, data) {
    var key = data.data.attributes.key;
    var value = data.data.attributes.value;
    var id = data.data.id;
    if (key === 'cPhoneNumber') {
      state.phoneNumber = value;
      state.phoneNumberId = id;
    } else if (key === 'homeTitleTop') {
      state.homeTitleTop = value;
      state.homeTitleTopId = id;
    } else if (key === 'homeTitleMid') {
      state.homeTitleMid = value;
      state.homeTitleMidId = id;
    } else if (key === 'homeTitleBot') {
      state.homeTitleBot = value;
      state.homeTitleBotId = id;
    } else if (key === 'homeDynamicText1') {
      state.homeDynamicText1 = value;
      state.homeDynamicText1Id = id;
    } else if (key === 'homeDynamicText2') {
      state.homeDynamicText2 = value;
      state.homeDynamicText2Id = id;
    } else if (key === 'homeDynamicText3') {
      state.homeDynamicText3 = value;
      state.homeDynamicText3Id = id;
    } else if (key === 'aboutTitleTop') {
      state.aboutTitleTop = value;
      state.aboutTitleTopId = id;
    } else if (key === 'aboutTitleMid') {
      state.aboutTitleMid = value;
      state.aboutTitleMidId = id;
    } else if (key === 'aboutTitleBot') {
      state.aboutTitleBot = value;
      state.aboutTitleBotId = id;
    } else if (key === 'aboutDynamicText1') {
      state.aboutDynamicText1 = value;
      state.aboutDynamicText1Id = id;
    } else if (key === 'aboutDynamicText2') {
      state.aboutDynamicText2 = value;
      state.aboutDynamicText2Id = id;
    } else if (key === 'aboutWhyUsTitle1') {
      state.aboutWhyUsTitle1 = value;
      state.aboutWhyUsTitle1Id = id;
    } else if (key === 'aboutWhyUsDescription1') {
      state.aboutWhyUsDescription1 = value;
      state.aboutWhyUsDescription1Id = id;
    } else if (key === 'aboutWhyUsTitle2') {
      state.aboutWhyUsTitle2 = value;
      state.aboutWhyUsTitle2Id = id;
    } else if (key === 'aboutWhyUsDescription2') {
      state.aboutWhyUsDescription2 = value;
      state.aboutWhyUsDescription2Id = id;
    } else if (key === 'aboutWhyUsTitle3') {
      state.aboutWhyUsTitle3 = value;
      state.aboutWhyUsTitle3Id = id;
    } else if (key === 'aboutWhyUsDescription3') {
      state.aboutWhyUsDescription3 = value;
      state.aboutWhyUsDescription3Id = id;
    } else if (key === 'aboutWhyUsTitle4') {
      state.aboutWhyUsTitle4 = value;
      state.aboutWhyUsTitle4Id = id;
    } else if (key === 'aboutWhyUsDescription4') {
      state.aboutWhyUsDescription4 = value;
      state.aboutWhyUsDescription4Id = id;
    } else if (key === 'visionMissionTitle1') {
      state.visionMissionTitle1 = value;
      state.visionMissionTitle1Id = id;
    } else if (key === 'visionMissionDescription1') {
      state.visionMissionDescription1 = value;
      state.visionMissionDescription1Id = id;
    } else if (key === 'visionMissionTitle2') {
      state.visionMissionTitle2 = value;
      state.visionMissionTitle2Id = id;
    } else if (key === 'visionMissionDescription2') {
      state.visionMissionDescription2 = value;
      state.visionMissionDescription2Id = id;
    } else if (key === 'visionMissionTitle3') {
      state.visionMissionTitle3 = value;
      state.visionMissionTitle3Id = id;
    } else if (key === 'visionMissionDescription3') {
      state.visionMissionDescription3 = value;
      state.visionMissionDescription3Id = id;
    } else if (key === 'visionMissionTitle4') {
      state.visionMissionTitle4 = value;
      state.visionMissionTitle4Id = id;
    } else if (key === 'visionMissionDescription4') {
      state.visionMissionDescription4 = value;
      state.visionMissionDescription4Id = id;
    } else if (key === 'visionMissionTitle5') {
      state.visionMissionTitle5 = value;
      state.visionMissionTitle5Id = id;
    } else if (key === 'visionMissionDescription5') {
      state.visionMissionDescription5 = value;
      state.visionMissionDescription5Id = id;
    } else if (key === 'visionMissionTitle6') {
      state.visionMissionTitle6 = value;
      state.visionMissionTitle6Id = id;
    } else if (key === 'visionMissionDescription6') {
      state.visionMissionDescription6 = value;
      state.visionMissionDescription6Id = id;
    } else if (key === 'visionMissionTitle7') {
      state.visionMissionTitle7 = value;
      state.visionMissionTitle7Id = id;
    } else if (key === 'visionMissionDescription7') {
      state.visionMissionDescription7 = value;
      state.visionMissionDescription7Id = id;
    } else if (key === 'visionMissionTitle8') {
      state.visionMissionTitle8 = value;
      state.visionMissionTitle8Id = id;
    } else if (key === 'visionMissionDescription8') {
      state.visionMissionDescription8 = value;
      state.visionMissionDescription8Id = id;
    } else if (key === 'serviceTitleTop') {
      state.serviceTitleTop = value;
      state.serviceTitleTopId = id;
    } else if (key === 'serviceTitleMid') {
      state.serviceTitleMid = value;
      state.serviceTitleMidId = id;
    } else if (key === 'serviceTitleBot') {
      state.serviceTitleBot = value;
      state.serviceTitleBotId = id;
    } else if (key === 'serviceDynamicText1') {
      state.serviceDynamicText1 = value;
      state.serviceDynamicText1Id = id;
    } else if (key === 'serviceDynamicText2') {
      state.serviceDynamicText2 = value;
      state.serviceDynamicText2Id = id;
    } else if (key === 'serviceDynamicText3') {
      state.serviceDynamicText3 = value;
      state.serviceDynamicText3Id = id;
    } else if (key === 'serviceDynamicText4') {
      state.serviceDynamicText4 = value;
      state.serviceDynamicText4Id = id;
    } else if (key === 'serviceDynamicText5') {
      state.serviceDynamicText5 = value;
      state.serviceDynamicText5Id = id;
    } else if (key === 'serviceDynamicText6') {
      state.serviceDynamicText6 = value;
      state.serviceDynamicText6Id = id;
    } else if (key === 'serviceDynamicText7') {
      state.serviceDynamicText7 = value;
      state.serviceDynamicText7Id = id;
    } else if (key === 'serviceDynamicText8') {
      state.serviceDynamicText8 = value;
      state.serviceDynamicText8Id = id;
    } else if (key === 'serviceDynamicText9') {
      state.serviceDynamicText9 = value;
      state.serviceDynamicText9Id = id;
    } else if (key === 'serviceDynamicText10') {
      state.serviceDynamicText10 = value;
      state.serviceDynamicText10Id = id;
    } else if (key === 'serviceDynamicText11') {
      state.serviceDynamicText11 = value;
      state.serviceDynamicText11Id = id;
    } else if (key === 'serviceDynamicText12') {
      state.serviceDynamicText12 = value;
      state.serviceDynamicText12Id = id;
    } else if (key === 'serviceDynamicText13') {
      state.serviceDynamicText13 = value;
      state.serviceDynamicText13Id = id;
    } else if (key === 'projectTitleTop') {
      console.log('project title top ', value);
      console.log('project title top ', id);
      state.projectTitleTop = value;
      state.projectTitleTopId = id;
    } else if (key === 'projectTitleMid') {
      state.projectTitleMid = value;
      state.projectTitleMidId = id;
    } else if (key === 'projectTitleBot') {
      state.projectTitleBot = value;
      state.projectTitleBotId = id;
    } else if (key === 'productTitleTop') {
      state.productTitleTop = value;
      state.productTitleTopId = id;
    } else if (key === 'productTitleMid') {
      state.productTitleMid = value;
      state.productTitleMidId = id;
    } else if (key === 'productTitleBot') {
      state.productTitleBot = value;
      state.productTitleBotId = id;
    } else if (key === 'contactTitleMid') {
      state.contactTitleMid = value;
      state.contactTitleMidId = id;
    } else if (key === 'contactTitleBot') {
      state.contactTitleBot = value;
      state.contactTitleBotId = id;
    } else if (key === 'contactDynamicText1') {
      state.contactDynamicText1 = value;
      state.contactDynamicText1Id = id;
    } else if (key === 'contactDynamicText2') {
      state.contactDynamicText2 = value;
      state.contactDynamicText2Id = id;
    } else if (key === 'contactDynamicText3') {
      state.contactDynamicText3 = value;
      state.contactDynamicText3Id = id;
    } else if (key === 'contactDynamicText4') {
      state.contactDynamicText4 = value;
      state.contactDynamicText4Id = id;
    } else if (key === 'aboutUsFooter') {
      state.aboutUsFooter = value;
      state.aboutUsFooterId = id;
    } else if (key === 'subscribeFooter') {
      state.subscribeFooter = value;
      state.subscribeFooterId = id;
    } else if (key === 'socialMediaFooter') {
      state.socialMediaFooter = value;
      state.socialMediaFooterId = id;
    }
  },
  setPhoneNumber: function setPhoneNumber(state, data) {
    state.phoneNumber = data.data;
  },
  setInquiries: function setInquiries(state, data) {
    state.inquiries = data.inquiries;
    state.totalInquiries = data.totalInquiries;
  },
  setClients: function setClients(state, data) {
    state.clients = data.clients;
  },
  setProducts: function setProducts(state, data) {
    state.products = data.products;
  },
  setProjects: function setProjects(state, data) {
    state.projects = data.projects;
  },
  setEditingProduct: function setEditingProduct(state, data) {
    if (data.product.length > 0) {
      state.editingProduct = data.product[0];
    }
  },
  setEditingProject: function setEditingProject(state, data) {
    state.editingProject = data.project;
  },
  deleteProduct: function deleteProduct(state, data) {
    for (var product in state.products) {
      if (state.products[product].id === data.id) {
        state.products.splice(product, 1);
        break;
      }
    }
  },
  deleteProject: function deleteProject(state, data) {
    for (var project in state.projects) {
      if (state.projects[project].id === data.id) {
        state.projects.splice(project, 1);
        break;
      }
    }
  },
  deleteSubscriber: function deleteSubscriber(state, data) {
    for (var index in state.subscribers) {
      if (state.subscribers[index] === data.email) {
        state.subscribers.splice(index, 1);
        break;
      }
    }
  },
  setSubscribers: function setSubscribers(state, data) {
    state.subscribers = data.subscribers;
    state.totalSubscribers = data.totalSubscribers;
  },
  setIsLoggedInOnly: function setIsLoggedInOnly(state, data) {
    state.isLoggedIn = true;
  },
  setIsLoggedIn: function setIsLoggedIn(state, data) {
    state.isLoggedIn = data.isLoggedIn;
    state.user = data.user;
    if (data.isLoggedIn === false) {
      state.countTotalItemInCart = 0;
    }
  },
  setProfile: function setProfile(state, data) {
    state.profile = data;
    state.memberId = data.id;
  },
  setCart: function setCart(state, data) {
    state.cart = data.cart;
    if (state.cart === null) {
      state.cart = {};
      state.cart.cartItems = [];
    }
  },
  setOrderStatus: function setOrderStatus(state, data) {
    for (var order in state.orderList.ongoing) {
      if (state.orderList.ongoing[order].orderNo === data.orderId) {
        state.orderList.ongoing[order].status = data.status;
        break;
      }
    }
  },
  setOrderList: function setOrderList(state, data) {
    if (data.status === 'ongoing') {
      state.orderList.ongoing = data.orderList;
      state.pagingOrderOngoing = data.paging;
    } else if (data.status === 'finished') {
      state.orderList.finished = data.orderList;
      state.pagingOrderDone = data.paging;
    } else if (data.status === 'cancelled') {
      state.orderList.cancelled = data.orderList;
      state.pagingOrderCancelled = data.paging;
    }
  },
  setOutletList: function setOutletList(state, data) {
    state.pagingOutlets = data.paging;
  },
  addToCart: function addToCart(state, item) {
    if (state.cart.itemListInCart < 1) {
      state.cart.itemListInCart.push(item);
    } else {
      var alreadyInCart = false;
      for (var itemInCart in state.cart.itemListInCart) {
        if (state.cart.itemListInCart[itemInCart].id === item.id) {
          state.cart.itemListInCart[itemInCart].quantity += 1;
          alreadyInCart = true;
        }
      }
      if (!alreadyInCart) {
        state.cart.itemListInCart.push(item);
      }
    }
  },
  resetCartAndSetThankYouPageData: function resetCartAndSetThankYouPageData(state, data) {
    state.cart = {};
    state.countTotalItemInCart = 0;
    state.thankYou = data.thankYou;
  },
  calculateGrandTotal: function calculateGrandTotal(state) {
    if (state.cart !== null) {
      state.cart.orderAmount = 0;
      state.countTotalItemInCart = 0;
      state.totalCartWeight = 0;
      for (var item in state.cart.cartItems) {
        state.totalCartWeight += parseInt(state.cart.cartItems[item].shippingWeight * state.cart.cartItems[item].quantity);
        state.countTotalItemInCart += parseInt(state.cart.cartItems[item].quantity);
        state.cart.orderAmount += state.cart.cartItems[item].quantity * state.cart.cartItems[item].unitPrice;
      }
      state.cart.totalAmount = state.cart.orderAmount;
    }
  },
  updateCartQuantity: function updateCartQuantity(state, data) {
    state.cart.cartItems[data.index].quantity = data.quantity;
  },
  removeFromCart: function removeFromCart(state, data) {
    state.cart.cartItems.splice(data.index, 1);
  },
  setDeliveryMethod: function setDeliveryMethod(state, data) {
    state.cart.deliveryMethod = data.methodCode;
    state.deliveryMethod = data.methodCode;
  },
  setNearestOutlet: function setNearestOutlet(state, data) {
    // useless
    state.nearestOutlet = data.nearestOutlet;
    // will use choosenOutlet
    state.choosenOutlet = data.nearestOutlet;
  },
  setPaymentType: function setPaymentType(state, data) {
    state.choosenPayment.type = data.paymentType;
    if (data.paymentType !== 'transfer') {
      state.choosenPayment.bankId = '';
      state.choosenPayment.bankName = '';
    }
  },
  setEditingAddress: function setEditingAddress(state, data) {
    state.editingAddress = data.address;
  },
  setChoosingBank: function setChoosingBank(state, data) {
    state.choosingBank = data.choosingBank;
  },
  chooseBank: function chooseBank(state, data) {
    state.choosenPayment.bankId = data.bankId;
    state.choosenPayment.bankName = data.bankName;
    state.choosenPayment.paymentMethod = data.paymentMethod;
  },
  setOutletId: function setOutletId(state, data) {
    state.choosenOutlet.id = data.outletId;
    state.choosenOutlet.name = data.outletName;
  },
  setAddressDestination: function setAddressDestination(state, data) {
    state.shippingDestination = data.address;
  },
  addNewAddress: function addNewAddress(state, data) {
    if (state.profile.shippingAddresses === undefined) {
      state.profile.shippingAddresses = [];
    }
    state.profile.shippingAddresses.unshift(data.address);
  },
  getProductDetailByProductId: function getProductDetailByProductId(state, data) {
    console.log('success get Product Detail for ' + data.id);
  },
  getProductListByCategoryName: function getProductListByCategoryName(state, data) {
    console.log('success get productList by categoryName: ' + data.categoryName);
  }
};

var actions = {
  findContentById: function findContentById(_ref) {
    var commit = _ref.commit;

    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref2.data,
        success = _ref2.success,
        fail = _ref2.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].findContentById(function (res) {
      commit('setContentById', {
        data: res.body.data
      });
      success && success(res);
    }, data, fail);
  },
  findAllContents: function findAllContents(_ref3) {
    var commit = _ref3.commit;

    var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref4.data,
        success = _ref4.success,
        fail = _ref4.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].findAllContents(function (res) {
      for (var counter in res.body.data) {
        commit('setContentById', {
          data: res.body.data[counter]
        });
      }

      // for (let product in state.products) {
      //   if (state.products[product].id === data.id) {

      success && success(res);
    }, data, fail);
  },
  uploadFile: function uploadFile(_ref5) {
    var commit = _ref5.commit;

    var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref6.data,
        success = _ref6.success,
        fail = _ref6.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].uploadFile(function (res) {
      success && success(res);
    }, data, fail);
  },
  deleteFile: function deleteFile(_ref7) {
    var commit = _ref7.commit;

    var _ref8 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref8.data,
        success = _ref8.success,
        fail = _ref8.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].deleteFile(function (res) {
      success && success(res);
    }, data, fail);
  },
  saveContentById: function saveContentById(_ref9) {
    var commit = _ref9.commit,
        dispatch = _ref9.dispatch;

    var _ref10 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref10.data,
        success = _ref10.success,
        fail = _ref10.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].editContentById(function (res) {
      commit('setContentById', {
        data: res.body.data
      });
      success && success(res);
    }, data, fail);
  },
  createClient: function createClient(_ref11) {
    var commit = _ref11.commit,
        dispatch = _ref11.dispatch;

    var _ref12 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref12.data,
        success = _ref12.success,
        fail = _ref12.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].createClient(function (res) {
      success && success(res);
    }, data, fail);
  },
  editClient: function editClient(_ref13) {
    var commit = _ref13.commit,
        dispatch = _ref13.dispatch;

    var _ref14 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref14.data,
        success = _ref14.success,
        fail = _ref14.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].editClient(function (res) {
      success && success(res);
    }, data, fail);
  },
  deleteClient: function deleteClient(_ref15) {
    var commit = _ref15.commit,
        dispatch = _ref15.dispatch;

    var _ref16 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref16.data,
        success = _ref16.success,
        fail = _ref16.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].deleteClient(function (res) {
      success && success(res);
    }, data, function (response) {
      fail && fail(response);
    });
  },
  findAllClients: function findAllClients(_ref17) {
    var commit = _ref17.commit;

    var _ref18 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref18.data,
        success = _ref18.success,
        fail = _ref18.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].findAllClients(function (res) {
      success && success(res);
    }, data, fail);
  },
  findClientById: function findClientById(_ref19) {
    var commit = _ref19.commit;

    var _ref20 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref20.data,
        success = _ref20.success,
        fail = _ref20.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].findClientById(function (res) {
      commit('setEditingClient', {
        project: res.body.data
      });
      success && success(res);
    }, data, fail);
  },
  createProject: function createProject(_ref21) {
    var commit = _ref21.commit,
        dispatch = _ref21.dispatch;

    var _ref22 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref22.data,
        success = _ref22.success,
        fail = _ref22.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].createProject(function (res) {
      success && success(res);
    }, data, fail);
  },
  editProject: function editProject(_ref23) {
    var commit = _ref23.commit,
        dispatch = _ref23.dispatch;

    var _ref24 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref24.data,
        success = _ref24.success,
        fail = _ref24.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].editProject(function (res) {
      success && success(res);
    }, data, fail);
  },
  deleteProject: function deleteProject(_ref25) {
    var commit = _ref25.commit,
        dispatch = _ref25.dispatch;

    var _ref26 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref26.data,
        success = _ref26.success,
        fail = _ref26.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].deleteProject(function (res) {
      commit('deleteProject', {
        id: data.id
      });
      success && success(res);
    }, data, function (response) {
      fail && fail(response);
    });
  },
  findAllProjects: function findAllProjects(_ref27) {
    var commit = _ref27.commit;

    var _ref28 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref28.data,
        success = _ref28.success,
        fail = _ref28.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].findAllProjects(function (res) {
      commit('setProjects', {
        projects: res.body.data.content,
        paging: res.body.pageable
      });
      success && success(res);
    }, data, fail);
  },
  findProjectById: function findProjectById(_ref29) {
    var commit = _ref29.commit;

    var _ref30 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref30.data,
        success = _ref30.success,
        fail = _ref30.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].findProjectById(function (res) {
      if (res.body.data.length > 0) {
        commit('setEditingProject', {
          project: res.body.data[0]
        });
      }
      success && success(res);
    }, data, fail);
  },
  createProduct: function createProduct(_ref31) {
    var commit = _ref31.commit,
        dispatch = _ref31.dispatch;

    var _ref32 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref32.data,
        success = _ref32.success,
        fail = _ref32.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].createProduct(function (res) {
      success && success(res);
    }, data, fail);
  },
  editProduct: function editProduct(_ref33) {
    var commit = _ref33.commit,
        dispatch = _ref33.dispatch;

    var _ref34 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref34.data,
        success = _ref34.success,
        fail = _ref34.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].editProduct(function (res) {
      success && success(res);
    }, data, fail);
  },
  deleteProduct: function deleteProduct(_ref35) {
    var commit = _ref35.commit,
        dispatch = _ref35.dispatch;

    var _ref36 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref36.data,
        success = _ref36.success,
        fail = _ref36.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].deleteProduct(function (res) {
      success && success(res);
    }, data, function (response) {
      fail && fail(response);
    });
  },
  findAllProducts: function findAllProducts(_ref37) {
    var commit = _ref37.commit;

    var _ref38 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref38.data,
        success = _ref38.success,
        fail = _ref38.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].findAllProducts(function (res) {
      commit('setProducts', {
        products: res.body.data.content,
        paging: res.body.pageable
      });
      success && success(res);
    }, data, fail);
  },
  findProductById: function findProductById(_ref39) {
    var commit = _ref39.commit;

    var _ref40 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref40.data,
        success = _ref40.success,
        fail = _ref40.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].findProductById(function (res) {
      commit('setEditingProduct', {
        product: res.body.data
      });
      success && success(res);
    }, data, fail);
  },
  login: function login(_ref41) {
    var commit = _ref41.commit,
        dispatch = _ref41.dispatch;

    var _ref42 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref42.data,
        success = _ref42.success,
        fail = _ref42.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].login(function (res) {
      success && success(res);
    }, data, fail);
  },
  createInquiry: function createInquiry(_ref43) {
    var commit = _ref43.commit,
        dispatch = _ref43.dispatch;

    var _ref44 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref44.data,
        success = _ref44.success,
        fail = _ref44.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].createInquiry(function (res) {
      success && success(res);
    }, data, fail);
  },
  sendMessage: function sendMessage(_ref45) {
    var commit = _ref45.commit,
        dispatch = _ref45.dispatch;

    var _ref46 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref46.data,
        success = _ref46.success,
        fail = _ref46.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].sendMessage(function (res) {
      success && success(res);
    }, data, fail);
  },
  getAllInquiries: function getAllInquiries(_ref47) {
    var commit = _ref47.commit;

    var _ref48 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref48.data,
        success = _ref48.success,
        fail = _ref48.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].getAllInquiries(function (res) {
      commit('setInquiries', {
        inquiries: res.body.data.content,
        paging: res.body.pageable,
        totalInquiries: res.body.data.totalElements
      });
      success && success(res);
    }, data, fail);
  },
  subscribe: function subscribe(_ref49) {
    var commit = _ref49.commit,
        dispatch = _ref49.dispatch;

    var _ref50 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref50.data,
        success = _ref50.success,
        fail = _ref50.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].subscribe(function (res) {
      success && success(res);
    }, data, fail);
  },
  unsubscribe: function unsubscribe(_ref51) {
    var commit = _ref51.commit,
        dispatch = _ref51.dispatch;

    var _ref52 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref52.data,
        success = _ref52.success,
        fail = _ref52.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].unsubscribe(function (res) {
      commit('deleteSubscriber', {
        email: data.email
      });
      success && success(res);
    }, data, function (response) {
      fail && fail(response);
    });
    commit('deleteSubscriber', {
      email: data.email
    });
  },
  findAllSubscribers: function findAllSubscribers(_ref53) {
    var commit = _ref53.commit;

    var _ref54 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref54.data,
        success = _ref54.success,
        fail = _ref54.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].findAllSubscribers(function (res) {
      commit('setSubscribers', {
        subscribers: res.body.data.content,
        paging: res.body.pageable,
        totalSubscribers: res.body.data.totalElements
      });
      success && success(res);
    }, data, fail);
  },
  changePassword: function changePassword(_ref55) {
    var commit = _ref55.commit,
        dispatch = _ref55.dispatch;

    var _ref56 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref56.data,
        success = _ref56.success,
        fail = _ref56.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].changePassword(function (res) {
      success && success(res);
    }, data, fail);
  },
  signUp: function signUp(_ref57) {
    var commit = _ref57.commit,
        dispatch = _ref57.dispatch;

    var _ref58 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref58.data,
        success = _ref58.success,
        fail = _ref58.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].signUp(function (res) {
      success && success(res);
    }, data, fail);
  },
  signIn: function signIn(_ref59) {
    var commit = _ref59.commit,
        dispatch = _ref59.dispatch;

    var _ref60 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref60.data,
        success = _ref60.success,
        fail = _ref60.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].signIn(function (res) {
      success && success(res);
    }, data, fail);
  },
  setIsLoggedInOnly: function setIsLoggedInOnly(_ref61) {
    var commit = _ref61.commit;

    var _ref62 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref62.data,
        success = _ref62.success,
        fail = _ref62.fail;

    commit('setIsLoggedInOnly');
    success && success();
  },
  setIsLoggedIn: function setIsLoggedIn(_ref63) {
    var commit = _ref63.commit;

    var _ref64 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref64.data,
        success = _ref64.success,
        fail = _ref64.fail;

    commit('setIsLoggedIn', {
      isLoggedIn: data.isLoggedIn,
      user: data.user
    });
    success && success();
  },
  getProfile: function getProfile(_ref65) {
    var commit = _ref65.commit;

    var _ref66 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref66.data,
        success = _ref66.success,
        fail = _ref66.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].getProfile(function (res) {
      commit('setProfile', res.body.data);
      success && success(res);
    }, data, fail);
  },
  addAddress: function addAddress(_ref67) {
    var commit = _ref67.commit,
        dispatch = _ref67.dispatch;

    var _ref68 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref68.data,
        success = _ref68.success,
        fail = _ref68.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].addAddress(function (res) {
      success && success(res);
    }, data, fail);
  },
  removeAddress: function removeAddress(_ref69) {
    var commit = _ref69.commit,
        dispatch = _ref69.dispatch;

    var _ref70 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref70.data,
        success = _ref70.success,
        fail = _ref70.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].removeAddress(function (res) {
      success && success(res);
    }, data, function (response) {
      fail && fail(response);
    });
  },
  editAddress: function editAddress(_ref71) {
    var commit = _ref71.commit;

    var _ref72 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref72.data,
        success = _ref72.success,
        fail = _ref72.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].editAddress(function (res) {
      success && success(res);
    }, data, fail);
  },
  calculateShippingCost: function calculateShippingCost(_ref73) {
    var commit = _ref73.commit;

    var _ref74 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref74.data,
        success = _ref74.success,
        fail = _ref74.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].calculateShippingCost(function (res) {
      success && success(res);
    }, data, fail);
  },
  getNearestOutlet: function getNearestOutlet(_ref75) {
    var commit = _ref75.commit;

    var _ref76 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref76.data,
        success = _ref76.success,
        fail = _ref76.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].getNearestOutlet(function (res) {
      success && success(res);
      commit('setNearestOutlet', {
        nearestOutlet: res.body.data
      });
    }, data, fail);
  },
  addToCart: function addToCart(_ref77) {
    var commit = _ref77.commit,
        state = _ref77.state;

    var _ref78 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref78.data,
        success = _ref78.success,
        fail = _ref78.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].addToCart(function (res) {
      success && success(res);
      commit('setCart', {
        cart: res.body.data
      });
      commit('calculateGrandTotal');
    }, data, fail);
  },
  checkout: function checkout(_ref79) {
    var commit = _ref79.commit,
        state = _ref79.state;

    var _ref80 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref80.data,
        success = _ref80.success,
        fail = _ref80.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].checkout(function (res) {
      success && success(res);
      commit('resetCartAndSetThankYouPageData', {
        thankYou: res.body.data
      });
    }, data, fail);
  },
  updateCart: function updateCart(_ref81) {
    var commit = _ref81.commit,
        state = _ref81.state;

    var _ref82 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref82.data,
        success = _ref82.success,
        fail = _ref82.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].updateCart(function (res) {
      success && success(res);
      commit('setCart', {
        cart: res.body.data
      });
      commit('calculateGrandTotal');
    }, data, fail);
  },
  removeCart: function removeCart(_ref83) {
    var commit = _ref83.commit,
        dispatch = _ref83.dispatch;

    var _ref84 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref84.data,
        success = _ref84.success,
        fail = _ref84.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].removeCart(function (res) {
      success && success(res);
    }, data, function (response) {
      fail && fail(response);
    });
  },
  updateCartQuantity: function updateCartQuantity(_ref85, data) {
    var commit = _ref85.commit,
        state = _ref85.state;

    commit('updateCartQuantity', {
      index: data.index,
      quantity: data.quantity
    });
    // always need to calculate again
    commit('calculateGrandTotal');
  },
  removeFromCart: function removeFromCart(_ref86, data) {
    var commit = _ref86.commit,
        state = _ref86.state;

    commit('removeFromCart', {
      index: data.index
    });
    // always need to calculate again
    commit('calculateGrandTotal');
  },
  setDeliveryMethod: function setDeliveryMethod(_ref87, data) {
    var commit = _ref87.commit,
        state = _ref87.state;

    commit('setDeliveryMethod', {
      methodCode: data.methodCode
    });
  },
  setEditingAddress: function setEditingAddress(_ref88, data) {
    var commit = _ref88.commit,
        state = _ref88.state;

    commit('setEditingAddress', {
      address: data.address
    });
  },
  setChoosingBank: function setChoosingBank(_ref89, data) {
    var commit = _ref89.commit,
        state = _ref89.state;

    commit('setChoosingBank', {
      choosingBank: data.choosingBank
    });
  },
  setOutletId: function setOutletId(_ref90, data) {
    var commit = _ref90.commit,
        state = _ref90.state;

    commit('setOutletId', {
      outletId: data.outletId,
      outletName: data.outletName
    });
  },
  setAddressDestination: function setAddressDestination(_ref91, data) {
    var commit = _ref91.commit,
        state = _ref91.state;

    commit('setAddressDestination', {
      address: data.address
    });
  },
  chooseBank: function chooseBank(_ref92, data) {
    var commit = _ref92.commit,
        state = _ref92.state;

    commit('chooseBank', {
      bankId: data.bankId,
      bankName: data.bankName,
      paymentMethod: data.paymentMethod
    });
    commit('setPaymentType', {
      paymentType: data.paymentType
    });
    commit('setChoosingBank', {
      choosingBank: false
    });
  },
  setPaymentType: function setPaymentType(_ref93, data) {
    var commit = _ref93.commit,
        state = _ref93.state;

    commit('setPaymentType', {
      paymentType: data.paymentType
    });
  },
  setNearestOutlet: function setNearestOutlet(_ref94, data) {
    var commit = _ref94.commit,
        state = _ref94.state;

    commit('setNearestOutlet', {
      nearestOutlet: data.nearestOutlet
    });
  },
  addNewAddress: function addNewAddress(_ref95, data) {
    var commit = _ref95.commit,
        state = _ref95.state;

    commit('addNewAddress', {
      address: data.address
    });
  },
  getProductDetailByProductId: function getProductDetailByProductId(_ref96, data) {
    var commit = _ref96.commit,
        state = _ref96.state;

    commit('getProductDetailByProductId', {
      id: data.id
    });
  },
  getProductListByCategoryName: function getProductListByCategoryName(_ref97, data) {
    var commit = _ref97.commit,
        state = _ref97.state;

    commit('getProductListByCategoryName', {
      categoryName: data.categoryName
    });
  },
  getProvinceList: function getProvinceList(_ref98) {
    var commit = _ref98.commit;

    var _ref99 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref99.data,
        success = _ref99.success,
        fail = _ref99.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].getProvinceList(function (res) {
      success && success(res);
    }, data, fail);
  },
  getCityList: function getCityList(_ref100) {
    var commit = _ref100.commit;

    var _ref101 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref101.data,
        success = _ref101.success,
        fail = _ref101.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].getCityList(function (res) {
      success && success(res);
    }, data, fail);
  },
  getDistrictList: function getDistrictList(_ref102) {
    var commit = _ref102.commit;

    var _ref103 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref103.data,
        success = _ref103.success,
        fail = _ref103.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].getDistrictList(function (res) {
      success && success(res);
    }, data, fail);
  },
  getSubDistrictList: function getSubDistrictList(_ref104) {
    var commit = _ref104.commit;

    var _ref105 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref105.data,
        success = _ref105.success,
        fail = _ref105.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].getSubDistrictList(function (res) {
      success && success(res);
    }, data, fail);
  },
  getPostalCodeList: function getPostalCodeList(_ref106) {
    var commit = _ref106.commit;

    var _ref107 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref107.data,
        success = _ref107.success,
        fail = _ref107.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].getPostalCodeList(function (res) {
      success && success(res);
    }, data, fail);
  },
  getAllOutlet: function getAllOutlet(_ref108) {
    var commit = _ref108.commit;

    var _ref109 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref109.data,
        success = _ref109.success,
        fail = _ref109.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].getAllOutlet(function (res) {
      commit('setOutletList', {
        paging: res.body.paging
      });
      success && success(res);
    }, data, fail);
  },
  getProductList: function getProductList(_ref110) {
    var commit = _ref110.commit;

    var _ref111 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref111.data,
        success = _ref111.success,
        fail = _ref111.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].getProductList(function (res) {
      success && success(res);
    }, data, fail);
  },
  getProjectList: function getProjectList(_ref112) {
    var commit = _ref112.commit;

    var _ref113 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref113.data,
        success = _ref113.success,
        fail = _ref113.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].getProjectList(function (res) {
      success && success(res);
    }, data, fail);
  },
  getProductListByName: function getProductListByName(_ref114) {
    var commit = _ref114.commit;

    var _ref115 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref115.data,
        success = _ref115.success,
        fail = _ref115.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].getProductListByName(function (res) {
      success && success(res);
    }, data, fail);
  },
  getProductDetail: function getProductDetail(_ref116) {
    var commit = _ref116.commit;

    var _ref117 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref117.data,
        success = _ref117.success,
        fail = _ref117.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].getProductDetail(function (res) {
      success && success(res);
    }, data, fail);
  },
  getCartById: function getCartById(_ref118) {
    var commit = _ref118.commit;

    var _ref119 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref119.data,
        success = _ref119.success,
        fail = _ref119.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].getCartById(function (res) {
      success && success(res);
      commit('setCart', {
        cart: res.body.data
      });
      commit('calculateGrandTotal');
    }, data, fail);
  },
  getOrderList: function getOrderList(_ref120) {
    var commit = _ref120.commit;

    var _ref121 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref121.data,
        success = _ref121.success,
        fail = _ref121.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].getOrderList(function (res) {
      success && success(res);
      commit('setOrderList', {
        orderList: res.body.data,
        status: data.status,
        paging: res.body.paging
      });
    }, data, fail);
  },
  confirmPayment: function confirmPayment(_ref122) {
    var commit = _ref122.commit;

    var _ref123 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref123.data,
        success = _ref123.success,
        fail = _ref123.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].confirmPayment(function (res) {
      success && success(res);
      commit('setOrderStatus', {
        orderId: data.orderId,
        status: 'C'
      });
    }, data, fail);
  },
  confirmDelivery: function confirmDelivery(_ref124) {
    var commit = _ref124.commit;

    var _ref125 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        data = _ref125.data,
        success = _ref125.success,
        fail = _ref125.fail;

    __WEBPACK_IMPORTED_MODULE_2__api_backend__["a" /* default */].confirmDelivery(function (res) {
      success && success(res);
      commit('setOrderStatus', {
        orderId: data.orderId,
        status: 'D'
      });
    }, data, fail);
  }
};

var getters = {
  phoneNumber: function phoneNumber(state) {
    return state.phoneNumber;
  },
  phoneNumberId: function phoneNumberId(state) {
    return state.phoneNumberId;
  },
  homeTitleTop: function homeTitleTop(state) {
    return state.homeTitleTop;
  },
  homeTitleTopId: function homeTitleTopId(state) {
    return state.homeTitleTopId;
  },
  homeTitleMid: function homeTitleMid(state) {
    return state.homeTitleMid;
  },
  homeTitleMidId: function homeTitleMidId(state) {
    return state.homeTitleMidId;
  },
  homeTitleBot: function homeTitleBot(state) {
    return state.homeTitleBot;
  },
  homeTitleBotId: function homeTitleBotId(state) {
    return state.homeTitleBotId;
  },
  homeDynamicText1: function homeDynamicText1(state) {
    return state.homeDynamicText1;
  },
  homeDynamicText1Id: function homeDynamicText1Id(state) {
    return state.homeDynamicText1Id;
  },
  homeDynamicText2: function homeDynamicText2(state) {
    return state.homeDynamicText2;
  },
  homeDynamicText2Id: function homeDynamicText2Id(state) {
    return state.homeDynamicText2Id;
  },
  homeDynamicText3: function homeDynamicText3(state) {
    return state.homeDynamicText3;
  },
  homeDynamicText3Id: function homeDynamicText3Id(state) {
    return state.homeDynamicText3Id;
  },
  aboutTitleTop: function aboutTitleTop(state) {
    return state.aboutTitleTop;
  },
  aboutTitleTopId: function aboutTitleTopId(state) {
    return state.aboutTitleTopId;
  },
  aboutTitleMid: function aboutTitleMid(state) {
    return state.aboutTitleMid;
  },
  aboutTitleMidId: function aboutTitleMidId(state) {
    return state.aboutTitleMidId;
  },
  aboutTitleBot: function aboutTitleBot(state) {
    return state.aboutTitleBot;
  },
  aboutTitleBotId: function aboutTitleBotId(state) {
    return state.aboutTitleBotId;
  },
  aboutDynamicText1: function aboutDynamicText1(state) {
    return state.aboutDynamicText1;
  },
  aboutDynamicText1Id: function aboutDynamicText1Id(state) {
    return state.aboutDynamicText1Id;
  },
  aboutDynamicText2: function aboutDynamicText2(state) {
    return state.aboutDynamicText2;
  },
  aboutDynamicText2Id: function aboutDynamicText2Id(state) {
    return state.aboutDynamicText2Id;
  },
  aboutWhyUsTitle1: function aboutWhyUsTitle1(state) {
    return state.aboutWhyUsTitle1;
  },
  aboutWhyUsTitle1Id: function aboutWhyUsTitle1Id(state) {
    return state.aboutWhyUsTitle1Id;
  },
  aboutWhyUsDescription1: function aboutWhyUsDescription1(state) {
    return state.aboutWhyUsDescription1;
  },
  aboutWhyUsDescription1Id: function aboutWhyUsDescription1Id(state) {
    return state.aboutWhyUsDescription1Id;
  },
  aboutWhyUsTitle2: function aboutWhyUsTitle2(state) {
    return state.aboutWhyUsTitle2;
  },
  aboutWhyUsTitle2Id: function aboutWhyUsTitle2Id(state) {
    return state.aboutWhyUsTitle2Id;
  },
  aboutWhyUsDescription2: function aboutWhyUsDescription2(state) {
    return state.aboutWhyUsDescription2;
  },
  aboutWhyUsDescription2Id: function aboutWhyUsDescription2Id(state) {
    return state.aboutWhyUsDescription2Id;
  },
  aboutWhyUsTitle3: function aboutWhyUsTitle3(state) {
    return state.aboutWhyUsTitle3;
  },
  aboutWhyUsTitle3Id: function aboutWhyUsTitle3Id(state) {
    return state.aboutWhyUsTitle3Id;
  },
  aboutWhyUsDescription3: function aboutWhyUsDescription3(state) {
    return state.aboutWhyUsDescription3;
  },
  aboutWhyUsDescription3Id: function aboutWhyUsDescription3Id(state) {
    return state.aboutWhyUsDescription3Id;
  },
  aboutWhyUsTitle4: function aboutWhyUsTitle4(state) {
    return state.aboutWhyUsTitle4;
  },
  aboutWhyUsTitle4Id: function aboutWhyUsTitle4Id(state) {
    return state.aboutWhyUsTitle4Id;
  },
  aboutWhyUsDescription4: function aboutWhyUsDescription4(state) {
    return state.aboutWhyUsDescription4;
  },
  aboutWhyUsDescription4Id: function aboutWhyUsDescription4Id(state) {
    return state.aboutWhyUsDescription4Id;
  },
  visionMissionTitle1: function visionMissionTitle1(state) {
    return state.visionMissionTitle1;
  },
  visionMissionTitle1Id: function visionMissionTitle1Id(state) {
    return state.visionMissionTitle1Id;
  },
  visionMissionDescription1: function visionMissionDescription1(state) {
    return state.visionMissionDescription1;
  },
  visionMissionDescription1Id: function visionMissionDescription1Id(state) {
    return state.visionMissionDescription1Id;
  },
  visionMissionTitle2: function visionMissionTitle2(state) {
    return state.visionMissionTitle2;
  },
  visionMissionTitle2Id: function visionMissionTitle2Id(state) {
    return state.visionMissionTitle2Id;
  },
  visionMissionDescription2: function visionMissionDescription2(state) {
    return state.visionMissionDescription2;
  },
  visionMissionDescription2Id: function visionMissionDescription2Id(state) {
    return state.visionMissionDescription2Id;
  },
  visionMissionTitle3: function visionMissionTitle3(state) {
    return state.visionMissionTitle3;
  },
  visionMissionTitle3Id: function visionMissionTitle3Id(state) {
    return state.visionMissionTitle3Id;
  },
  visionMissionDescription3: function visionMissionDescription3(state) {
    return state.visionMissionDescription3;
  },
  visionMissionDescription3Id: function visionMissionDescription3Id(state) {
    return state.visionMissionDescription3Id;
  },
  visionMissionTitle4: function visionMissionTitle4(state) {
    return state.visionMissionTitle4;
  },
  visionMissionTitle4Id: function visionMissionTitle4Id(state) {
    return state.visionMissionTitle4Id;
  },
  visionMissionDescription4: function visionMissionDescription4(state) {
    return state.visionMissionDescription4;
  },
  visionMissionDescription4Id: function visionMissionDescription4Id(state) {
    return state.visionMissionDescription4Id;
  },
  visionMissionTitle5: function visionMissionTitle5(state) {
    return state.visionMissionTitle5;
  },
  visionMissionTitle5Id: function visionMissionTitle5Id(state) {
    return state.visionMissionTitle5Id;
  },
  visionMissionDescription5: function visionMissionDescription5(state) {
    return state.visionMissionDescription5;
  },
  visionMissionDescription5Id: function visionMissionDescription5Id(state) {
    return state.visionMissionDescription5Id;
  },
  visionMissionTitle6: function visionMissionTitle6(state) {
    return state.visionMissionTitle6;
  },
  visionMissionTitle6Id: function visionMissionTitle6Id(state) {
    return state.visionMissionTitle6Id;
  },
  visionMissionDescription6: function visionMissionDescription6(state) {
    return state.visionMissionDescription6;
  },
  visionMissionDescription6Id: function visionMissionDescription6Id(state) {
    return state.visionMissionDescription6Id;
  },
  visionMissionTitle7: function visionMissionTitle7(state) {
    return state.visionMissionTitle7;
  },
  visionMissionTitle7Id: function visionMissionTitle7Id(state) {
    return state.visionMissionTitle7Id;
  },
  visionMissionDescription7: function visionMissionDescription7(state) {
    return state.visionMissionDescription7;
  },
  visionMissionDescription7Id: function visionMissionDescription7Id(state) {
    return state.visionMissionDescription7Id;
  },
  visionMissionTitle8: function visionMissionTitle8(state) {
    return state.visionMissionTitle8;
  },
  visionMissionTitle8Id: function visionMissionTitle8Id(state) {
    return state.visionMissionTitle8Id;
  },
  visionMissionDescription8: function visionMissionDescription8(state) {
    return state.visionMissionDescription8;
  },
  visionMissionDescription8Id: function visionMissionDescription8Id(state) {
    return state.visionMissionDescription8Id;
  },
  serviceTitleTop: function serviceTitleTop(state) {
    return state.serviceTitleTop;
  },
  serviceTitleTopId: function serviceTitleTopId(state) {
    return state.serviceTitleTopId;
  },
  serviceTitleMid: function serviceTitleMid(state) {
    return state.serviceTitleMid;
  },
  serviceTitleMidId: function serviceTitleMidId(state) {
    return state.serviceTitleMidId;
  },
  serviceTitleBot: function serviceTitleBot(state) {
    return state.serviceTitleBot;
  },
  serviceTitleBotId: function serviceTitleBotId(state) {
    return state.serviceTitleBotId;
  },
  serviceDynamicText1: function serviceDynamicText1(state) {
    return state.serviceDynamicText1;
  },
  serviceDynamicText1Id: function serviceDynamicText1Id(state) {
    return state.serviceDynamicText1Id;
  },
  serviceDynamicText2: function serviceDynamicText2(state) {
    return state.serviceDynamicText2;
  },
  serviceDynamicText2Id: function serviceDynamicText2Id(state) {
    return state.serviceDynamicText2Id;
  },
  serviceDynamicText3: function serviceDynamicText3(state) {
    return state.serviceDynamicText3;
  },
  serviceDynamicText3Id: function serviceDynamicText3Id(state) {
    return state.serviceDynamicText3Id;
  },
  serviceDynamicText4: function serviceDynamicText4(state) {
    return state.serviceDynamicText4;
  },
  serviceDynamicText4Id: function serviceDynamicText4Id(state) {
    return state.serviceDynamicText4Id;
  },
  serviceDynamicText5: function serviceDynamicText5(state) {
    return state.serviceDynamicText5;
  },
  serviceDynamicText5Id: function serviceDynamicText5Id(state) {
    return state.serviceDynamicText5Id;
  },
  serviceDynamicText6: function serviceDynamicText6(state) {
    return state.serviceDynamicText6;
  },
  serviceDynamicText6Id: function serviceDynamicText6Id(state) {
    return state.serviceDynamicText6Id;
  },
  serviceDynamicText7: function serviceDynamicText7(state) {
    return state.serviceDynamicText7;
  },
  serviceDynamicText7Id: function serviceDynamicText7Id(state) {
    return state.serviceDynamicText7Id;
  },
  serviceDynamicText8: function serviceDynamicText8(state) {
    return state.serviceDynamicText8;
  },
  serviceDynamicText8Id: function serviceDynamicText8Id(state) {
    return state.serviceDynamicText8Id;
  },
  serviceDynamicText9: function serviceDynamicText9(state) {
    return state.serviceDynamicText9;
  },
  serviceDynamicText9Id: function serviceDynamicText9Id(state) {
    return state.serviceDynamicText9Id;
  },
  serviceDynamicText10: function serviceDynamicText10(state) {
    return state.serviceDynamicText10;
  },
  serviceDynamicText10Id: function serviceDynamicText10Id(state) {
    return state.serviceDynamicText10Id;
  },
  serviceDynamicText11: function serviceDynamicText11(state) {
    return state.serviceDynamicText11;
  },
  serviceDynamicText11Id: function serviceDynamicText11Id(state) {
    return state.serviceDynamicText11Id;
  },
  serviceDynamicText12: function serviceDynamicText12(state) {
    return state.serviceDynamicText12;
  },
  serviceDynamicText12Id: function serviceDynamicText12Id(state) {
    return state.serviceDynamicText12Id;
  },
  serviceDynamicText13: function serviceDynamicText13(state) {
    return state.serviceDynamicText13;
  },
  serviceDynamicText13Id: function serviceDynamicText13Id(state) {
    return state.serviceDynamicText13Id;
  },
  projectTitleTop: function projectTitleTop(state) {
    return state.projectTitleTop;
  },
  projectTitleTopId: function projectTitleTopId(state) {
    return state.projectTitleTopId;
  },
  projectTitleMid: function projectTitleMid(state) {
    return state.projectTitleMid;
  },
  projectTitleMidId: function projectTitleMidId(state) {
    return state.projectTitleMidId;
  },
  projectTitleBot: function projectTitleBot(state) {
    return state.projectTitleBot;
  },
  projectTitleBotId: function projectTitleBotId(state) {
    return state.projectTitleBotId;
  },
  productTitleTop: function productTitleTop(state) {
    return state.productTitleTop;
  },
  productTitleTopId: function productTitleTopId(state) {
    return state.productTitleTopId;
  },
  productTitleMid: function productTitleMid(state) {
    return state.productTitleMid;
  },
  productTitleMidId: function productTitleMidId(state) {
    return state.productTitleMidId;
  },
  productTitleBot: function productTitleBot(state) {
    return state.productTitleBot;
  },
  productTitleBotId: function productTitleBotId(state) {
    return state.productTitleBotId;
  },
  contactTitleMid: function contactTitleMid(state) {
    return state.contactTitleMid;
  },
  contactTitleMidId: function contactTitleMidId(state) {
    return state.contactTitleMidId;
  },
  contactTitleBot: function contactTitleBot(state) {
    return state.contactTitleBot;
  },
  contactTitleBotId: function contactTitleBotId(state) {
    return state.contactTitleBotId;
  },
  contactDynamicText1: function contactDynamicText1(state) {
    return state.contactDynamicText1;
  },
  contactDynamicText1Id: function contactDynamicText1Id(state) {
    return state.contactDynamicText1Id;
  },
  contactDynamicText2: function contactDynamicText2(state) {
    return state.contactDynamicText2;
  },
  contactDynamicText2Id: function contactDynamicText2Id(state) {
    return state.contactDynamicText2Id;
  },
  contactDynamicText3: function contactDynamicText3(state) {
    return state.contactDynamicText3;
  },
  contactDynamicText3Id: function contactDynamicText3Id(state) {
    return state.contactDynamicText3Id;
  },
  contactDynamicText4: function contactDynamicText4(state) {
    return state.contactDynamicText4;
  },
  contactDynamicText4Id: function contactDynamicText4Id(state) {
    return state.contactDynamicText4Id;
  },
  aboutUsFooter: function aboutUsFooter(state) {
    return state.aboutUsFooter;
  },
  aboutUsFooterId: function aboutUsFooterId(state) {
    return state.aboutUsFooterId;
  },
  subscribeFooter: function subscribeFooter(state) {
    return state.subscribeFooter;
  },
  subscribeFooterId: function subscribeFooterId(state) {
    return state.subscribeFooterId;
  },
  socialMediaFooter: function socialMediaFooter(state) {
    return state.socialMediaFooter;
  },
  socialMediaFooterId: function socialMediaFooterId(state) {
    return state.socialMediaFooterId;
  },
  totalSubscribers: function totalSubscribers(state) {
    return state.totalSubscribers;
  },
  totalInquiries: function totalInquiries(state) {
    return state.totalInquiries;
  },
  inquiries: function inquiries(state) {
    return state.inquiries;
  },
  editingProduct: function editingProduct(state) {
    return state.editingProduct;
  },
  editingProject: function editingProject(state) {
    return state.editingProject;
  },
  clients: function clients(state) {
    return state.clients;
  },
  products: function products(state) {
    return state.products;
  },
  projects: function projects(state) {
    return state.projects;
  },
  subscribers: function subscribers(state) {
    return state.subscribers;
  },
  profile: function profile(state) {
    return state.profile;
  },
  isLoggedIn: function isLoggedIn(state) {
    return state.isLoggedIn;
  },
  user: function user(state) {
    return state.user;
  },
  memberId: function memberId(state) {
    return state.memberId;
  },
  countTotalItemInCart: function countTotalItemInCart(state) {
    return state.countTotalItemInCart;
  },
  deliveryMethod: function deliveryMethod(state) {
    return state.deliveryMethod;
  },
  cart: function cart(state) {
    return state.cart;
  },
  nearestOutlet: function nearestOutlet(state) {
    return state.nearestOutlet;
  },
  choosenOutlet: function choosenOutlet(state) {
    return state.choosenOutlet;
  },
  shippingDestination: function shippingDestination(state) {
    return state.shippingDestination;
  },
  thankYou: function thankYou(state) {
    return state.thankYou;
  },
  ongoingOrderList: function ongoingOrderList(state) {
    return state.orderList.ongoing;
  },
  finishedOrderList: function finishedOrderList(state) {
    return state.orderList.finished;
  },
  cancelledOrderList: function cancelledOrderList(state) {
    return state.orderList.cancelled;
  },
  pagingOrderOngoing: function pagingOrderOngoing(state) {
    return state.pagingOrderOngoing;
  },
  pagingOrderDone: function pagingOrderDone(state) {
    return state.pagingOrderDone;
  },
  pagingOrderCancelled: function pagingOrderCancelled(state) {
    return state.pagingOrderCancelled;
  },
  pagingOutlets: function pagingOutlets(state) {
    return state.pagingOutlets;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}));

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_index_js__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_index_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__config_index_js__);





__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use && __WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.options.crossOrigin = true;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.options.emulateJSON = true;

function getDataViaApi(path, cb, errorHandler, httpStatusHandler) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.getApiPath(path), {
    headers: {
      'requestId': '2',
      'principal': 'a'
    }
  }, { headers: { 'requestId': '1' } }).then(function (res) {
    cb(res);
  }, function (error) {
    if (httpStatusHandler) {
      console.log('httpStatusHandler ' + error);
    } else {
      console.log('not statushandler');
      errorHandler();
      // defaultHandlerConnectionError(error)
    }
    if (typeof errorHandler === 'function') {
      console.log('errorhandler');
      // errorHandler(error)
    }
  });
}

function putCredDataViaApi(path, data, token, cb, errorHandler, httpStatusHandler) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.put(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.getApiPath(path), data, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': 'Bearer ' + token
    }
  }).then(function (res) {
    cb(res);
  }, function (error) {
    if (httpStatusHandler) {
      console.log('httpStatusHandler' + error);
    } else {
      console.log('not statushandler');
      errorHandler();
    }
    if (typeof errorHandler === 'function') {
      console.log('errorhandler is function');
    }
  });
}

function getPublicData(path, cb, errorHandler, httpStatusHandler) {
  // const a = 'http://62.72.58.202:1337/api/mkuvalidityusermkus?filters[Username][$eq]=adminventory&filters[Hint][$eq]=adm101'
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.getApiPath(path), {
    // Vue.http.get(a, {
    headers: {
      // 'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MywiaWF0IjoxNzEyNjUzMTcwLCJleHAiOjE3MTUyNDUxNzB9.kBHcGuKpaNuc-kzhz8Nkw0pmbPBK1d0y-dwXlNffd6I'
    }
  }, { headers: { 'requestId': '1' } }).then(function (res) {
    cb(res);
  }, function (error) {
    if (httpStatusHandler) {
      console.log('httpStatusHandler ' + error);
    } else {
      console.log('not statushandler');
      errorHandler();
      // defaultHandlerConnectionError(error)
    }
    if (typeof errorHandler === 'function') {
      console.log('errorhandler');
      // errorHandler(error)
    }
  });
}

function authApi(username, password, cb, errorHandler, httpStatusHandler) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.getApiPath(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.member.signIn), {
    headers: {
      'requestId': username,
      'principal': username,
      'username': username,
      'password': password
    }
  }).then(function (res) {
    cb(res);
  }, function (error) {
    if (httpStatusHandler) {
      console.log('httpStatusHandler ' + error);
      // httpStatusHandler(error)
    } else {
      console.log('not statushandler');
      errorHandler();
      // defaultHandlerConnectionError(error)
    }
    if (typeof errorHandler === 'function') {
      console.log('errorhandler');
      // errorHandler(error)
    }
  });
}

function postDataViaApi(path, data, cb, errorHandler, httpStatusHandler) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.getApiPath(path), data, { headers: { 'Content-Type': 'application/json' } }).then(function (res) {
    cb(res);
  }, function (error) {
    if (httpStatusHandler) {
      console.log('httpStatusHandler ' + error);
      // httpStatusHandler(error)
    } else {
      console.log('not statushandler');
      errorHandler();
      // defaultHandlerConnectionError(error)
    }
    if (typeof errorHandler === 'function') {
      console.log('errorhandler');
      // errorHandler(error)
    }
  });
}

function postCredDataViaApi(path, data, token, cb, errorHandler, httpStatusHandler) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.getApiPath(path), data, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    }
  }).then(function (res) {
    cb(res);
  }, function (error) {
    if (httpStatusHandler) {
      console.log('httpStatusHandler ' + error);
    } else {
      errorHandler();
    }
    if (typeof errorHandler === 'function') {
      console.log('errorhandler');
    }
  });
}

function deleteCredDataViaApi(path, token, cb, errorHandler, httpStatusHandler) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.delete(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.getApiPath(path), {
    headers: {
      'Authorization': 'Bearer ' + token
    }
  }, { headers: { 'Authorization': 'no auth' } }).then(function (res) {
    cb(res);
  }, function (error) {
    if (httpStatusHandler) {
      console.log('httpStatusHandler ' + error);
    } else {
      console.log('not statushandler');
      errorHandler();
    }
    if (typeof errorHandler === 'function') {
      console.log('errorhandler');
    }
  });
}

function postMessage(path, data, cb, errorHandler, httpStatusHandler) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.postMessage(path), data, { headers: { 'Content-Type': 'application/json' } }).then(function (res) {
    cb(res);
  }, function (error) {
    if (httpStatusHandler) {
      console.log('httpStatusHandler ' + error);
      // httpStatusHandler(error)
    } else {
      console.log('not statushandler');
      errorHandler();
      // defaultHandlerConnectionError(error)
    }
    if (typeof errorHandler === 'function') {
      console.log('errorhandler');
      // errorHandler(error)
    }
  });
}

function postLoginDataViaApi(path, data, cb, errorHandler, httpStatusHandler) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.getApiPath(path), data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (res) {
    cb(res);
  }, function (error) {
    if (httpStatusHandler) {
      console.log('httpStatusHandler ' + error);
      // httpStatusHandler(error)
    } else {
      console.log('not statushandler');
      errorHandler();
      // defaultHandlerConnectionError(error)
    }
    if (typeof errorHandler === 'function') {
      console.log('errorhandler');
      // errorHandler(error)
    }
  });
}

// function postDataWithImageViaApi (path, data, cb, errorHandler, httpStatusHandler) {
//   console.log('postDataViaApi')
//   Vue.http.post(config.getApiPath(path), data, {headers: { 'Content-Type': undefined }}).then((res) => {
//     cb(res)
//   }, (error) => {
//     if (httpStatusHandler) {
//       console.log('httpStatusHandler ' + error)
//       // httpStatusHandler(error)
//     } else {
//       console.log('not statushandler')
//       errorHandler()
//       // defaultHandlerConnectionError(error)
//     }
//     if (typeof errorHandler === 'function') {
//       console.log('errorhandler')
//       // errorHandler(error)
//     }
//   })
// }

function putDataViaApi(path, data, cb, errorHandler, httpStatusHandler) {
  console.log('putDataViaApi');
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.put(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.getApiPath(path), data, { headers: { 'Content-Type': 'application/json' } }).then(function (res) {
    cb(res);
  }, function (error) {
    if (httpStatusHandler) {
      console.log('httpStatusHandler' + error);
    } else {
      console.log('not statushandler');
      errorHandler();
      // defaultHandlerConnectionError(error)
    }
    if (typeof errorHandler === 'function') {
      console.log('errorhandler is function');
      // errorHandler(error)
    }
  });
}

function deleteDataViaApi(path, cb, errorHandler, httpStatusHandler) {
  console.log('deleteDataViaApiPost');
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.delete(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.getApiPath(path), { headers: { 'Content-Type': 'application/json' } }).then(function (res) {
    cb(res);
  }, function (error) {
    if (httpStatusHandler) {
      console.log('httpStatusHandler ' + error);
      // httpStatusHandler(error)
    } else {
      console.log('not statushandler');
      // errorHandler()
      defaultHandlerConnectionError(error);
    }
    if (typeof errorHandler === 'function') {
      console.log('errorhandler is function');
      // errorHandler(error)
    }
  });
}

function defaultHandlerConnectionError(error) {
  console.log('errorStatus: ' + error.status);
  switch (error.status) {
    case 400:
      console.log('handle400error');
      break;
    case 500:
      console.log('handle500error');
      break;
    default:
      console.log('handleDefaultError');
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  sendMessage: function sendMessage(cb, data, errHandler) {
    var message = 'Ada pesan baru dari ' + data.message.name + '.\nEmail: ' + data.message.email + '.\nNomor: ' + data.message.phoneNumber + '.\nMohon hubungi kontak diatas, terima kasih.';
    var formData = new FormData();
    formData.append('chat_id', '-1002009060463');
    formData.append('text', message);
    // formData.append('data', new Blob([JSON.stringify(data.client)], {type: 'application/json'}))
    // formData.append('image', data.image)
    postMessage(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.tel.send, formData, cb, errHandler);
  },
  editProject: function editProject(cb, data, errHandler) {
    // var formData = new FormData()
    // formData.append('data', new Blob([JSON.stringify(data.project)], {type: 'application/json'}))
    // if (data.project.images != null) {
    //   formData.append('addImages', data.project.images)
    // }
    var req = { data: data.project };
    putCredDataViaApi(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.project.update + data.id, req, data.token, cb, errHandler);
  },
  editProduct: function editProduct(cb, data, errHandler) {
    // var formData = new FormData()
    // formData.append('data', new Blob([JSON.stringify(data.product)], {type: 'application/json'}))
    // if (data.product.images != null) {
    //   formData.append('addImages', data.product.images)
    // }
    var req = { data: data.product };
    putCredDataViaApi(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.product.update + data.id, req, data.token, cb, errHandler);
  },
  editContentById: function editContentById(cb, data, errHandler) {
    var req = { data: data.content };
    putCredDataViaApi(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.content.update + data.id, req, data.token, cb, errHandler);
  },
  deleteProject: function deleteProject(cb, data, errHandler) {
    deleteCredDataViaApi(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.project.delete + data.id, data.token, cb, errHandler);
  },
  deleteProduct: function deleteProduct(cb, data, errHandler) {
    deleteCredDataViaApi(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.product.delete + data.id, data.token, cb, errHandler);
  },
  deleteClient: function deleteClient(cb, data, errHandler) {
    deleteCredDataViaApi(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.client.delete + data.id, data.token, cb, errHandler);
  },
  uploadFile: function uploadFile(cb, data, errHandler) {
    var formData = new FormData();
    formData.append('refId', data.file.refId);
    formData.append('ref', data.file.ref);
    formData.append('field', data.file.field);
    formData.append('files', data.file.files);
    postCredDataViaApi(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.upload, formData, data.token, cb, errHandler);
  },
  deleteFile: function deleteFile(cb, data, errHandler) {
    deleteCredDataViaApi(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.upload + '/files/' + data.id, data.token, cb, errHandler);
  },
  createProject: function createProject(cb, data, errHandler) {
    // var formData = new FormData()
    // formData.append('data', new Blob([JSON.stringify(data.project)], {type: 'application/json'}))
    // formData.append('images', data.image)
    var req = { data: data.project };
    postCredDataViaApi(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.project.create, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(req), data.token, cb, errHandler);
  },
  createProduct: function createProduct(cb, data, errHandler) {
    // var formData = new FormData()
    // formData.append('data', new Blob([JSON.stringify(data.product)], {type: 'application/json'}))
    // formData.append('images', data.image)
    var req = { data: data.product };
    postCredDataViaApi(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.product.create, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(req), data.token, cb, errHandler);
  },
  createClient: function createClient(cb, data, errHandler) {
    // var formData = new FormData()
    // formData.append('data', new Blob([JSON.stringify(data.client)], {type: 'application/json'}))
    // formData.append('image', data.image)
    var req = { data: data.client };
    postCredDataViaApi(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.client.create, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(req), data.token, cb, errHandler);
  },
  getProductList: function getProductList(cb, data, errHandler) {
    getPublicData(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.product.find + '?pagination[page]=1&pagination[pageSize]=100000&populate=*', cb, errHandler);
  },
  getProjectList: function getProjectList(cb, data, errHandler) {
    getPublicData(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.project.find + '?pagination[page]=1&pagination[pageSize]=100000&populate=*', cb, errHandler);
  },
  findAllClients: function findAllClients(cb, data, errHandler) {
    getPublicData(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.client.find + '?pagination[page]=1&pagination[pageSize]=100000&populate=*', cb, errHandler);
  },
  findContentById: function findContentById(cb, data, errHandler) {
    // by key
    getPublicData(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.content.find + '?filters[key][$eq]=' + data.id, cb, errHandler);
  },
  findAllContents: function findAllContents(cb, data, errHandler) {
    getPublicData(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.content.find + '?pagination[page]=1&pagination[pageSize]=100000', cb, errHandler);
  },
  findProjectById: function findProjectById(cb, data, errHandler) {
    getPublicData(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.project.find + '?populate=*&filters[id][$eq]=' + data.id, cb, errHandler);
  },
  findProductById: function findProductById(cb, data, errHandler) {
    getPublicData(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.product.find + '?populate=*&filters[id][$eq]=' + data.id, cb, errHandler);
  },
  findClientById: function findClientById(cb, data, errHandler) {
    getDataViaApi(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.client.findById + data.id, cb, errHandler);
  },
  editClient: function editClient(cb, data, errHandler) {
    var formData = new FormData();
    formData.append('data', new Blob([__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data.client)], { type: 'application/json' }));
    if (data.client.images != null) {
      formData.append('addImages', data.client.images);
    }
    postDataViaApi(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.client.update + data.client.id, formData, cb, errHandler);
  },
  findAllProjects: function findAllProjects(cb, data, errHandler) {
    if (data.page === undefined || data.page === null) {
      data.page = 0;
      data.size = 20;
    } else {
      data.size = 20;
    }
    var params = [];
    params.push('page=' + data.page);
    params.push('size=' + data.size);
    getDataViaApi(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.project.find + '?' + params.join('&'), cb, errHandler);
  },
  findAllProducts: function findAllProducts(cb, data, errHandler) {
    if (data.page === undefined || data.page === null) {
      data.page = 0;
      data.size = 20;
    } else if (data.size === undefined || data.size === null) {
      data.size = 20;
    }
    var params = [];
    params.push('page=' + data.page);
    params.push('size=' + data.size);
    getDataViaApi(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.product.find + '?' + params.join('&'), cb, errHandler);
  },
  addClient: function addClient(cb, data, errHandler) {
    var formData = new FormData();
    formData.append('data', new Blob([__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data.product)], { type: 'application/json' }));
    formData.append('image', data.image);
    postDataViaApi(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.product.create, formData, cb, errHandler);
  },
  login: function login(cb, data, errHandler) {
    var formData = new FormData();
    formData.append('identifier', data.username);
    formData.append('password', data.password);
    postLoginDataViaApi(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.auth.login, formData, cb, errHandler);
  },
  createInquiry: function createInquiry(cb, data, errHandler) {
    postDataViaApi(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.inquiry.create, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data.inquiry), cb, errHandler);
  },
  getAllInquiries: function getAllInquiries(cb, data, errHandler) {
    if (data.page === undefined || data.page === null) {
      data.page = 0;
      data.size = 99999;
    } else if (data.size === undefined || data.size === null) {
      data.size = 20;
    }
    var params = [];
    params.push('page=' + data.page);
    params.push('size=' + data.size);
    params.push('sort=id,desc');
    getDataViaApi(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.inquiry.find + '?' + params.join('&'), cb, errHandler);
  },
  subscribe: function subscribe(cb, data, errHandler) {
    postDataViaApi(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.newsletter.subscribe + data.email, cb, errHandler);
  },
  findAllSubscribers: function findAllSubscribers(cb, data, errHandler) {
    if (data.page === undefined || data.page === null) {
      data.page = 0;
      data.size = 20;
    } else if (data.size === undefined || data.size === null) {
      data.size = 20;
    }
    var params = [];
    params.push('page=' + data.page);
    params.push('size=' + data.size);
    getDataViaApi(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.newsletter.find + '?' + params.join('&'), cb, errHandler);
  },
  unsubscribe: function unsubscribe(cb, data, errHandler) {
    postDataViaApi(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.newsletter.unsubscribe + data.email, cb, errHandler);
  },
  changePassword: function changePassword(cb, data, errHandler) {
    console.log('changPassword for username ' + data.member.username);
    postDataViaApi(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.member.changePassword, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data.member), cb, errHandler);
  },
  signUp: function signUp(cb, data, errHandler) {
    console.log('signUp: ' + data.member.username);
    postDataViaApi(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.member.signUp, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data.member), cb, errHandler);
  },
  signIn: function signIn(cb, data, errHandler) {
    console.log('signIn: ' + data.member.username);
    authApi(data.member.username, data.member.password, cb, errHandler);
  },
  getProfile: function getProfile(cb, data, errHandler) {
    console.log('getProfile with username: ' + data.username);
    getDataViaApi(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.member.profile + data.username, cb, errHandler);
  },
  addAddress: function addAddress(cb, data, errHandler) {
    console.log('addAddress with memberId: ' + data.memberId);
    postDataViaApi(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.member.addAddress + data.memberId + '/shipping-address', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data.address), cb, errHandler);
  },
  removeAddress: function removeAddress(cb, data, errHandler) {
    console.log('removeAddress with memberId: ' + data.memberId + ' and shippingId: ' + data.shippingId);
    deleteDataViaApi(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.member.removeAddress + data.memberId + '/shipping-address/' + data.shippingId, cb, errHandler);
  },
  removeCart: function removeCart(cb, data, errHandler) {
    console.log('removeCart with cartId: ' + data.cartId);
    deleteDataViaApi(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.cart.remove + data.cartId + '/items/' + data.skuCode, cb, errHandler);
  },
  confirmPayment: function confirmPayment(cb, data, errHandler) {
    console.log('confirmPayment with orderId: ' + data.orderId);
    putDataViaApi(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.order.confirmPayment + data.orderId, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data.orderId), cb, errHandler);
  },
  confirmDelivery: function confirmDelivery(cb, data, errHandler) {
    console.log('confirmDelivery with orderId: ' + data.orderId);
    putDataViaApi(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.order.confirmDelivery + data.orderId, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data.orderId), cb, errHandler);
  },
  editAddress: function editAddress(cb, data, errHandler) {
    console.log('editAddress with memberId: ' + data.memberId + ' and shippingId: ' + data.address.id);
    putDataViaApi(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.member.editAddress + data.memberId + '/shipping-address/' + data.address.id, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data.address), cb, errHandler);
  },
  getProvinceList: function getProvinceList(cb, data, errHandler) {
    console.log('getProvinceList');
    getDataViaApi(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.region.provinceList, cb, errHandler);
  },
  getCityList: function getCityList(cb, data, errHandler) {
    console.log('getCityList');
    getDataViaApi(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.region.cityList + data.stateId + '/cities/', cb, errHandler);
  },
  getDistrictList: function getDistrictList(cb, data, errHandler) {
    console.log('getDistrictList');
    getDataViaApi(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.region.districtList + data.cityId + '/districts/', cb, errHandler);
  },
  getSubDistrictList: function getSubDistrictList(cb, data, errHandler) {
    console.log('getSubDistrictList');
    getDataViaApi(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.region.subDistrictList + data.districtId + '/sub-districts/', cb, errHandler);
  },
  getPostalCodeList: function getPostalCodeList(cb, data, errHandler) {
    console.log('getPostalCodeList');
    getDataViaApi(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.region.postalCodeList + data.subDistrictId + '/postal-codes/', cb, errHandler);
  },
  getProductListByName: function getProductListByName(cb, data, errHandler) {
    console.log('getProductListByName');
    getDataViaApi(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.product.productListByName + data.categoryName, cb, errHandler);
  },
  getProductDetail: function getProductDetail(cb, data, errHandler) {
    console.log('getProductDetail. data: ' + data.skuCode);
    getDataViaApi(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.product.productDetail + data.skuCode, cb, errHandler);
  },
  getAllOutlet: function getAllOutlet(cb, data, errHandler) {
    console.log('getAllOutlet');
    if (data.page === undefined || data.page === null) {
      data.page = 0;
      data.size = 1000;
    } else {
      data.size = 20;
    }
    var params = [];
    params.push('page=' + data.page);
    params.push('size=' + data.size);
    getDataViaApi(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.outlet.getAllOutlet + '?' + params.join('&'), cb, errHandler);
  },
  addToCart: function addToCart(cb, data, errHandler) {
    console.log('addToCart with id: ' + data.id);
    postDataViaApi(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.cart.addToCart + data.id, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data.item), cb, errHandler);
  },
  updateCart: function updateCart(cb, data, errHandler) {
    console.log('update with id: ' + data.id);
    putDataViaApi(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.cart.updateCart + data.id, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data.item), cb, errHandler);
  },
  checkout: function checkout(cb, data, errHandler) {
    console.log('checkout with id: ' + data.cartId);
    console.log('checkout request outletId: ' + data.checkoutCartRequest.outletId);
    console.log('checkout request paymentMethod: ' + data.checkoutCartRequest.paymentMethod);
    console.log('checkout request shipmentMethod: ' + data.checkoutCartRequest.shipmentMethod);
    console.log('checkout request shippingAddressId: ' + data.checkoutCartRequest.shippingAddressId);
    putDataViaApi(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.cart.updateCart + data.cartId + '/checkout', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data.checkoutCartRequest), cb, errHandler);
  },
  calculateShippingCost: function calculateShippingCost(cb, data, errHandler) {
    console.log('calculateShippingCost. origin: ' + data.origin + '. destination: ' + data.destination + '. weight: ' + data.weight);
    var params = [];
    params.push('origin=' + data.origin);
    params.push('destination=' + data.destination);
    params.push('weight=' + data.weight);

    getDataViaApi(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.shipping.calculateShippingCost + '?' + params.join('&'), cb, errHandler);
  },
  getOrderList: function getOrderList(cb, data, errHandler) {
    console.log('getOrderList. status: ' + data.status + ' uname: ' + data.username);

    var params = [];
    params.push('page=' + data.page);
    params.push('size=' + 20);
    params.push('customer.username=' + data.username);
    if (data.status === 'ongoing') {
      params.push('status=M');
      params.push('status=C');
      params.push('status=FP');
      params.push('status=PU');
    } else if (data.status === 'finished') {
      params.push('status=D');
    } else if (data.status === 'cancelled') {
      params.push('status=X');
    }
    params.push('sort=createdDate,desc');
    getDataViaApi(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.order.getOrderList + '?' + params.join('&'), cb, errHandler);
  },
  getCartById: function getCartById(cb, data, errHandler) {
    console.log('getCartById. data: ' + data.id);
    getDataViaApi(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.cart.getCartById + data.id, cb, errHandler);
  },
  getNearestOutlet: function getNearestOutlet(cb, data, errHandler) {
    console.log('getNearestOutlet');
    var params = [];
    params.push('geoLong=' + data.geoLong);
    params.push('geoLat=' + data.geoLat);
    for (var code in data.cartItems) {
      params.push('productCodes=' + data.cartItems[code].skuCode);
    }
    getDataViaApi(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.outlet.nearest + '?' + params.join('&'), cb, errHandler);
  },
  getListExample: function getListExample(cb) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { page: 1, item_per_page: 10 };
    var errHandler = arguments[2];

    console.log('getProfile in member.js');
    var params = [];
    params.push('page=' + data.page);
    params.push('size=' + data.size);

    getDataViaApi(__WEBPACK_IMPORTED_MODULE_3__config_index_js___default.a.api.member.profile + 'test@gmail.com', cb, errHandler);
    // success
    // getDataViaApi(config.api.member.profile + '?' + params.join('&'), cb, errHandler)
  },

  getDataViaApi: getDataViaApi,
  postDataViaApi: postDataViaApi
});

/***/ }),
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 316 */
/***/ (function(module, exports) {

module.exports = {
  api: {
    // base_path: 'http://localhost:8080',
    // base_path: 'http://194.59.165.82:8080/dsk-backend-service',
    // AFTER SSL base_path: 'http://62.72.58.202:1337/api/',
    base_path: 'https://api.dutasaranakonstruksi.com/api/',
    // base_path: 'http://localhost:1337',
    upload: 'upload',
    tel: {
      send: 'https://api.telegram.org/bot7001829088:AAFk7HX-xWqLdkE-B3Qg-ND3TzKELeDk8tA/sendMessage'
    },
    product: {
      create: 'dsk-products/',
      update: 'dsk-products/',
      delete: 'dsk-products/',
      find: 'dsk-products/',
      findById: 'dsk-products/'
    },
    project: {
      create: 'dsk-projects/',
      update: 'dsk-projects/',
      delete: 'dsk-projects/',
      find: 'dsk-projects/'
    },
    client: {
      create: 'dsk-clients/',
      delete: 'dsk-clients/',
      find: 'dsk-clients/'
    },
    inquiry: {
      create: 'inquiry/create',
      find: 'inquiry/find'
    },
    auth: {
      login: 'auth/local' // 'admin/login'
    },
    newsletter: {
      subscribe: '/newsletter/subscribe/',
      unsubscribe: 'newsletter/unsubscribe/',
      find: 'newsletter/subscribers'
    },
    content: {
      find: 'dsks/',
      update: 'dsks/'
    }
  },
  getApiPath: function getApiPath(apiPath) {
    return this.api.base_path + apiPath;
  },
  postMessage: function postMessage(apiPath) {
    return apiPath;
  }
};

/***/ }),
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 431 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 432 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_infoWindow_vue__ = __webpack_require__(168);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_25e3f758_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__ = __webpack_require__(443);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_infoWindow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_25e3f758_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 442 */,
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"flyaway"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_map_vue__ = __webpack_require__(169);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6839df3e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__ = __webpack_require__(447);
function injectStyle (ssrContext) {
  __webpack_require__(445)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_map_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6839df3e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 445 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 446 */,
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-map-container"},[_c('div',{ref:"vue-map",staticClass:"vue-map"}),_vm._v(" "),_c('div',{staticClass:"vue-map-hidden"},[_vm._t("default")],2),_vm._v(" "),_vm._t("visible")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_streetViewPanorama_vue__ = __webpack_require__(171);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_50f7f8d6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__ = __webpack_require__(451);
function injectStyle (ssrContext) {
  __webpack_require__(449)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_streetViewPanorama_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_50f7f8d6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 449 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 450 */,
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-street-view-pano-container"},[_c('div',{ref:"vue-street-view-pano",staticClass:"vue-street-view-pano"}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__ = __webpack_require__(453);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',{domProps:{"textContent":_vm._s(_vm.label)}}),_vm._v(" "),_c('input',{ref:"input",class:_vm.className,attrs:{"type":"text","placeholder":_vm.placeholder}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_autocomplete_vue__ = __webpack_require__(174);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5e569f3e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__ = __webpack_require__(456);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_autocomplete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5e569f3e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 455 */,
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._g(_vm._b({ref:"input"},'input',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
],[175]);


// WEBPACK FOOTER //
// static/js/app.f5f07bf8ea97b5f64886.js